(()=>{
if(window.MOGA_INVENTORY_LOADED)return;
window.MOGA_INVENTORY_LOADED=true;

const INV_KEY='moga_inventory_v3';
const MOVE_KEY='moga_inventory_movements_v3';
const PRODUCTS_KEY='moga_products_v1';
const TRACKING_KEY='moga_tracking_info_v1';
const RECIPES_KEY='moga_manufacturing_recipes_v1';
const FIFO_KEY='moga_inventory_fifo_v1';

const esc=v=>typeof escapeHtml==='function'?escapeHtml(v??''):String(v??'').replace(/[&<>"']/g,'');
const money=n=>(Number(n)||0).toLocaleString('lt-LT',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';
const num=v=>{const n=Number(String(v??'').replace(',','.'));return Number.isFinite(n)?n:0};
const norm=v=>String(v||'').normalize('NFKC').trim().toLowerCase().replace(/[‐‑‒–—―−]/g,'-').replace(/\s*-\s*/g,'-').replace(/\s+/g,' ');
const now=()=>new Date().toISOString();
const uid=()=>`pid_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,8)}`;
const mid=()=>`mov_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,9)}`;
const premium=()=>!!window.MOGA_PLAN?.isPremium();

function getStore(){
  try{
    const x=JSON.parse(localStorage.getItem(INV_KEY)||'null');
    if(x&&typeof x==='object')return{
      version:1,
      settings:{allowNegative:false,defaultMin:0,lowStockMode:'individual',lowStockQty:3,lowStockPercent:25,lowStockScope:'all',lowStockSelected:[],...(x.settings||{})},
      records:x.records&&typeof x.records==='object'?x.records:{},
      // Gamybos API šitame pačiame inventory state saugo manufacturingEvents.
      // Jų negalima išmesti normalizuojant store, nes tada Sandėlis visada
      // matydavo "Pagaminta: 0", nors Cloud'e gamybos įvykis jau buvo įrašytas.
      manufacturingEvents:Array.isArray(x.manufacturingEvents)?x.manufacturingEvents:[]
    };
  }catch(e){}
  return{version:1,settings:{allowNegative:false,defaultMin:0,lowStockMode:'individual',lowStockQty:3,lowStockPercent:25,lowStockScope:'all',lowStockSelected:[]},records:{}};
}
function isQuotaError(e){return !!e&&(e.name==='QuotaExceededError'||e.code===22||/quota/i.test(String(e.message||e)))}
function safeStorageSet(key,value){
  const raw=typeof value==='string'?value:JSON.stringify(value);
  try{localStorage.setItem(key,raw);return true;}
  catch(e){
    if(!isQuotaError(e))throw e;
    let freed=0;
    try{freed=Number(window.MOGA_COMPACT_LOCAL_STORAGE_FOR_QUOTA?.()||0)}catch(_){}
    try{localStorage.setItem(key,raw);return true;}
    catch(e2){
      if(!isQuotaError(e2))throw e2;
      /* Senos Shopify CSV kopijos yra tik legacy eksportų cache. Jei globalus
         compactor dar neįkeltas / senesnės versijos, pašaliname jas lokaliai. */
      for(const k of ['moga_shopify_inventory_template_v1','moga_shopify_products_template_v1','moga_tracking_guard_v1']){
        try{const v=localStorage.getItem(k);if(v!==null){freed+=String(v).length;localStorage.removeItem(k)}}catch(_){}
      }
      try{localStorage.setItem(key,raw);return true;}
      catch(e3){
        if(isQuotaError(e3)){
          console.error('[MOGA storage quota]',{key,bytes:raw.length,freedChars:freed});
          throw new Error(`Naršyklės saugykla vis dar pilna (QuotaExceeded). Nepavyko išsaugoti ${key}.`);
        }
        throw e3;
      }
    }
  }
}
function setStore(x){
  safeStorageSet(INV_KEY,x);
}
function getMoves(){
  try{const x=JSON.parse(localStorage.getItem(MOVE_KEY)||'[]');return Array.isArray(x)?x:[]}catch(e){return[]}
}
function setMoves(x){
  safeStorageSet(MOVE_KEY,(x||[]).slice(-5000));
}
function getRecord(id,create=true){
  const store=getStore();
  if(!store.records[id]&&create){
    store.records[id]={
      qty:0,reserved:0,min:-1,target:0,location:'',barcode:'',notes:'',updatedAt:now()
    };
    setStore(store);
  }
  return store.records[id]||null;
}
function patchRecord(id,patch){
  const store=getStore();
  const cur=store.records[id]||{qty:0,reserved:0,min:-1,target:0,location:'',barcode:'',notes:''};
  store.records[id]={...cur,...patch,updatedAt:now()};
  setStore(store);
  try{
    window.dispatchEvent(new CustomEvent('moga:inventory-changed',{detail:{productId:id,beforeQty:num(cur.qty),afterQty:num(store.records[id].qty)}}));
  }catch(_){ }
  return store.records[id];
}
function addMove({productId,type='adjust',delta=0,before=0,after=0,reference='',note='',invoiceNo='',unitCost=null}){
  const p=findProductById(productId);
  const arr=getMoves();
  arr.push({
    id:mid(),createdAt:now(),productId,
    productName:p?.name||'Nežinoma prekė',sku:p?.sku||'',
    type,delta:num(delta),before:num(before),after:num(after),
    reference:String(reference||''),note:String(note||''),invoiceNo:String(invoiceNo||''),
    unitCost:unitCost===null?null:num(unitCost)
  });
  setMoves(arr);
}
function productMatch(old,p){
  if(p.inventoryId&&old.inventoryId===p.inventoryId)return true;
  if(p.sku&&old.sku&&norm(p.sku)===norm(old.sku))return true;
  return norm(p.name)===norm(old.name)&&String(p.price||'')===String(old.price||'');
}
function cleanProduct(x,oldProducts){
  const existing=oldProducts.find(o=>productMatch(o,x))||oldProducts.find(o=>norm(o.name)===norm(x.name));
  return{
    name:String(x.name||'').trim(),
    price:typeof normalizePrice==='function'?normalizePrice(x.price):String(x.price||''),
    sku:String(x.sku||'').trim(),
    category:String(x.category||'').trim(),
    cost:typeof normalizePrice==='function'?normalizePrice(x.cost):String(x.cost||''),
    inventoryId:String(x.inventoryId||existing?.inventoryId||uid()),
    shopifyInventoryItemId:String(x.shopifyInventoryItemId||existing?.shopifyInventoryItemId||'').trim(),
    shopifyVariantId:String(x.shopifyVariantId||existing?.shopifyVariantId||'').trim(),
    shopifyProductId:String(x.shopifyProductId||existing?.shopifyProductId||'').trim(),
    shopifyHandle:String(x.shopifyHandle||existing?.shopifyHandle||'').trim(),
    shopifyImageUrl:String(x.shopifyImageUrl||existing?.shopifyImageUrl||'').trim(),
    shopifyImageAlt:String(x.shopifyImageAlt||existing?.shopifyImageAlt||'').trim(),
    shopifyImportedAt:String(x.shopifyImportedAt||existing?.shopifyImportedAt||'').trim()
  };
}
function ensureProductIds(){
  let arr=[];
  try{arr=JSON.parse(localStorage.getItem(PRODUCTS_KEY)||'[]');if(!Array.isArray(arr))arr=[]}catch(e){arr=[]}
  let changed=false;
  arr=arr.map(p=>{
    if(p.inventoryId)return p;
    changed=true;return{...p,inventoryId:uid()};
  });
  if(changed)safeStorageSet(PRODUCTS_KEY,arr);
  const store=getStore();
  let storeChanged=false;
  arr.forEach(p=>{
    if(!store.records[p.inventoryId]){
      store.records[p.inventoryId]={qty:0,reserved:0,min:-1,target:0,location:'',barcode:'',notes:'',updatedAt:now()};
      storeChanged=true;
    }
  });
  if(storeChanged)setStore(store);
  return arr;
}
function products(){try{return typeof getProducts==='function'?getProducts():[]}catch(e){return[]}}
function findProductById(id){return products().find(p=>p.inventoryId===id)}
/* SF pavadinimai ateina iš seno katalogo ir gali turėti kitokį brūkšnį / tašką / tarpus
   nei sandėlio katalogas (pvz. "Boreal - 50ml." vs "Boreal — 50ml.").
   Pirma bandom griežtą normalizuotą atitikimą, po to saugų kanoninį raktą. */
function inventoryProductKey(v){
  return String(v||'').normalize('NFKC').toLowerCase()
    .replace(/[‐‑‒–—―−]/g,'-')
    .replace(/(ml|vnt)\.?/g,'$1')
    .replace(/[^a-z0-9ąčęėįšųūž]+/gi,'')
    .trim();
}
function findProductByName(name){
  const arr=products(), n=norm(name);
  const exact=arr.find(p=>norm(p.name)===n);
  if(exact)return exact;
  const key=inventoryProductKey(name);
  if(!key)return null;
  const matches=arr.filter(p=>inventoryProductKey(p.name)===key);
  return matches.length===1?matches[0]:null;
}
function available(id){
  const r=getRecord(id,false)||{qty:0,reserved:0};
  return num(r.qty)-num(r.reserved);
}


/* ---------------- FIFO savikainos sluoksniai ----------------
   Nuo FIFO įjungimo momento esamas sandėlis tampa viena pradine partija.
   Vėlesni priėmimai kuria naujas partijas, o SF nurašo seniausias pirmiausia. */
function getFifoStore(){
  try{
    const x=JSON.parse(localStorage.getItem(FIFO_KEY)||'null');
    if(x&&typeof x==='object')return{version:1,startedAt:x.startedAt||'',products:x.products&&typeof x.products==='object'?x.products:{}};
  }catch(e){}
  return{version:1,startedAt:'',products:{}};
}
function setFifoStore(x){
  safeStorageSet(FIFO_KEY,x);
  return x;
}
function fifoState(store,productId,create=true){
  if(!store.products[productId]&&create)store.products[productId]={initialized:false,initializedAt:'',layers:[]};
  const st=store.products[productId]||null;
  if(st&&!Array.isArray(st.layers))st.layers=[];
  return st;
}
function fifoLayerQtyFromState(st){return(st?.layers||[]).reduce((a,l)=>a+Math.max(0,num(l.remainingQty)),0)}
function fifoLayerValueFromState(st){return(st?.layers||[]).reduce((a,l)=>a+Math.max(0,num(l.remainingQty))*Math.max(0,num(l.unitCost)),0)}
function fifoLayers(productId,activeOnly=false){
  const st=fifoState(getFifoStore(),productId,false),arr=(st?.layers||[]).map(x=>({...x}));
  return activeOnly?arr.filter(x=>num(x.remainingQty)>1e-9):arr;
}
function fifoSummary(productId,storeOverride=null){
  const store=storeOverride||getFifoStore();
  const st=fifoState(store,productId,false),qty=fifoLayerQtyFromState(st),value=fifoLayerValueFromState(st),layers=(st?.layers||[]).filter(x=>num(x.remainingQty)>1e-9);
  return{qty,value,avgCost:qty>1e-9?value/qty:0,layers};
}
function setCatalogCostDirect(productId,cost){
  let arr=[];try{arr=JSON.parse(localStorage.getItem(PRODUCTS_KEY)||'[]');if(!Array.isArray(arr))arr=[]}catch(_){return}
  const i=arr.findIndex(x=>String(x.inventoryId||'')===String(productId||''));if(i<0)return;
  const v=Math.max(0,num(cost));
  if(Math.abs(num(arr[i].cost)-v)<0.00005)return;
  arr[i]={...arr[i],cost:String(v.toFixed(4))};
  safeStorageSet(PRODUCTS_KEY,arr);
}
function fifoSyncProductCost(productId){
  const sum=fifoSummary(productId);
  if(sum.qty>1e-9)setCatalogCostDirect(productId,sum.avgCost);
  return sum.avgCost;
}
function fifoPushLayerToStore(store,productId,qty,cost,meta={}){
  qty=Math.max(0,num(qty));if(qty<=1e-9)return null;
  const st=fifoState(store,productId,true);st.initialized=true;if(!st.initializedAt)st.initializedAt=now();
  const layer={
    id:String(meta.id||`fifo_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,9)}`),
    productId:String(productId||''),sourceType:String(meta.sourceType||'adjustment'),sourceRef:String(meta.sourceRef||''),
    sourceLineId:String(meta.sourceLineId||''),receiptId:String(meta.receiptId||''),
    receivedAt:String(meta.receivedAt||now()),createdAt:now(),unitCost:Math.max(0,num(cost)),
    originalQty:Math.max(qty,num(meta.originalQty)||qty),remainingQty:qty,note:String(meta.note||'')
  };
  st.layers.push(layer);return layer;
}
function fifoAddLayer(productId,qty,cost,meta={}){
  const store=getFifoStore();const layer=fifoPushLayerToStore(store,productId,qty,cost,meta);if(!layer)return null;
  setFifoStore(store);fifoSyncProductCost(productId);return layer;
}
function fifoSortLayers(st){
  const dateKey=l=>{
    const raw=String(l?.receivedAt||'').trim();
    const m=raw.match(/^(\d{4}-\d{2}-\d{2})/);
    return m?m[1]:String(l?.createdAt||'').slice(0,10);
  };
  return(st?.layers||[]).slice().sort((a,b)=>{
    // FIFO START / opening stock is the baseline that existed before any
    // receipt created after FIFO was enabled, even when both share the same date.
    const ao=a?.sourceType==='opening'?0:1,bo=b?.sourceType==='opening'?0:1;
    if(ao!==bo)return ao-bo;
    const d=dateKey(a).localeCompare(dateKey(b));
    if(d)return d;
    return String(a?.createdAt||'').localeCompare(String(b?.createdAt||''));
  });
}
function fifoConsumeRaw(store,productId,qty){
  qty=Math.max(0,num(qty));const st=fifoState(store,productId,true),out=[];let left=qty;
  for(const l of fifoSortLayers(st)){
    if(left<=1e-9)break;const avail=Math.max(0,num(l.remainingQty));if(avail<=1e-9)continue;
    const take=Math.min(avail,left);l.remainingQty=avail-take;left-=take;
    out.push({layerId:l.id,qty:take,unitCost:Math.max(0,num(l.unitCost)),sourceType:l.sourceType||'',sourceRef:l.sourceRef||''});
  }
  return{requested:qty,allocated:qty-left,left,layers:out,totalCost:out.reduce((a,x)=>a+x.qty*x.unitCost,0)};
}
function fifoReconcileToQty(productId,desiredQty,meta={}){
  desiredQty=Math.max(0,num(desiredQty));const store=getFifoStore(),st=fifoState(store,productId,true);st.initialized=true;if(!st.initializedAt)st.initializedAt=store.startedAt||now();const have=fifoLayerQtyFromState(st),p=findProductById(productId),cost=Math.max(0,num(meta.unitCost!==undefined?meta.unitCost:p?.cost));
  if(desiredQty>have+1e-9){
    fifoPushLayerToStore(store,productId,desiredQty-have,cost,{sourceType:meta.sourceType||'reconcile-in',sourceRef:meta.sourceRef||'',receivedAt:meta.receivedAt||now(),note:meta.note||'FIFO sutikrinimas su sandėlio likučiu'});
  }else if(have>desiredQty+1e-9){
    fifoConsumeRaw(store,productId,have-desiredQty);
  }
  setFifoStore(store);fifoSyncProductCost(productId);return fifoSummary(productId);
}
function fifoConsume(productId,qty,meta={}){
  qty=Math.max(0,num(qty));if(qty<=1e-9)return{qty:0,totalCost:0,unitCost:0,layers:[]};
  const before=Math.max(0,num(getRecord(productId,false)?.qty));fifoReconcileToQty(productId,before,{sourceType:'reconcile-before-sale'});
  const store=getFifoStore(),res=fifoConsumeRaw(store,productId,qty);let left=res.left;
  if(left>1e-9){
    const p=findProductById(productId),fallback=Math.max(0,num(p?.cost));
    res.layers.push({layerId:'',qty:left,unitCost:fallback,sourceType:'negative-fallback',sourceRef:String(meta.sourceRef||'')});
    res.totalCost+=left*fallback;res.allocated+=left;left=0;
  }
  setFifoStore(store);fifoSyncProductCost(productId);
  return{qty,resolvedQty:res.allocated,totalCost:res.totalCost,unitCost:qty>0?res.totalCost/qty:0,layers:res.layers};
}
function fifoMergeAllocation(base,extra){
  const out=base?JSON.parse(JSON.stringify(base)):{productId:extra.productId,name:extra.name||'',qty:0,totalCost:0,layers:[]};
  out.productId=extra.productId||out.productId;out.name=extra.name||out.name;out.layers=Array.isArray(out.layers)?out.layers:[];
  (extra.layers||[]).forEach(x=>{const k=out.layers.find(y=>String(y.layerId||'')===String(x.layerId||'')&&num(y.unitCost)===num(x.unitCost));if(k)k.qty=num(k.qty)+num(x.qty);else out.layers.push({...x});});
  out.qty=(out.layers||[]).reduce((a,x)=>a+num(x.qty),0);out.totalCost=(out.layers||[]).reduce((a,x)=>a+num(x.qty)*num(x.unitCost),0);out.unitCost=out.qty>0?out.totalCost/out.qty:0;return out;
}
function fifoRestoreAllocationQty(productId,allocation,qty){
  qty=Math.max(0,num(qty));if(!allocation||qty<=1e-9)return{restored:0,totalCost:0};
  const store=getFifoStore(),st=fifoState(store,productId,true),layers=Array.isArray(allocation.layers)?allocation.layers:[];let left=qty,totalCost=0;
  for(let i=layers.length-1;i>=0&&left>1e-9;i--){
    const a=layers[i],have=Math.max(0,num(a.qty));if(have<=1e-9)continue;const take=Math.min(have,left),target=st.layers.find(l=>String(l.id)===String(a.layerId||''));
    if(target)target.remainingQty=Math.max(0,num(target.remainingQty))+take;
    else fifoPushLayerToStore(store,productId,take,num(a.unitCost),{sourceType:'invoice-restore',sourceRef:'',receivedAt:now(),note:'Atkurta trūkstama FIFO partija'});
    a.qty=have-take;left-=take;totalCost+=take*num(a.unitCost);
  }
  allocation.layers=layers.filter(x=>num(x.qty)>1e-9);allocation.qty=allocation.layers.reduce((a,x)=>a+num(x.qty),0);allocation.totalCost=allocation.layers.reduce((a,x)=>a+num(x.qty)*num(x.unitCost),0);allocation.unitCost=allocation.qty>0?allocation.totalCost/allocation.qty:0;
  setFifoStore(store);fifoSyncProductCost(productId);return{restored:qty-left,totalCost};
}
function fifoRestoreAllAllocations(allocations=[]){
  (allocations||[]).forEach(a=>fifoRestoreAllocationQty(a.productId,a,num(a.qty)));
}
function fifoAddPurchaseReceipt(productId,receivedQty,cost,meta={}){
  const desired=Math.max(0,num(getRecord(productId,false)?.qty));const store=getFifoStore(),st=fifoState(store,productId,true),have=fifoLayerQtyFromState(st),add=Math.max(0,desired-have);
  if(add<=1e-9){setFifoStore(store);fifoSyncProductCost(productId);return null}
  const layer=fifoPushLayerToStore(store,productId,add,cost,{...meta,sourceType:'purchase',originalQty:Math.max(add,num(receivedQty))});setFifoStore(store);fifoSyncProductCost(productId);return layer;
}
function fifoSourceLayers(sourceType,sourceRef,productId){return fifoLayers(productId,false).filter(l=>l.sourceType===sourceType&&String(l.sourceRef||'')===String(sourceRef||''))}
function fifoCanReverseSource(sourceType,sourceRef,productId,qty){
  qty=Math.max(0,num(qty));const ls=fifoSourceLayers(sourceType,sourceRef,productId),remaining=ls.reduce((a,l)=>a+Math.max(0,num(l.remainingQty)),0),original=ls.reduce((a,l)=>a+Math.max(0,num(l.originalQty)),0);
  return ls.length>0&&original+1e-9>=qty&&remaining+1e-9>=qty;
}
function fifoReverseSource(sourceType,sourceRef,productId,qty){
  qty=Math.max(0,num(qty));if(!fifoCanReverseSource(sourceType,sourceRef,productId,qty))return false;
  const store=getFifoStore(),st=fifoState(store,productId,true);let left=qty;
  const ls=(st.layers||[]).filter(l=>l.sourceType===sourceType&&String(l.sourceRef||'')===String(sourceRef||'')).sort((a,b)=>String(b.receivedAt||'').localeCompare(String(a.receivedAt||'')));
  for(const l of ls){if(left<=1e-9)break;const take=Math.min(Math.max(0,num(l.remainingQty)),left);l.remainingQty=Math.max(0,num(l.remainingQty))-take;left-=take;}
  setFifoStore(store);fifoSyncProductCost(productId);return left<=1e-9;
}
function fifoCanRemoveLayer(productId,layerId,qty){const l=fifoLayers(productId,false).find(x=>String(x.id)===String(layerId||''));return!!l&&num(l.remainingQty)+1e-9>=Math.max(0,num(qty))}
function fifoRemoveLayer(productId,layerId,qty){
  qty=Math.max(0,num(qty));if(!fifoCanRemoveLayer(productId,layerId,qty))return false;const store=getFifoStore(),st=fifoState(store,productId,true),l=st.layers.find(x=>String(x.id)===String(layerId));l.remainingQty=Math.max(0,num(l.remainingQty)-qty);setFifoStore(store);fifoSyncProductCost(productId);return true;
}
function fifoInvoiceItemCost(invoiceNo,productName){
  const row=(typeof getTrackingInfo==='function'?getTrackingInfo():[]).find(r=>String(r.no||'').trim()===String(invoiceNo||'').trim());if(!row)return 0;
  const p=findProductByName(productName);
  // FIFO SF atveju autoritetingas šaltinis yra konkrečios SF fifoAllocations.
  // it.cost gali būti užsilikusi / vėliau perrašyta katalogo savikaina, todėl jos
  // NEGALIMA tikrinti pirmiau už tikrą FIFO paskirstymą.
  const a=(row.fifoAllocations||[]).find(x=>String(x.productId||'')===String(p?.inventoryId||''))
    ||(row.fifoAllocations||[]).find(x=>norm(x?.name)===norm(productName));
  if(row.fifoVersion===1&&!row.fifoLegacy&&a&&num(a.qty)>0)return num(a.totalCost)/num(a.qty);
  const it=(row.items||[]).find(x=>norm(x.name)===norm(productName));if(num(it?.cost)>0)return num(it.cost);
  if(a&&num(a.qty)>0)return num(a.totalCost)/num(a.qty);
  return num(p?.cost);
}
function fifoAddCustomerReturn(productId,qty,cost,meta={}){return fifoAddLayer(productId,qty,cost,{...meta,sourceType:'customer-return'})}
function ensureFifoInitialized(){
  const existed=!!localStorage.getItem(FIFO_KEY);
  const store=getFifoStore();
  const invStore=getStore();
  let changed=false;
  if(!store.startedAt){store.startedAt=now();changed=true;}
  const arr=products();
  arr.forEach(p=>{
    const id=p.inventoryId;if(!id)return;
    let st=fifoState(store,id,true);
    if(st.initialized||st.layers.length){
      if(!st.initialized){st.initialized=true;changed=true;}
      if(!st.initializedAt){st.initializedAt=store.startedAt;changed=true;}
      return;
    }
    const q=Math.max(0,num(invStore.records?.[id]?.qty));
    st.initialized=true;st.initializedAt=store.startedAt;changed=true;
    if(q>1e-9)fifoPushLayerToStore(store,id,q,num(p.cost),{sourceType:'opening',sourceRef:'FIFO START',receivedAt:store.startedAt,note:'Pradinis likutis FIFO įjungimo momentu'});
  });
  if(changed)setFifoStore(store);
  if(!existed){
    let rows=[];try{rows=typeof getTrackingInfo==='function'?getTrackingInfo():[]}catch(_){rows=[]}
    if(Array.isArray(rows)&&rows.length){rows.forEach(r=>{if(r.fifoVersion===undefined){r.fifoLegacy=true;r.fifoVersion=0;}});try{setTrackingInfo(rows)}catch(_){} }
  }
  return changed?getFifoStore():store;
}
function fifoStartedAt(){return getFifoStore().startedAt||''}
function fifoSummaryText(productId,storeOverride=null){
  const s=fifoSummary(productId,storeOverride);if(!s.layers.length)return'FIFO partijų nėra';
  return s.layers.slice(0,8).map(l=>`${num(l.remainingQty).toLocaleString('lt-LT')} vnt. × ${money(l.unitCost)} · ${l.sourceType==='opening'?'Pradinis likutis':(l.sourceRef||l.sourceType)}`).join('\n')+(s.layers.length>8?`\n+ dar ${s.layers.length-8}`:'');
}

/* Preserve stable inventoryId through all existing product edits/imports. */
const baseSetProducts=window.setProducts;
if(typeof baseSetProducts==='function'){
  window.setProducts=function(rows){
    const old=products();
    const raw=(rows||[]).map(x=>cleanProduct(x,old)).filter(x=>x.name);
    const map=new Map();
    for(const x of raw){
      const sku=String(x.sku||'').trim().toLowerCase();
      const k=sku?`sku:${sku}`:`name:${norm(x.name)}`;
      if(!map.has(k))map.set(k,x);
      else map.set(k,{...map.get(k),...x,inventoryId:map.get(k).inventoryId||x.inventoryId});
    }
    const clean=[...map.values()];
    /* Kai FIFO jau turi aktyvių partijų, katalogo savikaina yra išvestinė reikšmė,
       todėl rankinis produkto redagavimas negali perrašyti likusio sandėlio vertės. */
    clean.forEach(p=>{const fs=fifoSummary(p.inventoryId);if(fs.qty>1e-9)p.cost=String(fs.avgCost.toFixed(4));});
    safeStorageSet(PRODUCTS_KEY,clean);
    const store=getStore();
    clean.forEach(p=>{
      if(!store.records[p.inventoryId]){
        store.records[p.inventoryId]={qty:0,reserved:0,min:-1,target:0,location:'',barcode:'',notes:'',updatedAt:now()};
      }
    });
    setStore(store);
    if(typeof renderProductCatalog==='function')renderProductCatalog();
    if(typeof refreshProductDatalist==='function')refreshProductDatalist();
    renderInventory();
    return clean;
  };
}

/* Existing historical invoices become baseline only — no retroactive stock deduction. */
function baselineLegacyInvoices(){
  let rows=[];
  try{rows=typeof getTrackingInfo==='function'?getTrackingInfo():JSON.parse(localStorage.getItem(TRACKING_KEY)||'[]')}catch(e){rows=[]}
  let changed=false;
  rows.forEach(r=>{
    if(Array.isArray(r.inventorySnapshot))return;
    r.inventorySnapshot=(r.items||[]).map(it=>{
      const p=findProductByName(it.name);
      return p?{productId:p.inventoryId,name:p.name,qty:num(it.qty)}:null;
    }).filter(Boolean);
    r.inventoryLegacy=true;
    r.inventoryPostedAt=null;
    changed=true;
  });
  if(changed&&typeof setTrackingInfo==='function')setTrackingInfo(rows);
}

function manufacturingRecipes(){
  try{
    const x=JSON.parse(localStorage.getItem(RECIPES_KEY)||'[]');
    return Array.isArray(x)?x:[];
  }catch(e){return[]}
}
function recipeById(id){return manufacturingRecipes().find(r=>String(r.id||'')===String(id||''))||null}
function recipeByName(name){const n=norm(name);return manufacturingRecipes().find(r=>norm(r.name)===n)||null}
function recipeMaterialNeeds(recipe,multiplier=1){
  const byId=new Map();
  (recipe?.materials||[]).forEach(m=>{
    const id=String(m.productId||'');const q=Math.max(0,num(m.qty))*Math.max(0,num(multiplier));
    if(!id||q<=0)return;
    const p=findProductById(id);
    const prev=byId.get(id)||{productId:id,name:p?.name||m.name||'Medžiaga',qty:0};
    prev.qty+=q;byId.set(id,prev);
  });
  return [...byId.values()];
}
function recipeBuildableQty(recipe){
  const needs=recipeMaterialNeeds(recipe,1);
  if(!needs.length)return 0;
  let possible=Infinity;
  needs.forEach(n=>{const per=Math.max(0,num(n.qty));if(per<=0)return;possible=Math.min(possible,Math.max(0,available(n.productId))/per)});
  return Number.isFinite(possible)?Math.max(0,Math.floor(possible+1e-9)):0;
}
function manufacturingProjects(){
  try{const x=JSON.parse(localStorage.getItem('moga_projects_v1')||'[]');return Array.isArray(x)?x:[]}catch(_){return[]}
}
function projectByInventoryId(id){id=String(id||'');if(!id.startsWith('project:'))return null;return manufacturingProjects().find(p=>String(p?.id||'')===id.slice(8))||null}
function virtualProjectId(project){return project?.id?`project:${project.id}`:''}
function projectProductionEvent(project){
  const pid=String(project?.id||'');const events=Array.isArray(getStore()?.manufacturingEvents)?getStore().manufacturingEvents:[];
  return [...events].reverse().find(e=>String(e?.projectId||'')===pid)||null;
}
function projectProducedQty(project){
  const ev=projectProductionEvent(project);if(!ev)return 0;
  const produced=Math.max(0,num(ev.quantity??ev.qty??1))||1;let sold=0;
  try{const tracking=typeof getTrackingInfo==='function'?getTrackingInfo():JSON.parse(localStorage.getItem(TRACKING_KEY)||'[]');(Array.isArray(tracking)?tracking:[]).forEach(r=>(r.items||[]).forEach(it=>{if(String(it?.projectId||'')===String(project.id))sold+=Math.max(0,num(it.qty))}))}catch(_){}
  return Math.max(0,produced-sold);
}
function projectUnitCost(project){const ev=projectProductionEvent(project);if(ev&&num(ev.totalCost)>0)return num(ev.totalCost)/Math.max(1,num(ev.quantity??ev.qty??1));return Math.max(0,num(project?.actualCost||project?.productionCost||project?.productionPlan?.plannedTotalCost||project?.plannedTotalCost))}
function recipeProducedQty(recipe){
  const rid=String(recipe?.id||'');
  const rname=norm(recipe?.name||'');
  const events=Array.isArray(getStore()?.manufacturingEvents)?getStore().manufacturingEvents:[];
  const produced=events.reduce((sum,e)=>{
    if(e?.projectId)return sum;
    const eid=String(e?.recipeId??e?.recipe?.id??'');
    const ename=norm(e?.recipeName??e?.recipe?.name??'');
    if((rid&&eid===rid)||(!eid&&rname&&ename===rname)){
      return sum+Math.max(0,num(e?.quantity??e?.qty??e?.producedQty));
    }
    return sum;
  },0);

  // Pagamintas gaminys jau yra ATSKIRAS sandėlio vienetas.
  // Jo medžiagos buvo nurašytos gamybos momentu, todėl pardavus SF
  // mažiname gatavo gaminio likutį, o ne dar kartą jo medžiagas.
  let sold=0;
  try{
    const tracking=typeof getTrackingInfo==='function'
      ?getTrackingInfo()
      :JSON.parse(localStorage.getItem(TRACKING_KEY)||'[]');
    (Array.isArray(tracking)?tracking:[]).forEach(row=>{
      (Array.isArray(row?.items)?row.items:[]).forEach(it=>{
        const iid=String(it?.recipeId||'');
        const iname=norm(it?.name||'');
        if((rid&&iid===rid)||(!iid&&rname&&iname===rname)){
          sold+=Math.max(0,num(it?.qty));
        }
      });
    });
  }catch(_){}
  return Math.max(0,produced-sold);
}
function virtualRecipeId(recipe){return recipe?.id?`recipe:${recipe.id}`:''}
function recipeFromVirtualId(id){
  id=String(id||'');
  return id.startsWith('recipe:')?recipeById(id.slice(7)):null;
}
function recipeUnitCost(recipe){
  const rid=String(recipe?.id||''),rname=norm(recipe?.name||'');
  const events=Array.isArray(getStore()?.manufacturingEvents)?getStore().manufacturingEvents:[];
  let q=0,total=0;
  events.forEach(e=>{
    if(e?.projectId)return;
    const eid=String(e?.recipeId??e?.recipe?.id??'');
    const ename=norm(e?.recipeName??e?.recipe?.name??'');
    if(!((rid&&eid===rid)||(!eid&&rname&&ename===rname)))return;
    const eq=Math.max(0,num(e?.quantity??e?.qty??e?.producedQty));
    const ec=Math.max(0,num(e?.unitCost));
    if(eq>0&&ec>=0){q+=eq;total+=eq*ec}
  });
  if(q>1e-9)return total/q;
  let cost=Math.max(0,num(recipe?.cost));
  recipeMaterialNeeds(recipe,1).forEach(n=>{cost+=num(n.qty)*num(findProductById(n.productId)?.cost)});
  return cost;
}
function snapshotInvoice(data){
  const byId=new Map();
  const add=(productId,name,q)=>{
    q=num(q);if(!productId||q<=0)return;
    const p=findProductById(productId);
    const prev=byId.get(productId)||{productId,name:p?.name||name||'Prekė',qty:0};
    prev.qty+=q;byId.set(productId,prev);
  };
  (data?.items||[]).forEach(it=>{
    const q=num(it.qty);if(q<=0)return;
    const project=(it.projectId?manufacturingProjects().find(p=>String(p?.id||'')===String(it.projectId)):null);
    if(project){add(virtualProjectId(project),project.name,q);return;}
    const recipe=recipeById(it.recipeId)||(!it.productId?recipeByName(it.name):null);
    if(recipe){add(virtualRecipeId(recipe),recipe.name,q);return;}
    const p=(it.productId&&findProductById(it.productId))||findProductByName(it.name);
    if(p)add(p.inventoryId,p.name,q);
  });
  return [...byId.values()];
}
function snapMap(snap){
  const m=new Map();
  (snap||[]).forEach(x=>m.set(x.productId,num(x.qty)));
  return m;
}
function snapshotDiff(oldSnap,newSnap){
  const a=snapMap(oldSnap),b=snapMap(newSnap),ids=new Set([...a.keys(),...b.keys()]);
  return [...ids].map(id=>({productId:id,oldQty:a.get(id)||0,newQty:b.get(id)||0,diff:(b.get(id)||0)-(a.get(id)||0)})).filter(x=>Math.abs(x.diff)>1e-9);
}
function itemsEquivalent(a,b){
  const clean=x=>(x||[]).filter(i=>String(i.name||'').trim()).map(i=>[norm(i.name),num(i.qty),num(i.price),num(i.discount)]).sort((x,y)=>x[0].localeCompare(y[0]));
  return JSON.stringify(clean(a))===JSON.stringify(clean(b));
}
function invoiceNoFrom(data){
  try{return typeof buildInvoiceNo==='function'?buildInvoiceNo(data):''}catch(e){return''}
}
function shortageMessage(diff){
  const bad=[];
  diff.forEach(x=>{
    if(x.diff<=0)return;
    const recipe=recipeFromVirtualId(x.productId);
    if(recipe){
      const a=recipeProducedQty(recipe);
      if(a<x.diff)bad.push(`${recipe.name}: reikia ${x.diff}, pagaminta sandėlyje ${a}`);
      return;
    }
    const p=findProductById(x.productId);if(!p)return;
    const a=available(x.productId);
    if(a<x.diff)bad.push(`${p.name}: reikia ${x.diff}, galima ${a}`);
  });
  return bad;
}
function legacyCostForProduct(row,productId){
  const p=findProductById(productId);if(!p)return 0;
  const it=(row?.items||[]).find(x=>norm(x.name)===norm(p.name));
  return num(it?.cost)>0?num(it.cost):num(p.cost);
}
function allocationForProduct(arr,productId){return(arr||[]).find(x=>String(x.productId||'')===String(productId||''))||null}
function allocationForInvoiceItem(arr,it){
  const p=findProductByName(it?.name);
  return (p?allocationForProduct(arr,p.inventoryId):null)
    ||(arr||[]).find(x=>norm(x?.name)===norm(it?.name))
    ||null;
}
function setInvoiceItemCosts(row){
  if(!row)return;
  const allocations=Array.isArray(row.fifoAllocations)?row.fifoAllocations:[];
  (row.items||[]).forEach(it=>{
    const p=findProductByName(it.name);
    if(it.projectId){
      const events=Array.isArray(getStore()?.manufacturingEvents)?getStore().manufacturingEvents:[];
      const ev=events.find(e=>String(e?.projectId||'')===String(it.projectId||''));
      if(ev){
        const producedQty=Math.max(1,num(ev.quantity??ev.qty??ev.producedQty??1));
        const totalCost=Math.max(0,num(ev.totalCost));
        if(totalCost>0)it.cost=totalCost/producedQty;
      }
      return;
    }
    const recipe=recipeById(it.recipeId)||(!p?recipeByName(it.name):null);
    if(recipe){
      let unitCost=Math.max(0,num(recipe.cost));
      recipeMaterialNeeds(recipe,1).forEach(n=>{
        const a=allocationForProduct(allocations,n.productId),cp=findProductById(n.productId);
        const c=a&&num(a.qty)>1e-9?num(a.totalCost)/num(a.qty):num(cp?.cost);
        unitCost+=num(n.qty)*c;
      });
      it.cost=unitCost;
      return;
    }
    const a=allocationForInvoiceItem(allocations,it);
    // Vienos SF prekės savikaina yra VISŲ jos sunaudotų FIFO sluoksnių
    // bendra vertė / bendras kiekis (pvz. 1x0,50 + 1x1,00 => 0,75/vnt.).
    if(a&&num(a.qty)>1e-9)it.cost=num(a.totalCost)/num(a.qty);
    else if(num(it.cost)<=0&&p)it.cost=num(p.cost);
  });
}
function applyInvoiceFifoDiff(diff,invoiceNo,oldRow,newRow){
  const oldFifo=!!(oldRow&&oldRow.fifoVersion===1&&!oldRow.fifoLegacy);
  const allocations=oldFifo?JSON.parse(JSON.stringify(oldRow.fifoAllocations||[])):[];
  diff.forEach(x=>{
    const recipe=recipeFromVirtualId(x.productId);
    if(recipe){
      // baseAppend() jau išsaugojo SF, todėl recipeProducedQty() šioje vietoje
      // grąžina NAUJĄ gatavo gaminio likutį po SF.
      const after=recipeProducedQty(recipe);
      const delta=-x.diff;
      const before=after-delta;
      addMove({
        productId:x.productId,
        type:oldRow?'invoice-update':'sale',
        delta,before,after,
        reference:invoiceNo,invoiceNo,
        note:oldRow?'Automatinis pagaminto gaminio SF pakeitimo sutikrinimas':'Pagaminto gaminio pardavimas pagal SF',
        unitCost:recipeUnitCost(recipe)
      });
      return;
    }

    const p=findProductById(x.productId);if(!p)return;
    const r=getRecord(x.productId),before=num(r.qty),delta=-x.diff,after=before+delta;
    let moveCost=num(p.cost);
    if(x.diff>0){
      const c=fifoConsume(x.productId,x.diff,{sourceRef:invoiceNo});
      moveCost=c.unitCost||moveCost;
      if(oldFifo){
        const existing=allocationForProduct(allocations,x.productId),extra={productId:x.productId,name:p.name,qty:c.qty,totalCost:c.totalCost,unitCost:c.unitCost,layers:c.layers};
        const merged=fifoMergeAllocation(existing,extra);
        if(existing)allocations[allocations.indexOf(existing)]=merged;else allocations.push(merged);
      }else if(!oldRow){
        allocations.push({productId:x.productId,name:p.name,qty:c.qty,totalCost:c.totalCost,unitCost:c.unitCost,layers:c.layers});
      }
    }else if(x.diff<0){
      const giveBack=-x.diff;
      if(oldFifo){
        const a=allocationForProduct(allocations,x.productId);
        if(a){const restored=fifoRestoreAllocationQty(x.productId,a,giveBack);moveCost=restored.restored>0?restored.totalCost/restored.restored:moveCost;}
        else fifoAddLayer(x.productId,giveBack,legacyCostForProduct(oldRow,x.productId),{sourceType:'invoice-update-return',sourceRef:invoiceNo,receivedAt:now()});
      }else{
        moveCost=legacyCostForProduct(oldRow,x.productId)||moveCost;
        fifoAddLayer(x.productId,giveBack,moveCost,{sourceType:'legacy-invoice-update-return',sourceRef:invoiceNo,receivedAt:now(),note:'Seno SF kiekio sumažinimas po FIFO įjungimo'});
      }
    }
    patchRecord(x.productId,{qty:after});
    addMove({productId:x.productId,type:oldRow?'invoice-update':'sale',delta,before,after,reference:invoiceNo,invoiceNo,note:oldRow?'Automatinis SF pakeitimo sutikrinimas':'Automatiškai pagal registruotą SF',unitCost:moveCost});
  });
  if(!oldRow){
    newRow.fifoAllocations=allocations;newRow.fifoLegacy=false;newRow.fifoVersion=1;
  }else if(oldFifo){
    newRow.fifoAllocations=allocations.filter(a=>num(a.qty)>1e-9);newRow.fifoLegacy=false;newRow.fifoVersion=1;
  }else{
    newRow.fifoLegacy=true;newRow.fifoVersion=0;
  }
  setInvoiceItemCosts(newRow);
}

/* Automatic stock posting when invoice is registered / updated. */
const baseAppend=window.appendCurrentInvoiceToTracking;
if(typeof baseAppend==='function'){
  window.appendCurrentInvoiceToTracking=async function(){
    if(!premium())return baseAppend();

    ensureFifoInitialized();
    const d=typeof collect==='function'?collect():null;
    const no=invoiceNoFrom(d);
    const beforeRows=typeof getTrackingInfo==='function'?getTrackingInfo():[];
    const editOriginal=String(window.__MOGA_EDITING_INVOICE_ORIGINAL_NO||'').trim();
    const old=beforeRows.find(r=>String(r.no||'').trim()===String(editOriginal||no||'').trim());
    /* Jei tai sena, jau užregistruota SF be inventorySnapshot,
       jos esamas prekių kiekis yra pradinis taškas. Taip vien datos,
       pirkėjo, sekimo nr. ir kitų metaduomenų pakeitimas sandėlio neliečia. */
    const newSnap=snapshotInvoice(d);

    /* KRITINIS SAUGIKLIS:
       jei jau registruotos SF prekės/kiekiai/kainos/nuolaidos nepasikeitė,
       tai yra tik metaduomenų pakeitimas (data, pardavimo data, pirkėjas,
       sekimo nr., pristatymas ir pan.). Sandėlis ir FIFO tokiu atveju
       NEGALI būti judinami net jei senos SF inventorySnapshot trūksta
       arba jis buvo tuščias. */
    const metadataOnlyUpdate=!!(old&&itemsEquivalent(old.items||[],d?.items||[]));

    const oldSnap=Array.isArray(old?.inventorySnapshot)&&old.inventorySnapshot.length
      ? old.inventorySnapshot
      : (old ? snapshotInvoice({items:old.items||[]}) : []);

    const diff=metadataOnlyUpdate ? [] : snapshotDiff(oldSnap,newSnap);
    const shortages=shortageMessage(diff);
    const store=getStore();

    if(shortages.length&&!store.settings.allowNegative){
      const msg=shortages.join('\n')+'\n\nSandėlyje nepakanka tik papildomai pridedamam kiekiui. Pakoreguok likutį arba prekės kiekį.';
      if(window.MOGA_UI?.alert)await MOGA_UI.alert(msg,{title:'Sandėlio įspėjimas'});
      else alert(msg);
      return;
    }
    if(shortages.length&&store.settings.allowNegative){
      if(!(await MOGA_UI.confirm('Kai kurių prekių likutis taps neigiamas:\n\n'+shortages.join('\n')+'\n\nTęsti?',{title:'Neigiamas sandėlio likutis',danger:true,requireCheck:true,checkText:'Patvirtinu, kad leidžiu neigiamą likutį šiam veiksmui',confirmText:'TĘSTI'})))return;
    }

    const saved=await baseAppend();
    if(saved===false)return false;

    const afterRows=typeof getTrackingInfo==='function'?getTrackingInfo():[];
    const row=afterRows.find(r=>String(r.no||'').trim()===String(no||'').trim());
    if(!row)return;
    if(!itemsEquivalent(row.items,d?.items))return;

    /* metadataOnlyUpdate => diff=[] => jokio qty/FIFO judėjimo. */
    applyInvoiceFifoDiff(diff,no,old,row);
    row.inventorySnapshot=newSnap;
    row.inventoryLegacy=old?!!old.inventoryLegacy:false;
    row.inventoryPostedAt=now();
    if(typeof setTrackingInfo==='function')setTrackingInfo(afterRows);
    renderInventory();renderInventoryHistory();
    try{window.renderSalesPage?.()}catch(_){}
    return true;
  };
}

/* Safer delete: custom MOGA confirmation instead of the browser confirm box. */
function ensureInvoiceCancelModal(){
  if(!document.getElementById('mogaInvoiceCancelModalCss')){
    const st=document.createElement('style');
    st.id='mogaInvoiceCancelModalCss';
    st.textContent=`
      #mogaInvoiceCancelModal.moga-action-modal{
        position:fixed!important;
        inset:0!important;
        width:100vw!important;
        height:100vh!important;
        margin:0!important;
        padding:20px!important;
        box-sizing:border-box!important;
        display:none!important;
        align-items:center!important;
        justify-content:center!important;
        background:rgba(0,0,0,.62)!important;
        backdrop-filter:blur(4px);
        -webkit-backdrop-filter:blur(4px);
        z-index:2147483000!important;
      }
      #mogaInvoiceCancelModal.moga-action-modal.show{
        display:flex!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-card{
        position:relative!important;
        inset:auto!important;
        transform:none!important;
        margin:0!important;
        width:min(560px,calc(100vw - 40px))!important;
        max-height:calc(100vh - 40px)!important;
        overflow:auto!important;
        box-sizing:border-box!important;
        background:#151515!important;
        color:#fff!important;
        border:1px solid transparent!important;
        border-radius:20px!important;
        padding:28px!important;
        box-shadow:0 24px 70px rgba(0,0,0,.48)!important;
        background-image:
          linear-gradient(#151515,#151515),
          linear-gradient(135deg,#ff8a00,#ff5f9e)!important;
        background-origin:border-box!important;
        background-clip:padding-box,border-box!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-close{
        position:absolute!important;
        top:14px!important;
        right:14px!important;
        width:38px!important;
        height:38px!important;
        border-radius:50%!important;
        border:1px solid #555!important;
        background:#242424!important;
        color:#fff!important;
        font-size:24px!important;
        line-height:1!important;
        cursor:pointer!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-kicker{
        margin:0 46px 8px 0!important;
        color:#ff9a19!important;
        font-size:11px!important;
        font-weight:900!important;
        letter-spacing:.08em!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-card h3{
        margin:0 46px 14px 0!important;
        color:#fff!important;
        font-size:25px!important;
        line-height:1.15!important;
        font-weight:800!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-text{
        color:#fff!important;
        font-size:14px!important;
        line-height:1.55!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-text p{
        margin:0 0 10px!important;
      }
      #mogaInvoiceCancelModal .moga-action-summary{
        margin-top:8px!important;
      }
      #mogaInvoiceCancelModal .moga-action-summary ul{
        margin:8px 0 0 20px!important;
        padding:0!important;
      }
      #mogaInvoiceCancelModal .moga-action-summary li{
        margin:5px 0!important;
      }
      #mogaInvoiceCancelModal .moga-action-confirm-check{
        display:flex!important;
        align-items:flex-start!important;
        gap:10px!important;
        margin:18px 0 0!important;
        padding:13px 14px!important;
        border:1px solid #353535!important;
        border-radius:12px!important;
        background:#1d1d1d!important;
        color:#fff!important;
        font-size:13px!important;
        cursor:pointer!important;
      }
      #mogaInvoiceCancelModal .moga-action-confirm-check input{
        appearance:none!important;
        -webkit-appearance:none!important;
        width:20px!important;
        height:20px!important;
        margin:0!important;
        flex:0 0 auto!important;
        border:1px solid #666!important;
        border-radius:6px!important;
        background:#fff!important;
        display:grid!important;
        place-items:center!important;
        cursor:pointer!important;
        transition:.15s ease!important;
      }
      #mogaInvoiceCancelModal .moga-action-confirm-check input:hover{
        border-color:#ff8a00!important;
        box-shadow:0 0 0 3px rgba(255,138,0,.13)!important;
      }
      #mogaInvoiceCancelModal .moga-action-confirm-check input:checked{
        border-color:transparent!important;
        background:linear-gradient(135deg,#ff8a00,#ff5f9e)!important;
      }
      #mogaInvoiceCancelModal .moga-action-confirm-check input:checked::after{
        content:'✓';
        color:#111;
        font-size:14px;
        line-height:1;
        font-weight:1000;
      }
      #mogaInvoiceCancelModal .moga-action-modal-actions{
        display:flex!important;
        justify-content:flex-end!important;
        gap:10px!important;
        margin-top:18px!important;
        padding-top:18px!important;
        border-top:1px solid #333!important;
      }
      #mogaInvoiceCancelModal .moga-action-modal-actions button{
        min-height:42px!important;
        padding:0 18px!important;
        border-radius:999px!important;
        font-weight:900!important;
        font-size:12px!important;
        cursor:pointer!important;
      }
      #mogaInvoiceCancelModal .moga-action-secondary{
        border:1px solid #555!important;
        background:#262626!important;
        color:#fff!important;
      }
      #mogaInvoiceCancelModal .moga-action-primary{
        border:0!important;
        background:linear-gradient(135deg,#ff8a00,#ff5f9e)!important;
        color:#111!important;
      }
      #mogaInvoiceCancelModal .moga-action-primary:disabled{
        opacity:.38!important;
        cursor:not-allowed!important;
        filter:grayscale(.25)!important;
      }
      @media(max-width:600px){
        #mogaInvoiceCancelModal.moga-action-modal{padding:12px!important}
        #mogaInvoiceCancelModal .moga-action-modal-card{
          width:calc(100vw - 24px)!important;
          padding:22px 18px!important;
          border-radius:16px!important;
        }
        #mogaInvoiceCancelModal .moga-action-modal-actions{
          flex-direction:column-reverse!important;
        }
        #mogaInvoiceCancelModal .moga-action-modal-actions button{
          width:100%!important;
        }
      }
    `;
    document.head.appendChild(st);
  }
  if(document.getElementById('mogaInvoiceCancelModal'))return;
  document.body.insertAdjacentHTML('beforeend',`<div id="mogaInvoiceCancelModal" class="moga-action-modal screen-only" aria-hidden="true">
    <div class="moga-action-modal-card" role="dialog" aria-modal="true" aria-labelledby="mogaInvoiceCancelTitle">
      <button type="button" class="moga-action-modal-close" data-moga-cancel-close aria-label="Uždaryti">×</button>
      <div class="moga-action-modal-kicker">SĄSKAITOS ATŠAUKIMAS</div>
      <h3 id="mogaInvoiceCancelTitle">Patvirtinkite veiksmą</h3>
      <div id="mogaInvoiceCancelText" class="moga-action-modal-text"></div>
      <label class="moga-action-confirm-check"><input id="mogaInvoiceCancelCheck" type="checkbox"><span>Patvirtinu, kad noriu atšaukti šią sąskaitą</span></label>
      <div class="moga-action-modal-actions">
        <button type="button" class="moga-action-secondary" data-moga-cancel-close>ATŠAUKTI</button>
        <button type="button" id="mogaInvoiceCancelConfirm" class="moga-action-primary" disabled>PATVIRTINTI ATŠAUKIMĄ</button>
      </div>
    </div>
  </div>`);
}

const baseDelete=window.deleteTrackingRow;
if(typeof baseDelete==='function'){
  window.deleteTrackingRow=function(btn){
    const tr=btn?.closest('tr');
    const no=tr?.querySelector('.t-no')?.value.trim()||'';
    const row=(typeof getTrackingInfo==='function'?getTrackingInfo():[]).find(r=>String(r.no||'').trim()===no);
    const shouldRestore=!!(premium()&&row&&!row.inventoryLegacy&&Array.isArray(row.inventorySnapshot)&&row.inventorySnapshot.length);

    ensureInvoiceCancelModal();
    const modal=document.getElementById('mogaInvoiceCancelModal');
    const text=document.getElementById('mogaInvoiceCancelText');
    const check=document.getElementById('mogaInvoiceCancelCheck');
    const confirmBtn=document.getElementById('mogaInvoiceCancelConfirm');
    if(!modal||!text||!check||!confirmBtn)return;

    text.innerHTML=shouldRestore
      ? `<p>Sąskaita <b>${esc(no||'—')}</b> jau nurašė prekes iš sandėlio.</p><div class="moga-action-summary"><span>Atšaukus sąskaitą:</span><ul><li>prekės bus grąžintos į sandėlį;</li><li>sandėlio likučiai bus perskaičiuoti;</li><li>sąskaitos įrašas bus pašalintas iš SEKIMO INFO.</li></ul></div>`
      : `<p>Ar tikrai norite panaikinti sąskaitą <b>${esc(no||'—')}</b> iš SEKIMO INFO?</p><div class="moga-action-summary"><span>Šiam įrašui automatinio sandėlio nurašymo nėra, todėl sandėlio likučiai nebus keičiami.</span></div>`;

    check.checked=false;
    confirmBtn.disabled=true;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden','false');

    const close=()=>{modal.classList.remove('show');modal.setAttribute('aria-hidden','true');};
    modal.querySelectorAll('[data-moga-cancel-close]').forEach(x=>x.onclick=close);
    check.onchange=()=>{confirmBtn.disabled=!check.checked;};
    modal.onclick=e=>{if(e.target===modal)close();};
    confirmBtn.onclick=()=>{
      if(!check.checked)return;
      confirmBtn.disabled=true;
      if(shouldRestore){
        ensureFifoInitialized();
        const exact=!!(row.fifoVersion===1&&!row.fifoLegacy&&Array.isArray(row.fifoAllocations));
        if(exact)fifoRestoreAllAllocations(JSON.parse(JSON.stringify(row.fifoAllocations||[])));
        row.inventorySnapshot.forEach(x=>{
          const recipe=recipeFromVirtualId(x.productId);
          if(recipe){
            const before=recipeProducedQty(recipe);
            const delta=num(x.qty);
            const after=before+delta;
            addMove({productId:x.productId,type:'invoice-return',delta,before,after,reference:no,invoiceNo:no,note:'SF panaikinta – pagamintas gaminys grąžintas į sandėlį',unitCost:recipeUnitCost(recipe)});
            return;
          }

          const p=findProductById(x.productId);if(!p)return;
          const r=getRecord(x.productId),before=num(r.qty),delta=num(x.qty),after=before+delta;
          let cost=legacyCostForProduct(row,x.productId)||num(p.cost);
          if(!exact)fifoAddLayer(x.productId,delta,cost,{sourceType:'legacy-invoice-cancel',sourceRef:no,receivedAt:now(),note:'Sena SF panaikinta po FIFO įjungimo'});
          else{const a=allocationForProduct(row.fifoAllocations,x.productId);if(a&&num(a.qty)>0)cost=num(a.totalCost)/num(a.qty);}
          patchRecord(x.productId,{qty:after});
          addMove({productId:x.productId,type:'invoice-return',delta,before,after,reference:no,invoiceNo:no,note:'SF panaikinta – prekės grąžintos į sandėlį',unitCost:cost});
        });
      }
      close();
      baseDelete(btn);
      renderInventory();renderInventoryHistory();
    };
  };
}

/* Page navigation extension. */
const baseSwitchPage=window.switchPage;
if(typeof baseSwitchPage==='function'){
  window.switchPage=function(page){
    if(page!=='warehouse')return baseSwitchPage(page);
    if(!premium()){alert('SANDĖLIS prieinamas MOGA SF PREMIUM plane.');return}
    ['invoiceSheet','trackingSheet','statsSheet'].forEach(id=>{
      const el=document.getElementById(id);if(!el)return;
      if(id==='invoiceSheet')el.style.display='none';else el.classList.remove('active');
    });
    const w=document.getElementById('warehouseSheet');if(w)w.classList.add('active');
    ['tabInvoice','tabTracking','tabStats'].forEach(id=>document.getElementById(id)?.classList.remove('active'));
    document.getElementById('tabWarehouse')?.classList.add('active');
    // Perskaitome naujausią būseną ir atnaujiname BŪTENT matomą Sandėlio skiltį.
    // Anksčiau „Prekių informacija“ likdavo su senu DOM iki F5.
    ensureFifoInitialized();
    renderInventory(); // KPI / bendri likučiai
    const activePane=document.querySelector('#warehouseSheet .inventory-pane.active')?.dataset?.invPane||'stock';
    if(activePane==='info')renderProductInfo();
    else if(activePane==='history')renderInventoryHistory();
    else if(activePane==='count')renderInventoryCount();
  };
}
/* When leaving warehouse through existing switchPage, ensure it closes
   and remove the active state from the warehouse tab. */
const inventoryAwareSwitch=window.switchPage;
window.switchPage=function(page){
  const w=document.getElementById('warehouseSheet');
  const tab=document.getElementById('tabWarehouse');

  if(page!=='warehouse'){
    if(w)w.classList.remove('active');
    if(tab)tab.classList.remove('active');
  }

  return inventoryAwareSwitch(page);
};

function lowStockApplies(p,settings){
  if((settings.lowStockScope||'all')!=='selected')return true;
  return Array.isArray(settings.lowStockSelected)&&settings.lowStockSelected.includes(p.inventoryId);
}
function effectiveInventoryMin(r,settings=getStore().settings||{}){
  const raw=r?.min;
  const fallback=Math.max(0,num(settings.defaultMin));
  if(raw===null||raw===undefined||raw===''||num(raw)<0)return fallback;
  return Math.max(0,num(raw));
}

function inventoryDisplayedMin(p,r,settingsOverride=null){
  const settings=settingsOverride||getStore().settings||{};
  if(!lowStockApplies(p,settings))return '—';

  const mode=settings.lowStockMode||'individual';
  if(mode==='off')return '—';

  if(mode==='quantity'){
    return Math.max(0,num(settings.lowStockQty));
  }

  if(mode==='percent'){
    const pct=Math.max(0,Math.min(100,num(settings.lowStockPercent)));
    const target=Math.max(0,num(r.target)||effectiveInventoryMin(r,settings));
    return target>0?(target*pct/100):0;
  }

  return effectiveInventoryMin(r,settings);
}

function inventoryStatus(p,r,settingsOverride=null){
  const a=num(r.qty)-num(r.reserved),settings=settingsOverride||getStore().settings||{};
  if(a<=0)return{key:'out',label:'NĖRA',reason:'Nėra laisvo likučio'};

  const mode=settings.lowStockMode||'individual';
  if(mode==='off'||!lowStockApplies(p,settings))return{key:'ok',label:'GERAS',reason:'Įspėjimas šiai prekei netaikomas'};

  let isLow=false,reason='';
  if(mode==='quantity'){
    const q=Math.max(0,num(settings.lowStockQty));
    isLow=a<=q;reason=`Riba: ${q} vnt.`;
  }else if(mode==='percent'){
    const pct=Math.max(0,Math.min(100,num(settings.lowStockPercent)));
    const target=Math.max(0,num(r.target)||effectiveInventoryMin(r,settings));
    if(target>0){
      const limit=target*pct/100;
      isLow=a<=limit;
      reason=`${pct}% nuo tikslinio ${target} vnt. (riba ${limit.toLocaleString('lt-LT',{maximumFractionDigits:2})})`;
    }else{
      isLow=false;reason='Nenustatytas tikslinis kiekis';
    }
  }else{
    const inherited=(r?.min===null||r?.min===undefined||r?.min===''||num(r.min)<0);
    const min=effectiveInventoryMin(r,settings);
    isLow=min>0&&a<=min;
    reason=inherited
      ?`Numatytas minimumas: ${min} vnt.`
      :`Individualus minimumas: ${min} vnt.`;
  }
  return isLow?{key:'low',label:'MAŽAS',reason}:{key:'ok',label:'GERAS',reason};
}
function inventoryRows(){
  const store=getStore();
  const physical=products().map(p=>({p,r:store.records[p.inventoryId]||{qty:0,reserved:0,min:-1,target:0,location:'',barcode:'',notes:''}}));
  const recipes=manufacturingRecipes().filter(r=>r&&r.archived!==true&&r.active!==false).map(r=>{
    const virtualId=`recipe:${r.id}`;
    const produced=recipeProducedQty(r);
    const buildable=recipeBuildableQty(r);
    const materialCost=recipeMaterialNeeds(r,1).reduce((sum,n)=>sum+num(n.qty)*num(findProductById(n.productId)?.cost),0)+Math.max(0,num(r.cost));
    const p={inventoryId:virtualId,name:String(r.name||'Gaminys'),sku:String(r.code||''),category:'Gaminiai',unit:String(r.unit||'vnt.'),cost:materialCost,price:num(r.salePrice??r.price),_virtualRecipe:true,recipeId:r.id,_buildableQty:buildable};
    const rr={qty:produced,reserved:0,min:0,target:0,location:'',barcode:'',notes:'Pagamintas kiekis pagal gamybos istoriją'};
    return{p,r:rr};
  });
  const projects=manufacturingProjects().filter(p=>p&&p.archived!==true&&projectProductionEvent(p)).map(p=>{
    const ev=projectProductionEvent(p),virtualId=virtualProjectId(p),produced=projectProducedQty(p),cost=projectUnitCost(p),plan=p.productionPlan||p;
    const pp={inventoryId:virtualId,name:String(plan.name||p.name||'Individualus gaminys'),sku:String(p.code||''),category:'Individualūs gaminiai',unit:String(plan.unit||p.unit||'vnt.'),cost,price:num(plan.price??p.price),_virtualProject:true,projectId:p.id};
    const rr={qty:produced,reserved:0,min:0,target:0,location:'',barcode:'',notes:`Individualus projektas · FIFO savikaina ${cost.toFixed(2)} €`};return{p:pp,r:rr};
  });
  return [...physical,...recipes,...projects];
}
function renderInventory(){
  if(!premium())return;
  ensureProductIds();
  const rows=inventoryRows();
  const settings=getStore().settings||{};
  const search=norm(document.getElementById('inventorySearch')?.value);
  const cat=document.getElementById('inventoryCategory')?.value||'all';
  const status=document.getElementById('inventoryStatus')?.value||'all';
  const lowOnly=!!document.getElementById('inventoryLowOnly')?.checked;

  const categories=[...new Set(rows.map(x=>x.p.category).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt'));
  const catEl=document.getElementById('inventoryCategory');
  if(catEl){
    const current=catEl.value||'all';
    catEl.innerHTML='<option value="all">Visos kategorijos</option>'+categories.map(c=>`<option value="${esc(c)}">${esc(c)}</option>`).join('');
    catEl.value=categories.includes(current)?current:'all';
  }

  const filtered=rows.filter(({p,r})=>{
    const st=inventoryStatus(p,r,settings);
    const hay=norm([p.name,p.sku,p.category,r.location,r.barcode].join(' '));
    if(search&&!hay.includes(search))return false;
    if(cat!=='all'&&p.category!==cat)return false;
    if(status!=='all'&&st.key!==status)return false;
    if(lowOnly&&!['low','out'].includes(st.key))return false;
    return true;
  });

  let units=0,costValue=0,retailValue=0,low=0,out=0,reserved=0;
  rows.forEach(({p,r})=>{
    if(!p._virtualRecipe){
      units+=num(r.qty);reserved+=num(r.reserved);
      costValue+=num(r.qty)*num(p.cost);
      retailValue+=num(r.qty)*num(p.price);
    }
    const st=inventoryStatus(p,r,settings);if(st.key==='low')low++;if(st.key==='out')out++;
  });
  const put=(id,v)=>{const e=document.getElementById(id);if(e)e.textContent=v};
  put('invStatProducts',rows.length);
  put('invStatUnits',units.toLocaleString('lt-LT'));
  put('invStatReserved',reserved.toLocaleString('lt-LT'));
  put('invStatCost',money(costValue));
  put('invStatRetail',money(retailValue));
  put('invStatAlerts',low+out);

  const alert=document.getElementById('inventoryAlert');
  if(alert){
    if(low+out){
      alert.classList.add('show');
      alert.innerHTML=`<b>Reikia dėmesio:</b> ${out} prek. be laisvo likučio ir ${low} prek. pasiekė minimalų likutį.`;
    }else alert.classList.remove('show');
  }

  const tb=document.getElementById('inventoryBody');if(!tb)return;
  if(!filtered.length){tb.innerHTML='<tr><td colspan="12"><div class="inventory-empty">Pagal pasirinktus filtrus prekių nėra.</div></td></tr>';return}
  tb.innerHTML=filtered.map(({p,r})=>{
    const st=inventoryStatus(p,r,settings),a=num(r.qty)-num(r.reserved),value=num(r.qty)*num(p.cost);
    return `<tr class="${st.key==='low'?'low-stock':st.key==='out'?'out-stock':''}">
      <td><div class="inventory-product-name">${esc(p.name)}${p._virtualRecipe?' <span class="inventory-recipe-badge">GAMINYS</span>':p._virtualProject?' <span class="inventory-recipe-badge">INDIVIDUALUS</span>':''}</div>${(p._virtualRecipe||p._virtualProject)?'':`<div class="inventory-product-meta">${esc([p.sku,p.category].filter(Boolean).join(' · ')||'Be SKU / kategorijos')}</div>`}</td>
      <td class="inventory-center">${esc(p.sku||'—')}</td>
      <td class="inventory-center"><span class="inventory-status-pill ${st.key}" title="${esc(st.reason||'')}">${st.label}</span></td>
      <td class="inventory-qty ${a<0?'negative':st.key==='low'?'low':''}">${num(r.qty).toLocaleString('lt-LT')}</td>
      <td class="inventory-center">${num(r.reserved).toLocaleString('lt-LT')}</td>
      <td class="inventory-qty ${a<0?'negative':''}">${a.toLocaleString('lt-LT')}</td>
      <td class="inventory-center" title="Aktyvi įspėjimo riba pagal pasirinktą „MAŽAS“ režimą">${(()=>{
        const m=inventoryDisplayedMin(p,r,settings);
        return typeof m==='number'
          ?m.toLocaleString('lt-LT',{maximumFractionDigits:2})
          :m;
      })()}</td>
      <td class="inventory-money">${money(p.cost)}</td>
      <td class="inventory-money">${money(value)}</td>
      <td class="inventory-location" title="${esc(r.location||'')}">${esc(r.location||'—')}</td>
      <td class="inventory-center">${esc(r.barcode||'—')}</td>
      <td><div class="inventory-actions">
        ${(p._virtualRecipe||p._virtualProject)?`<button class="inventory-row-btn history" title="Atidaryti gamybą" onclick="switchPage('manufacturing')">⚙</button>`:`<button class="inventory-row-btn edit" title="Koreguoti / priimti / nurašyti" onclick="openInventoryEditor('${p.inventoryId}')">±</button><button class="inventory-row-btn history" title="Prekės istorija" onclick="showProductHistory('${p.inventoryId}')">↕</button>`}
      </div></td>
    </tr>`;
  }).join('');
}
window.renderInventory=renderInventory;


/* ---------------- PREKIŲ KATEGORIJŲ REGISTRAS ---------------- */
const PRODUCT_CATEGORY_KEY='moga_product_categories_v1';

function productCategoryRegistry(){
  let saved=[];
  try{
    const x=JSON.parse(localStorage.getItem(PRODUCT_CATEGORY_KEY)||'[]');
    if(Array.isArray(x))saved=x.map(v=>String(v||'').trim()).filter(Boolean);
  }catch(_){}
  const used=products().map(p=>String(p.category||'').trim()).filter(Boolean);
  return [...new Set([...saved,...used])].sort((a,b)=>a.localeCompare(b,'lt'));
}
function saveProductCategoryRegistry(arr){
  const clean=[...new Set((arr||[]).map(v=>String(v||'').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt'));
  localStorage.setItem(PRODUCT_CATEGORY_KEY,JSON.stringify(clean));
  return clean;
}
function ensureProductCategory(name){
  const v=String(name||'').trim();if(!v)return;
  const arr=productCategoryRegistry();
  if(!arr.some(x=>norm(x)===norm(v)))arr.push(v);
  saveProductCategoryRegistry(arr);
}
function ensureProductCategoryManagerUi(){
  const input=document.getElementById('productInfoBulkCategory');
  if(!input)return;

  if(!document.getElementById('productInfoCategoryPicker')){
    const wrap=document.createElement('div');
    wrap.id='productInfoCategoryPicker';
    wrap.className='product-info-category-picker';
    input.parentElement.insertBefore(wrap,input);
    wrap.appendChild(input);

    const arrow=document.createElement('button');
    arrow.type='button';
    arrow.className='product-info-category-arrow';
    arrow.setAttribute('aria-label','Rodyti kategorijas');
    arrow.textContent='▼';
    arrow.onclick=(e)=>{
      e.preventDefault();e.stopPropagation();
      toggleProductInfoCategoryMenu();
    };
    wrap.appendChild(arrow);

    const menu=document.createElement('div');
    menu.id='productInfoCategoryMenu';
    menu.className='product-info-category-menu';
    wrap.appendChild(menu);

    input.removeAttribute('list');
    input.addEventListener('focus',()=>renderProductInfoCategoryMenu(false));
    input.addEventListener('input',()=>renderProductInfoCategoryMenu(false));
    input.addEventListener('keydown',e=>{
      if(e.key==='Escape')closeProductInfoCategoryMenu();
      if(e.key==='ArrowDown'){e.preventDefault();renderProductInfoCategoryMenu(true);}
    });
  }

  if(document.getElementById('productCategoryManageBtn'))return;
  const btn=document.createElement('button');
  btn.id='productCategoryManageBtn';
  btn.type='button';
  btn.className='product-category-manage-btn';
  btn.textContent='⚙ KATEGORIJOS';
  btn.onclick=openProductCategoryManager;
  document.getElementById('productInfoCategoryPicker').insertAdjacentElement('afterend',btn);

  const modal=document.createElement('div');
  modal.id='productCategoryModal';
  modal.className='moga-category-modal';
  modal.innerHTML=`
    <div class="moga-category-modal-window">
      <div class="moga-category-modal-head">
        <div><small>MOGA SF</small><h3>PREKIŲ KATEGORIJOS</h3></div>
        <button type="button" class="moga-category-close" onclick="closeProductCategoryManager()">×</button>
      </div>
      <div class="moga-category-add">
        <input id="productCategoryNew" placeholder="Naujos kategorijos pavadinimas">
        <button type="button" onclick="addProductCategory()">+ PRIDĖTI</button>
      </div>
      <div id="productCategoryList" class="moga-category-list"></div>
    </div>`;
  document.body.appendChild(modal);
  modal.addEventListener('mousedown',e=>{if(e.target===modal)closeProductCategoryManager();});
}
function positionProductInfoCategoryMenu(){
  const menu=document.getElementById('productInfoCategoryMenu');
  const input=document.getElementById('productInfoBulkCategory');
  if(!menu||!input)return;
  // Portal į BODY: taip dropdown nebegali būti nukirstas sandėlio lentelės overflow/sticky headerio.
  if(menu.parentElement!==document.body)document.body.appendChild(menu);
  const r=input.getBoundingClientRect();
  const gap=6;
  const maxW=Math.max(220,r.width);
  menu.style.setProperty('position','fixed','important');
  menu.style.setProperty('left',`${Math.round(r.left)}px`,'important');
  menu.style.setProperty('top',`${Math.round(r.bottom+gap)}px`,'important');
  menu.style.setProperty('width',`${Math.round(maxW)}px`,'important');
  menu.style.setProperty('right','auto','important');
  menu.style.setProperty('z-index','2147483646','important');
}
function renderProductInfoCategoryMenu(forceOpen=true){
  const menu=document.getElementById('productInfoCategoryMenu');
  const input=document.getElementById('productInfoBulkCategory');
  if(!menu||!input)return;
  positionProductInfoCategoryMenu();
  const q=norm(input.value);
  const cats=productCategoryRegistry().filter(c=>!q||norm(c).includes(q));
  menu.innerHTML=cats.length
    ?cats.map(c=>`<button type="button" data-cat="${esc(c)}">${esc(c)}</button>`).join('')
    :'<div class="product-info-category-empty">Kategorijų nėra</div>';
  menu.querySelectorAll('[data-cat]').forEach(btn=>btn.addEventListener('mousedown',e=>{
    e.preventDefault();
    input.value=btn.dataset.cat||'';
    closeProductInfoCategoryMenu();
    input.focus();
  }));
  if(forceOpen||document.activeElement===input){
    menu.classList.add('open');
    positionProductInfoCategoryMenu();
  }
}
function toggleProductInfoCategoryMenu(){
  const menu=document.getElementById('productInfoCategoryMenu');
  if(!menu)return;
  if(menu.classList.contains('open'))closeProductInfoCategoryMenu();
  else renderProductInfoCategoryMenu(true);
}
function closeProductInfoCategoryMenu(){document.getElementById('productInfoCategoryMenu')?.classList.remove('open')}
document.addEventListener('mousedown',e=>{
  const picker=document.getElementById('productInfoCategoryPicker');
  const menu=document.getElementById('productInfoCategoryMenu');
  if(picker&&!picker.contains(e.target)&&!(menu&&menu.contains(e.target)))closeProductInfoCategoryMenu();
},true);
window.addEventListener('resize',()=>{if(document.getElementById('productInfoCategoryMenu')?.classList.contains('open'))positionProductInfoCategoryMenu();});
window.addEventListener('scroll',()=>{if(document.getElementById('productInfoCategoryMenu')?.classList.contains('open'))positionProductInfoCategoryMenu();},true);

function openProductCategoryManager(){
  ensureProductCategoryManagerUi();
  renderProductCategoryManager();
  document.getElementById('productCategoryModal')?.classList.add('open');
  setTimeout(()=>document.getElementById('productCategoryNew')?.focus(),30);
}
window.openProductCategoryManager=openProductCategoryManager;
function closeProductCategoryManager(){document.getElementById('productCategoryModal')?.classList.remove('open')}
window.closeProductCategoryManager=closeProductCategoryManager;

function renderProductCategoryManager(){
  const box=document.getElementById('productCategoryList');if(!box)return;
  const cats=productCategoryRegistry();
  const counts={};products().forEach(p=>{const c=String(p.category||'').trim();if(c)counts[c]=(counts[c]||0)+1;});
  box.innerHTML=cats.length?cats.map((c,i)=>`
    <div class="moga-category-row">
      <div class="moga-category-main">
        <input id="productCategoryEdit_${i}" value="${esc(c)}">
        <span>${counts[c]||0} prek.</span>
      </div>
      <div class="moga-category-actions">
        <button type="button" onclick="renameProductCategory(${i},'${esc(c).replace(/'/g,'&#39;')}')">IŠSAUGOTI</button>
        <button type="button" class="danger" onclick="deleteProductCategory('${esc(c).replace(/'/g,'&#39;')}')">IŠTRINTI</button>
      </div>
    </div>`).join(''):'<div class="purchase-empty">Kategorijų dar nėra.</div>';
}
async function addProductCategory(){
  const input=document.getElementById('productCategoryNew');
  const name=String(input?.value||'').trim();
  if(!name)return alert('Įrašyk kategorijos pavadinimą.');
  if(productCategoryRegistry().some(x=>norm(x)===norm(name)))return alert('Tokia kategorija jau yra.');
  ensureProductCategory(name);
  if(input)input.value='';
  renderProductCategoryManager();refreshProductInfoFilters();
}
window.addProductCategory=addProductCategory;

async function renameProductCategory(i,oldName){
  const input=document.getElementById(`productCategoryEdit_${i}`);
  const nextName=String(input?.value||'').trim();
  if(!nextName)return alert('Kategorijos pavadinimas negali būti tuščias.');
  if(norm(nextName)===norm(oldName)){renderProductCategoryManager();return;}
  if(productCategoryRegistry().some(x=>norm(x)===norm(nextName)&&norm(x)!==norm(oldName)))return alert('Tokia kategorija jau yra.');

  const affected=products().filter(p=>norm(p.category)===norm(oldName)).length;
  const ok=window.MOGA_UI?.confirm
    ?await window.MOGA_UI.confirm(`Pervadinti kategoriją „${oldName}“ į „${nextName}“?\n\nAutomatiškai bus pakeista ${affected} prekėms.`,{title:'Pervadinti kategoriją',confirmText:'PERVADINTI'})
    :confirm(`Pervadinti kategoriją „${oldName}“ į „${nextName}“?`);
  if(!ok)return;

  const nextProducts=products().map(p=>norm(p.category)===norm(oldName)?{...p,category:nextName}:p);
  window.setProducts?.(nextProducts);

  const cats=productCategoryRegistry().filter(x=>norm(x)!==norm(oldName));
  cats.push(nextName);saveProductCategoryRegistry(cats);

  renderProductCategoryManager();refreshProductInfoFilters();renderProductInfo();
}
window.renameProductCategory=renameProductCategory;

async function deleteProductCategory(name){
  const affected=products().filter(p=>norm(p.category)===norm(name)).length;
  const ok=window.MOGA_UI?.confirm
    ?await window.MOGA_UI.confirm(
      affected?`Ištrinti kategoriją „${name}“?\n\nJi šiuo metu priskirta ${affected} prekėms. Toms prekėms kategorija bus išvalyta.`:`Ištrinti kategoriją „${name}“?`,
      {title:'Ištrinti kategoriją',danger:true,requireCheck:affected>0,checkText:affected>0?'Patvirtinu kategorijos pašalinimą nuo prekių':'Patvirtinu ištrynimą',confirmText:'IŠTRINTI'}
    )
    :confirm(`Ištrinti kategoriją „${name}“?`);
  if(!ok)return;

  if(affected){
    const nextProducts=products().map(p=>norm(p.category)===norm(name)?{...p,category:''}:p);
    window.setProducts?.(nextProducts);
  }
  saveProductCategoryRegistry(productCategoryRegistry().filter(x=>norm(x)!==norm(name)));
  renderProductCategoryManager();refreshProductInfoFilters();renderProductInfo();
}
window.deleteProductCategory=deleteProductCategory;

/* ---------------- PREKIŲ INFORMACIJA / MASINIS REDAGAVIMAS ---------------- */
const productInfoSelection=new Set();

function productInfoSupplierMap(){
  const map=new Map();
  try{
    const api=window.MOGA_PURCHASES;
    const links=api?.links?.()||[];
    const suppliers=api?.suppliers?.()||[];
    const names=new Map(suppliers.map(s=>[String(s.id),String(s.name||'')]));
    links.forEach(l=>{
      const pid=String(l.productId||'');if(!pid)return;
      const name=names.get(String(l.supplierId||''))||'';
      if(!name)return;
      if(!map.has(pid))map.set(pid,new Set());
      map.get(pid).add(name);
    });
  }catch(_){}
  return map;
}
function productInfoSupplierNames(p,map){
  return [...(map.get(String(p.inventoryId||''))||new Set())].sort((a,b)=>a.localeCompare(b,'lt'));
}
function productInfoVisibleColumns(){
  const defaults=['sku','category','supplier','cost','price'];
  const checked=[...document.querySelectorAll('[data-product-info-col]')].filter(x=>x.checked).map(x=>x.dataset.productInfoCol);
  return checked.length?checked:defaults;
}
function productInfoFilteredRows(){
  ensureProductIds();
  const all=products();
  const smap=productInfoSupplierMap();
  const q=norm(document.getElementById('productInfoSearch')?.value);
  const cat=document.getElementById('productInfoCategory')?.value||'all';
  const sup=document.getElementById('productInfoSupplier')?.value||'all';
  const costFilter=document.getElementById('productInfoCostFilter')?.value||'all';
  return all.map(p=>({p,suppliers:productInfoSupplierNames(p,smap)})).filter(x=>{
    const hay=norm([x.p.name,x.p.sku,x.p.category,...x.suppliers].join(' '));
    if(q&&!hay.includes(q))return false;
    if(cat==='__empty__'&&String(x.p.category||'').trim())return false;
    if(cat!=='all'&&cat!=='__empty__'&&String(x.p.category||'')!==cat)return false;
    if(sup==='__none__'&&x.suppliers.length)return false;
    if(sup!=='all'&&sup!=='__none__'&&!x.suppliers.includes(sup))return false;
    if(costFilter==='missing'&&num(x.p.cost)>0.000001)return false;
    if(costFilter==='set'&&num(x.p.cost)<=0.000001)return false;
    return true;
  });
}
function refreshProductInfoFilters(){
  const all=products();
  const smap=productInfoSupplierMap();
  const categories=productCategoryRegistry();
  const supplierNames=[...new Set(all.flatMap(p=>productInfoSupplierNames(p,smap)))].sort((a,b)=>a.localeCompare(b,'lt'));

  const cat=document.getElementById('productInfoCategory');
  if(cat){
    const cur=cat.value||'all';
    cat.innerHTML='<option value="all">Visos kategorijos</option><option value="__empty__">Be kategorijos</option>'+categories.map(c=>`<option value="${esc(c)}">${esc(c)}</option>`).join('');
    if(cur==='__empty__'||categories.includes(cur))cat.value=cur;else cat.value='all';
  }
  const sup=document.getElementById('productInfoSupplier');
  if(sup){
    const cur=sup.value||'all';
    sup.innerHTML='<option value="all">Visi tiekėjai</option><option value="__none__">Be tiekėjo susiejimo</option>'+supplierNames.map(s=>`<option value="${esc(s)}">${esc(s)}</option>`).join('');
    if(cur==='__none__'||supplierNames.includes(cur))sup.value=cur;else sup.value='all';
  }
  const dl=document.getElementById('productInfoCategoryList');
  if(dl)dl.innerHTML=categories.map(c=>`<option value="${esc(c)}"></option>`).join('');
}
function ensureProductInfoPlaceholders(){
  const search=document.getElementById('productInfoSearch');
  if(search)search.setAttribute('placeholder','Ieškoti prekių...');
  const bulk=document.getElementById('productInfoBulkCategory');
  if(bulk)bulk.setAttribute('placeholder','Įrašyk / pasirink kategoriją');
}
function ensureProductInfoCostFilter(){
  const filters=document.querySelector('#warehouseSheet .product-info-filters');
  if(!filters||document.getElementById('productInfoCostFilter'))return;
  const sel=document.createElement('select');
  sel.id='productInfoCostFilter';
  sel.innerHTML='<option value="all">Visos savikainos</option><option value="missing">Be savikainos</option><option value="set">Su savikaina</option>';
  sel.addEventListener('change',renderProductInfo);
  filters.appendChild(sel);
}
function ensureProductInfoBulkDeleteUi(){
  const selection=document.querySelector('#warehouseSheet .product-info-selection');
  if(!selection||document.getElementById('productInfoBulkDeleteBtn'))return;
  const btn=document.createElement('button');
  btn.id='productInfoBulkDeleteBtn';
  btn.type='button';
  btn.className='product-info-delete-btn';
  btn.textContent='IŠTRINTI PAŽYMĖTAS';
  btn.onclick=openBulkDeleteProductInfoModal;
  selection.appendChild(btn);
}

function ensureProductInfoBulkCostUi(){
  const action=document.querySelector('#warehouseSheet .product-info-category-action');
  if(!action||document.getElementById('productInfoBulkCost'))return;
  const wrap=document.createElement('div');
  wrap.className='product-info-cost-action';
  wrap.innerHTML=`
    <label for="productInfoBulkCost">Masinis savikainos nustatymas</label>
    <input id="productInfoBulkCost" type="number" min="0" step="0.01" placeholder="Savikaina, €">
    <button type="button" class="gold" onclick="bulkSetProductInfoOpeningCost()">NUSTATYTI SAVIKAINĄ</button>`;
  action.insertAdjacentElement('afterend',wrap);
}
function ensureProductInfoKpis(){
  const found=document.getElementById('productInfoFound');
  if(!found||!found.parentElement)return;
  const parent=found.parentElement;

  let noCat=document.getElementById('productInfoNoCategoryKpi');
  if(!noCat){
    noCat=document.createElement('div');
    noCat.id='productInfoNoCategoryKpi';
    noCat.className='product-info-mini-kpi';
    parent.appendChild(noCat);
  }

  let noSupplier=document.getElementById('productInfoNoSupplierKpi');
  if(!noSupplier){
    noSupplier=document.createElement('div');
    noSupplier.id='productInfoNoSupplierKpi';
    noSupplier.className='product-info-mini-kpi';
    parent.appendChild(noSupplier);
  }
}

function updateProductInfoKpis(){
  ensureProductIds();
  ensureProductInfoKpis();
  const all=products();
  const smap=productInfoSupplierMap();
  const noCategory=all.filter(p=>!String(p.category||'').trim()).length;
  const noSupplier=all.filter(p=>productInfoSupplierNames(p,smap).length===0).length;

  const noCat=document.getElementById('productInfoNoCategoryKpi');
  if(noCat)noCat.innerHTML=`Be kategorijos: <strong>${noCategory}</strong>`;

  const noSup=document.getElementById('productInfoNoSupplierKpi');
  if(noSup)noSup.innerHTML=`Be tiekėjo: <strong>${noSupplier}</strong>`;
}

function productInfoCostEditState(productId,storeOverride=null){
  const store=storeOverride||getFifoStore();
  const st=fifoState(store,String(productId||''),false);
  const layers=(st?.layers||[]);
  const nonOpening=layers.filter(l=>String(l.sourceType||'')!=='opening');
  return{editable:nonOpening.length===0,layers,nonOpening};
}
function productInfoCostCell(p,fifoStoreSnapshot){
  const state=productInfoCostEditState(p.inventoryId,fifoStoreSnapshot);
  const title=fifoSummaryText(p.inventoryId,fifoStoreSnapshot)+(state.editable?'\nSpustelk savikainą ir įrašyk pradinę FIFO savikainą.':'\nSavikaina užrakinta: jau yra ne pradinio likučio FIFO partijų.');
  if(!state.editable)return `<td class="inventory-money product-info-cost-locked" title="${esc(title)}">${money(p.cost)} <small class="product-info-muted">FIFO 🔒</small></td>`;
  return `<td class="inventory-money product-info-cost-editable" title="${esc(title)}"><input class="product-info-cost-input" type="number" min="0" step="0.01" value="${num(p.cost).toFixed(2)}" data-product-id="${esc(p.inventoryId)}" aria-label="${esc(p.name)} savikaina" onkeydown="if(event.key==='Enter'){this.blur()}" onchange="saveProductInfoOpeningCost('${esc(p.inventoryId)}',this.value,this)"><small class="product-info-muted">FIFO</small></td>`;
}
function saveProductInfoOpeningCost(productId,value,input){
  const id=String(productId||'');
  const v=Math.max(0,num(value));
  const store=getFifoStore();
  const st=fifoState(store,id,false);
  const layers=(st?.layers||[]);
  if(layers.some(l=>String(l.sourceType||'')!=='opening')){
    if(input){const p=findProductById(id);input.value=num(p?.cost).toFixed(2)}
    alert('Šios prekės savikaina jau turi realių FIFO partijų. Keisti ją reikia per pirkimo / priėmimo istoriją.');
    return false;
  }
  let touched=false;
  layers.forEach(l=>{if(String(l.sourceType||'')==='opening'){l.unitCost=v;touched=true}});
  if(touched)setFifoStore(store);
  setCatalogCostDirect(id,v);
  // Jeigu yra pradinis FIFO likutis, katalogo savikaina turi sutapti su perskaičiuotu FIFO vidurkiu.
  if(touched)fifoSyncProductCost(id);
  if(input)input.value=v.toFixed(2);
  try{renderProductInfo()}catch(_){}
  try{renderInventory()}catch(_){}
  return true;
}
window.saveProductInfoOpeningCost=saveProductInfoOpeningCost;

function renderProductInfo(){
  ensureProductInfoPlaceholders();
  ensureProductInfoCostFilter();
  ensureProductInfoBulkCostUi();
  ensureProductInfoBulkDeleteUi();
  ensureProductCategoryManagerUi();
  ensureProductInfoKpis();
  if(!premium())return;
  refreshProductInfoFilters();
  const rows=productInfoFilteredRows();
  const fifoStoreSnapshot=getFifoStore();
  const cat=document.getElementById('productInfoCategory')?.value||'all';
  const sup=document.getElementById('productInfoSupplier')?.value||'all';
  const filtered=rows;

  const cols=productInfoVisibleColumns();
  const labels={sku:'SKU',category:'Kategorija',supplier:'Tiekėjas',cost:'Savikaina',price:'Pardavimo kaina'};
  const head=document.getElementById('productInfoHead');
  if(head)head.innerHTML=`<tr><th class="product-info-check-col"><input id="productInfoVisibleCheck" type="checkbox" title="Pažymėti / nuimti visas šiuo metu matomas" onchange="toggleVisibleProductInfo(this.checked)"></th><th>Prekė</th>${cols.map(c=>`<th>${labels[c]}</th>`).join('')}</tr>`;

  const body=document.getElementById('productInfoBody');
  if(body){
    if(!filtered.length)body.innerHTML=`<tr><td colspan="${2+cols.length}"><div class="inventory-empty">Pagal pasirinktus filtrus prekių nėra.</div></td></tr>`;
    else body.innerHTML=filtered.map(({p,suppliers})=>`<tr>
      <td class="product-info-check-col"><input type="checkbox" data-product-info-id="${esc(p.inventoryId)}" ${productInfoSelection.has(String(p.inventoryId))?'checked':''} onchange="toggleProductInfoSelection('${esc(p.inventoryId)}',this.checked)"></td>
      <td><div class="inventory-product-name">${esc(p.name)}</div></td>
      ${cols.map(c=>{
        if(c==='sku')return `<td>${esc(p.sku||'—')}</td>`;
        if(c==='category')return `<td><span class="product-info-pill">${esc(p.category||'Be kategorijos')}</span></td>`;
        if(c==='supplier')return `<td>${suppliers.length?suppliers.map(s=>`<span class="product-info-supplier">${esc(s)}</span>`).join(' '):'<span class="product-info-muted">Nesusieta</span>'}</td>`;
        if(c==='cost')return productInfoCostCell(p,fifoStoreSnapshot);
        if(c==='price')return `<td class="inventory-money">${money(p.price)}</td>`;
        return '<td>—</td>';
      }).join('')}
    </tr>`).join('');
  }
  const found=document.getElementById('productInfoFound');if(found)found.textContent=`Rasta: ${filtered.length}`;
  const selected=document.getElementById('productInfoSelected');if(selected)selected.textContent=`Pažymėta: ${productInfoSelection.size}`;
  updateProductInfoKpis();
  const visibleIds=new Set(filtered.map(x=>String(x.p.inventoryId)));
  const chk=document.getElementById('productInfoVisibleCheck');
  if(chk){const cnt=[...visibleIds].filter(id=>productInfoSelection.has(id)).length;chk.checked=filtered.length>0&&cnt===filtered.length;chk.indeterminate=cnt>0&&cnt<filtered.length;}
}
window.renderProductInfo=renderProductInfo;

window.addEventListener('moga:supplier-links-change',()=>{
  try{
    if(document.getElementById('productInfoBody'))renderProductInfo();
  }catch(err){console.warn('Prekių informacija: nepavyko atnaujinti tiekėjų',err);}
});


function toggleProductInfoSelection(id,on){
  id=String(id||'');if(!id)return;
  if(on)productInfoSelection.add(id);else productInfoSelection.delete(id);
  const selected=document.getElementById('productInfoSelected');if(selected)selected.textContent=`Pažymėta: ${productInfoSelection.size}`;
}
window.toggleProductInfoSelection=toggleProductInfoSelection;

function productInfoCurrentFilteredIds(){
  const rows=productInfoFilteredRows();
  const cat=document.getElementById('productInfoCategory')?.value||'all';
  const sup=document.getElementById('productInfoSupplier')?.value||'all';
  return rows.filter(x=>(cat!=='__empty__'||!String(x.p.category||'').trim())&&(sup!=='__none__'||!x.suppliers.length)).map(x=>String(x.p.inventoryId));
}
function toggleVisibleProductInfo(on){
  productInfoCurrentFilteredIds().forEach(id=>on?productInfoSelection.add(id):productInfoSelection.delete(id));
  renderProductInfo();
}
window.toggleVisibleProductInfo=toggleVisibleProductInfo;
function selectAllFilteredProductInfo(){productInfoCurrentFilteredIds().forEach(id=>productInfoSelection.add(id));renderProductInfo()}
window.selectAllFilteredProductInfo=selectAllFilteredProductInfo;
function clearProductInfoSelection(){productInfoSelection.clear();renderProductInfo()}
window.clearProductInfoSelection=clearProductInfoSelection;

function productInfoDeleteCandidates(){
  const ids=[...productInfoSelection].map(String);
  const pmap=new Map(products().map(p=>[String(p.inventoryId||''),p]));
  const inv=getStore();
  return ids.map(id=>{
    const p=pmap.get(id);
    if(!p)return null;
    const r=inv.records?.[id]||{};
    const qty=num(r.qty),reserved=num(r.reserved);
    return{p,id,qty,reserved,blocked:Math.abs(qty)>1e-9||Math.abs(reserved)>1e-9};
  }).filter(Boolean);
}
let productInfoDeleteSuccessTimer=null;
function closeBulkDeleteProductInfoModal(){
  document.getElementById('productInfoDeleteModal')?.remove();
}
window.closeBulkDeleteProductInfoModal=closeBulkDeleteProductInfoModal;
function closeBulkDeleteProductInfoSuccessModal(){
  if(productInfoDeleteSuccessTimer){clearInterval(productInfoDeleteSuccessTimer);productInfoDeleteSuccessTimer=null;}
  document.getElementById('productInfoDeleteSuccessModal')?.remove();
}
window.closeBulkDeleteProductInfoSuccessModal=closeBulkDeleteProductInfoSuccessModal;
function openBulkDeleteProductInfoSuccessModal(count){
  closeBulkDeleteProductInfoSuccessModal();
  const modal=document.createElement('div');
  modal.id='productInfoDeleteSuccessModal';
  modal.className='product-info-delete-overlay';
  modal.innerHTML=`<div class="product-info-delete-modal product-info-delete-success-modal" role="dialog" aria-modal="true" aria-labelledby="productInfoDeleteSuccessTitle">
    <div class="product-info-delete-head">
      <div><div class="product-info-delete-kicker">MOGA SF PREMIUM</div><h3 id="productInfoDeleteSuccessTitle">Prekės ištrintos ✓</h3></div>
      <button type="button" class="product-info-delete-x" onclick="closeBulkDeleteProductInfoSuccessModal()" aria-label="Uždaryti">×</button>
    </div>
    <div class="product-info-delete-success-body">
      <div class="product-info-delete-success-check">✓</div>
      <div>
        <div class="product-info-delete-success-title">Ištrinta ${Number(count)||0} prek.</div>
        <div class="product-info-delete-success-copy">Langas automatiškai užsidarys po <strong id="productInfoDeleteSuccessCountdown">3</strong> s.</div>
      </div>
    </div>
    <div class="product-info-delete-actions">
      <button type="button" class="danger" onclick="closeBulkDeleteProductInfoSuccessModal()">GERAI</button>
    </div>
  </div>`;
  modal.addEventListener('click',e=>{if(e.target===modal)closeBulkDeleteProductInfoSuccessModal()});
  document.body.appendChild(modal);
  let left=3;
  productInfoDeleteSuccessTimer=setInterval(()=>{
    left-=1;
    const el=document.getElementById('productInfoDeleteSuccessCountdown');
    if(el)el.textContent=String(Math.max(0,left));
    if(left<=0)closeBulkDeleteProductInfoSuccessModal();
  },1000);
}
window.openBulkDeleteProductInfoSuccessModal=openBulkDeleteProductInfoSuccessModal;
function openBulkDeleteProductInfoModal(){
  const rows=productInfoDeleteCandidates();
  if(!rows.length)return alert('Pirmiausia pažymėk bent vieną prekę.');
  closeBulkDeleteProductInfoModal();
  const blocked=rows.filter(x=>x.blocked);
  const modal=document.createElement('div');
  modal.id='productInfoDeleteModal';
  modal.className='product-info-delete-overlay';
  modal.innerHTML=`<div class="product-info-delete-modal" role="dialog" aria-modal="true" aria-labelledby="productInfoDeleteTitle">
    <div class="product-info-delete-head">
      <div><div class="product-info-delete-kicker">MOGA SF PREMIUM</div><h3 id="productInfoDeleteTitle">Ištrinti pažymėtas prekes?</h3></div>
      <button type="button" class="product-info-delete-x" onclick="closeBulkDeleteProductInfoModal()" aria-label="Uždaryti">×</button>
    </div>
    <p class="product-info-delete-copy">Ketinate ištrinti žemiau parodytas prekes iš aktyvaus prekių katalogo. Istoriniai SF, FIFO judėjimai ir kiti apskaitos įrašai nebus trinami.</p>
    ${blocked.length?`<div class="product-info-delete-warning">⚠ ${blocked.length} pažymėta(-os) prekė(-ės) turi likutį arba rezervą. Jas pirmiausia reikia nunulinti — trynimas kol kas užblokuotas.</div>`:''}
    <div class="product-info-delete-list">
      <div class="product-info-delete-row product-info-delete-row-head"><span>Prekė</span><span>SKU</span><span>Likutis</span></div>
      ${rows.map(x=>`<div class="product-info-delete-row ${x.blocked?'is-blocked':''}"><span title="${esc(x.p.name)}">• ${esc(x.p.name)}</span><span>${esc(x.p.sku||'—')}</span><span>${num(x.qty).toLocaleString('lt-LT')} vnt.${num(x.reserved)>0?` / rez. ${num(x.reserved).toLocaleString('lt-LT')}`:''}</span></div>`).join('')}
    </div>
    <label class="product-info-delete-consent ${blocked.length?'is-disabled':''}">
      <input id="productInfoDeleteConsent" type="checkbox" ${blocked.length?'disabled':''} onchange="document.getElementById('productInfoDeleteConfirm').disabled=!this.checked">
      <span>Suprantu, kad pažymėtos prekės bus pašalintos iš prekių katalogo.</span>
    </label>
    <div class="product-info-delete-actions">
      <button type="button" class="cancel" onclick="closeBulkDeleteProductInfoModal()">ATŠAUKTI</button>
      <button id="productInfoDeleteConfirm" type="button" class="danger" disabled onclick="confirmBulkDeleteProductInfo()">IŠTRINTI ${rows.length} PREK.</button>
    </div>
  </div>`;
  modal.addEventListener('click',e=>{if(e.target===modal)closeBulkDeleteProductInfoModal()});
  document.body.appendChild(modal);
}
window.openBulkDeleteProductInfoModal=openBulkDeleteProductInfoModal;
function confirmBulkDeleteProductInfo(){
  const consent=document.getElementById('productInfoDeleteConsent');
  if(!consent?.checked)return false;
  const rows=productInfoDeleteCandidates();
  if(!rows.length){closeBulkDeleteProductInfoModal();return false;}
  const blocked=rows.filter(x=>x.blocked);
  if(blocked.length){alert('Bent viena pažymėta prekė turi likutį arba rezervą. Trynimas sustabdytas.');return false;}
  const ids=new Set(rows.map(x=>String(x.id)));
  const next=products().filter(p=>!ids.has(String(p.inventoryId||'')));
  if(typeof window.setProducts!=='function')return alert('Prekių išsaugojimo funkcija nerasta.');
  // Sąmoningai triname tik iš aktyvaus katalogo. FIFO / sandėlio / judėjimų istorijos
  // neišmetame, kad seni SF ir apskaitos audito pėdsakas liktų nepažeisti.
  window.setProducts(next);
  const deletedCount=ids.size;
  ids.forEach(id=>productInfoSelection.delete(id));
  closeBulkDeleteProductInfoModal();
  refreshProductInfoFilters();
  renderProductInfo();
  try{renderInventory()}catch(_){}
  try{window.MOGA_PURCHASES?.render?.()}catch(_){}
  openBulkDeleteProductInfoSuccessModal(deletedCount);
  return true;
}
window.confirmBulkDeleteProductInfo=confirmBulkDeleteProductInfo;

async function bulkSetProductInfoOpeningCost(){
  const ids=[...productInfoSelection];
  if(!ids.length)return alert('Pirmiausia pažymėk bent vieną prekę.');
  const input=document.getElementById('productInfoBulkCost');
  const raw=String(input?.value??'').trim().replace(',','.');
  if(raw===''||!Number.isFinite(Number(raw))||Number(raw)<0)return alert('Įrašyk teisingą savikainą.');
  const value=Math.max(0,Number(raw));
  const fifoStore=getFifoStore();
  const editable=[];
  const locked=[];
  ids.forEach(id=>{
    const state=productInfoCostEditState(id,fifoStore);
    if(state.editable)editable.push(String(id));else locked.push(String(id));
  });
  if(!editable.length)return alert('Visos pažymėtos prekės jau turi realių FIFO partijų, todėl jų savikaina užrakinta.');

  const msg=`Nustatyti ${value.toFixed(2)} € savikainą ${editable.length} pažymėtoms prekėms?`+
    (locked.length?`\n\n${locked.length} prek. bus praleista, nes jos jau turi realių FIFO partijų.`:'');
  const ok=window.MOGA_UI?.confirm
    ?await window.MOGA_UI.confirm(msg,{title:'Masinis savikainos nustatymas',confirmText:'NUSTATYTI'})
    :confirm(msg);
  if(!ok)return false;

  let fifoTouched=false;
  editable.forEach(id=>{
    const st=fifoState(fifoStore,id,false);
    (st?.layers||[]).forEach(layer=>{
      if(String(layer.sourceType||'')==='opening'){
        layer.unitCost=value;
        fifoTouched=true;
      }
    });
    setCatalogCostDirect(id,value);
  });
  if(fifoTouched)setFifoStore(fifoStore);
  editable.forEach(id=>{
    const st=fifoState(fifoStore,id,false);
    if((st?.layers||[]).some(l=>String(l.sourceType||'')==='opening'))fifoSyncProductCost(id);
  });

  if(input)input.value='';
  productInfoSelection.clear();
  renderProductInfo();
  try{renderInventory()}catch(_){}
  if(locked.length)alert(`Savikaina nustatyta ${editable.length} prek. ${locked.length} užrakintos FIFO prek. praleistos.`);
  return true;
}
window.bulkSetProductInfoOpeningCost=bulkSetProductInfoOpeningCost;

async function applyBulkProductCategory(category){
  const ids=[...productInfoSelection];
  if(!ids.length)return alert('Pirmiausia pažymėk bent vieną prekę.');
  const cat=String(category||'').trim();
  const msg=cat
    ?`Priskirti kategoriją „${cat}“ ${ids.length} pažymėtoms prekėms?`
    :`Išvalyti kategoriją ${ids.length} pažymėtoms prekėms?`;
  const ok=window.MOGA_UI?.confirm
    ?await window.MOGA_UI.confirm(msg,{title:cat?'Masinis kategorijos priskyrimas':'Išvalyti kategoriją',confirmText:cat?'PRISKIRTI':'IŠVALYTI',danger:!cat})
    :confirm(msg);
  if(!ok)return false;

  if(cat)ensureProductCategory(cat);
  const next=products().map(p=>productInfoSelection.has(String(p.inventoryId))?{...p,category:cat}:p);
  if(typeof window.setProducts!=='function')return alert('Prekių išsaugojimo funkcija nerasta.');
  window.setProducts(next);
  productInfoSelection.clear();
  renderProductInfo();
  try{window.MOGA_PURCHASES?.render?.()}catch(_){}
  return true;
}
async function bulkSetProductInfoCategory(){
  const val=document.getElementById('productInfoBulkCategory')?.value||'';
  if(!String(val).trim())return alert('Įrašyk arba pasirink kategoriją.');
  const ok=await applyBulkProductCategory(val);
  if(ok&&document.getElementById('productInfoBulkCategory'))document.getElementById('productInfoBulkCategory').value='';
}
window.bulkSetProductInfoCategory=bulkSetProductInfoCategory;
async function bulkClearProductInfoCategory(){return applyBulkProductCategory('')}
window.bulkClearProductInfoCategory=bulkClearProductInfoCategory;

(function installProductInfoStyle(){
  const id='moga-product-info-style-v1';if(document.getElementById(id))return;
  const st=document.createElement('style');st.id=id;st.textContent=`
    #warehouseSheet .product-info-toolbar{display:flex;gap:12px;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;margin:0 0 12px}
    #warehouseSheet .product-info-mini-kpi{display:inline-flex;align-items:center;min-height:38px;padding:0 12px;border:1px solid #eadfce;border-radius:9px;background:#fff;font-weight:800;white-space:nowrap}
    #warehouseSheet .product-info-mini-kpi strong{margin-left:4px;font-size:15px}
    #warehouseSheet .product-info-filters{display:grid;grid-template-columns:minmax(250px,1.6fr) minmax(160px,.75fr) minmax(160px,.75fr) minmax(150px,.65fr);gap:10px;flex:1}
    #warehouseSheet .product-info-filters input,#warehouseSheet .product-info-filters select,#warehouseSheet .product-info-category-action input{height:42px;border:1px solid #d7d7d7;border-radius:10px;background:#fff;padding:0 12px;font:inherit;box-sizing:border-box}
    #warehouseSheet #productInfoSearch::placeholder,#warehouseSheet #productInfoBulkCategory::placeholder{color:#777!important;opacity:1!important;font-weight:600!important}
    #warehouseSheet .product-info-columns{display:flex;gap:8px;align-items:center;flex-wrap:wrap;padding:9px 12px;border:1px solid #e4ded6;border-radius:12px;background:#fffaf4;font-size:12px}
    #warehouseSheet .product-info-columns>span{font-weight:900}
    #warehouseSheet .product-info-columns label{display:flex;gap:5px;align-items:center;white-space:nowrap}
    #warehouseSheet .product-info-bulk{display:flex;justify-content:space-between;gap:12px;align-items:end;flex-wrap:wrap;padding:12px;margin-bottom:12px;border:1px solid #eadfce;border-radius:14px;background:linear-gradient(135deg,#fffaf4,#fff)}
    #warehouseSheet .product-info-selection{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
    #warehouseSheet .product-info-selection b{padding:8px 11px;background:#fff;border:1px solid #eee;border-radius:9px}
    #warehouseSheet .product-info-bulk button{min-height:38px;border:1px solid #d9d1c8;border-radius:9px;padding:0 12px;font-weight:900;cursor:pointer;background:#fff}
    #warehouseSheet .product-info-bulk button.gold{border:0;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111}
    #warehouseSheet .product-info-category-action{display:grid;grid-template-columns:minmax(230px,1fr) auto auto auto;gap:8px;align-items:end}
    #warehouseSheet .product-info-category-action label{grid-column:1/-1;font-size:11px;font-weight:900}
    #warehouseSheet .product-info-cost-action{display:grid;grid-template-columns:minmax(180px,230px) auto;gap:8px;align-items:end;margin-top:10px;margin-left:auto}
    #warehouseSheet .product-info-cost-action label{grid-column:1/-1;font-size:11px;font-weight:900}
    #warehouseSheet .product-info-cost-action input{height:40px;border:1px solid #d7d7d7;border-radius:10px;background:#fff;padding:0 12px;font:inherit;box-sizing:border-box;min-width:0}
    #warehouseSheet .product-info-cost-action button{min-height:40px;border-radius:9px;padding:0 14px;font-weight:900;cursor:pointer;border:0}
    #warehouseSheet .product-info-cost-action button.gold{background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111}
    #warehouseSheet .product-info-table-wrap{max-height:620px;overflow:auto}
    #warehouseSheet .product-info-table thead{position:sticky;top:0;z-index:3}
    #warehouseSheet .product-info-table th{white-space:nowrap}
    #warehouseSheet .product-info-check-col{width:42px;text-align:center}
    #warehouseSheet .product-info-check-col input{
      -webkit-appearance:none!important;appearance:none!important;
      width:20px!important;height:20px!important;min-width:20px!important;
      margin:0!important;border:1.5px solid #c8c8c8!important;border-radius:6px!important;
      background:#fff!important;display:inline-grid!important;place-content:center!important;
      cursor:pointer!important;vertical-align:middle!important;
      transition:.15s ease!important;
    }
    #warehouseSheet .product-info-check-col input:hover{
      border-color:#ff7a19!important;box-shadow:0 0 0 3px rgba(255,122,25,.10)!important;
    }
    #warehouseSheet .product-info-check-col input:checked{
      border-color:transparent!important;
      background:linear-gradient(135deg,#ff8a00 0%,#ff4b93 100%)!important;
    }
    #warehouseSheet .product-info-check-col input:checked::after{
      content:'✓';color:#fff;font-size:14px;font-weight:1000;line-height:1;
    }
    #warehouseSheet .product-info-check-col input:indeterminate{
      border-color:transparent!important;
      background:linear-gradient(135deg,#ff8a00 0%,#ff4b93 100%)!important;
    }
    #warehouseSheet .product-info-check-col input:indeterminate::after{
      content:'−';color:#fff;font-size:15px;font-weight:1000;line-height:1;
    }
    #warehouseSheet .product-info-pill{display:inline-block;padding:5px 8px;border-radius:999px;background:#fff4df;border:1px solid #f1d8ae;font-size:11px;font-weight:900}
    #warehouseSheet .product-info-supplier{display:inline-block;padding:5px 8px;border-radius:999px;background:#eef6ff;border:1px solid #d4e7fb;font-size:11px;font-weight:800;margin:2px}
    #warehouseSheet .product-info-muted{color:#999;font-size:11px}
    #warehouseSheet .product-info-cost-editable{white-space:nowrap}
    #warehouseSheet .product-info-cost-input{width:88px;height:34px;border:1px solid #efb26b;border-radius:8px;background:#fffaf4;padding:0 8px;font-weight:900;text-align:right;box-sizing:border-box;outline:none}
    #warehouseSheet .product-info-cost-input:focus{border-color:#ff7a19;box-shadow:0 0 0 3px rgba(255,122,25,.12);background:#fff}
    #warehouseSheet .product-info-cost-editable .product-info-muted{margin-left:4px}
    #warehouseSheet .product-info-cost-locked{opacity:.88}

    #warehouseSheet .product-info-delete-btn{border:0!important;background:#b90000!important;color:#fff!important;font-weight:1000!important}
    #warehouseSheet .product-info-delete-btn:hover{background:#8f0000!important;transform:translateY(-1px)}
    .product-info-delete-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(12,12,12,.58);backdrop-filter:blur(5px);display:grid;place-items:center;padding:18px}
    .product-info-delete-modal{width:min(760px,calc(100vw - 32px));max-height:min(760px,calc(100vh - 36px));overflow:hidden;background:#151515;color:#fff;border:1px solid transparent;border-radius:22px;box-shadow:0 28px 80px rgba(0,0,0,.52);padding:22px;box-sizing:border-box;position:relative;background-image:linear-gradient(#151515,#151515),linear-gradient(90deg,#ff8a00,#ff4b93);background-origin:border-box;background-clip:padding-box,border-box}
    .product-info-delete-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;border-bottom:3px solid transparent;border-image:linear-gradient(90deg,#ff8a00,#ff4b93) 1;padding-bottom:13px}
    .product-info-delete-kicker{font-size:10px;font-weight:1000;letter-spacing:.12em;color:#ff9a2f;margin-bottom:3px}
    .product-info-delete-head h3{margin:0;font-size:22px;line-height:1.15}
    .product-info-delete-x{width:36px;height:36px;border:1px solid #5a5a5a;border-radius:999px;background:#262626;color:#fff;font-size:24px;line-height:1;cursor:pointer}
    .product-info-delete-copy{margin:16px 0 12px;color:#e7e7e7;font-size:13px;line-height:1.45}
    .product-info-delete-warning{margin:0 0 12px;padding:10px 12px;border:1px solid rgba(255,138,0,.55);border-radius:10px;background:#2a2116;color:#ffd08a;font-size:12px;font-weight:800}
    .product-info-delete-list{max-height:310px;overflow:auto;border:1px solid #3a3a3a;border-radius:12px;background:#1d1d1d;color:#fff}
    .product-info-delete-row{display:grid;grid-template-columns:minmax(0,1fr) 150px 110px;gap:10px;align-items:center;padding:9px 11px;border-bottom:1px solid #333;font-size:12px}
    .product-info-delete-row:last-child{border-bottom:0}
    .product-info-delete-row>span:first-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:800}
    .product-info-delete-row-head{position:sticky;top:0;z-index:2;background:#0f0f0f;color:#fff;font-weight:1000;border-bottom:1px solid #ff8a00}
    .product-info-delete-row.is-blocked{background:#3a1717;color:#ff8f8f}
    .product-info-delete-consent{display:flex;align-items:flex-start;gap:10px;margin:15px 0 0;padding:12px;border:1px solid #454545;border-radius:12px;background:#202020;color:#fff;font-size:12px;font-weight:800;cursor:pointer}
    .product-info-delete-consent.is-disabled{opacity:.55;cursor:not-allowed}
    .product-info-delete-consent input{-webkit-appearance:none;appearance:none;width:21px;height:21px;min-width:21px;margin:0;border:1.5px solid #666;border-radius:6px;background:#111;display:grid;place-content:center;cursor:pointer}
    .product-info-delete-consent input:checked{border-color:transparent;background:linear-gradient(135deg,#ff8a00,#ff4b93)}
    .product-info-delete-consent input:checked::after{content:'✓';color:#fff;font-size:14px;font-weight:1000;line-height:1}
    .product-info-delete-actions{display:flex;justify-content:flex-end;gap:9px;margin-top:14px}
    .product-info-delete-actions button{height:40px;border-radius:10px;padding:0 16px;font-weight:1000;cursor:pointer}
    .product-info-delete-actions .cancel{border:1px solid #555;background:#262626;color:#fff}
    .product-info-delete-actions .danger{border:0;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111}
    .product-info-delete-actions .danger:disabled{background:#3b3b3b;color:#777;cursor:not-allowed}
    .product-info-delete-success-modal{width:min(560px,calc(100vw - 32px))}
    .product-info-delete-success-body{display:flex;align-items:center;gap:15px;padding:22px 2px 8px}
    .product-info-delete-success-check{width:52px;height:52px;min-width:52px;border-radius:16px;display:grid;place-items:center;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111;font-size:28px;font-weight:1000}
    .product-info-delete-success-title{font-size:18px;font-weight:1000;color:#fff;margin-bottom:5px}
    .product-info-delete-success-copy{font-size:13px;color:#d7d7d7}
    .product-info-delete-success-copy strong{color:#ff9a2f;font-size:17px}
    @media(max-width:700px){.product-info-delete-row{grid-template-columns:minmax(0,1fr) 85px}.product-info-delete-row>span:nth-child(2){display:none}.product-info-delete-modal{padding:16px}.product-info-delete-list{max-height:260px}}

    #warehouseSheet .product-category-manage-btn{
      height:40px!important;min-height:40px!important;
      border:1px solid #f0b06d!important;border-radius:10px!important;
      padding:0 12px!important;
      background:#fff7ed!important;color:#222!important;
      font-size:12px!important;font-weight:900!important;cursor:pointer!important;
      white-space:nowrap!important;
    }
    #warehouseSheet .product-category-manage-btn:hover{
      background:#fff0dc!important;border-color:#ff8a00!important;
    }

    #warehouseSheet .product-info-category-picker{
      position:relative;display:flex;align-items:center;min-width:0;
    }
    #warehouseSheet .product-info-category-picker #productInfoBulkCategory{
      width:100%!important;padding-right:42px!important;
    }
    #warehouseSheet .product-info-category-arrow{
      position:absolute;right:5px;top:50%;transform:translateY(-50%);
      width:28px!important;height:28px!important;min-width:28px!important;padding:0!important;
      border:0!important;border-radius:50%!important;background:#171717!important;color:#fff!important;
      display:grid!important;place-items:center!important;font-size:11px!important;line-height:1!important;
      cursor:pointer!important;z-index:3!important;
    }
    #warehouseSheet .product-info-category-arrow:hover{
      background:#fff!important;color:#111!important;border:1px solid #171717!important;
    }
    #warehouseSheet .product-info-category-menu{
      position:absolute;left:0;right:0;top:calc(100% + 6px);display:none;
      background:#1c1c22;color:#fff;border:1px solid #393943;border-radius:10px;
      box-shadow:0 14px 34px rgba(0,0,0,.28);overflow:hidden;z-index:100;
      max-height:220px;overflow-y:auto;
    }
    #warehouseSheet .product-info-category-menu.open{display:block}
    #warehouseSheet .product-info-category-menu button{
      width:100%;height:auto!important;min-height:38px!important;padding:9px 12px!important;
      display:block;text-align:left;border:0!important;border-radius:0!important;
      background:#1c1c22!important;color:#fff!important;font-size:12px!important;font-weight:700!important;
      cursor:pointer!important;
    }
    #warehouseSheet .product-info-category-menu button:hover{background:#34343e!important}
    #warehouseSheet .product-info-category-empty{padding:11px 12px;color:#aaa;font-size:12px}

    .moga-category-modal{
      position:fixed;inset:0;display:none;align-items:center;justify-content:center;padding:24px;
      background:rgba(0,0,0,.48);backdrop-filter:blur(3px);z-index:2147483600
    }
    .moga-category-modal.open{display:flex}
    .moga-category-modal-window{
      width:min(720px,94vw);max-height:82vh;overflow:hidden;border-radius:18px;background:#fff;
      border:1px solid #e4c58f;box-shadow:0 24px 70px rgba(0,0,0,.35)
    }
    .moga-category-modal-head{
      display:flex;align-items:center;justify-content:space-between;padding:18px 20px;background:#171717;color:#fff;
      border-bottom:3px solid transparent;border-image:linear-gradient(90deg,#ff8a00,#ff4b93) 1
    }
    .moga-category-modal-head small{color:#ff9a21;font-weight:900;letter-spacing:.12em}
    .moga-category-modal-head h3{margin:3px 0 0;font-size:19px}
    .moga-category-close{
      width:38px;height:38px;border-radius:50%;border:1px solid #555;background:#2a2a2a;color:#fff;font-size:24px;cursor:pointer
    }
    .moga-category-add{
      display:grid;grid-template-columns:1fr auto;gap:10px;padding:16px 18px;border-bottom:1px solid #eee;background:#fffaf4
    }
    .moga-category-add input,.moga-category-main input{
      height:42px!important;
      border:1px solid #d2d2d2!important;
      border-radius:10px!important;
      padding:0 12px!important;
      font:inherit!important;
      box-sizing:border-box!important;
      background:#fff!important;
      color:#111!important;
      -webkit-text-fill-color:#111!important;
      caret-color:#111!important;
      opacity:1!important;
    }
    .moga-category-add input::placeholder,.moga-category-main input::placeholder{
      color:#777!important;
      -webkit-text-fill-color:#777!important;
      opacity:1!important;
    }
    .moga-category-add input:focus,.moga-category-main input:focus{
      background:#fffaf0!important;
      color:#111!important;
      -webkit-text-fill-color:#111!important;
      border-color:#e2a632!important;
      box-shadow:0 0 0 2px rgba(226,166,50,.28)!important;
      outline:none!important;
    }
    .moga-category-add button,.moga-category-actions button{
      min-height:40px;border:0;border-radius:10px;padding:0 13px;font-weight:900;cursor:pointer;
      background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111
    }
    .moga-category-list{padding:10px 18px 18px;max-height:58vh;overflow:auto}
    .moga-category-row{
      display:grid;grid-template-columns:1fr auto;gap:12px;align-items:center;padding:10px 0;border-bottom:1px solid #eee
    }
    .moga-category-main{display:grid;grid-template-columns:1fr auto;gap:10px;align-items:center}
    .moga-category-main span{min-width:72px;text-align:right;color:#777;font-size:12px;font-weight:800}
    .moga-category-actions{display:flex;gap:7px}
    .moga-category-actions button.danger{background:#b00000;color:#fff}
    @media(max-width:900px){
      #warehouseSheet .product-info-filters{grid-template-columns:1fr}
      #warehouseSheet .product-info-category-action{grid-template-columns:1fr}
      .moga-category-add,.moga-category-row,.moga-category-main{grid-template-columns:1fr}
      .moga-category-actions{justify-content:flex-end}
      .moga-category-main span{text-align:left}
    }
  `;document.head.appendChild(st);
})();

function switchInventoryPane(name){
  document.querySelectorAll('#warehouseSheet .inventory-pane').forEach(x=>x.classList.toggle('active',x.dataset.invPane===name));
  document.querySelectorAll('#warehouseSheet .inventory-tabs button').forEach(x=>x.classList.toggle('active',x.dataset.invTab===name));
  if(name==='stock')renderInventory();
  if(name==='info')renderProductInfo();
  if(name==='history')renderInventoryHistory();
  if(name==='count')renderInventoryCount();
}
window.switchInventoryPane=switchInventoryPane;

let editingInventoryId=null;
function openInventoryEditor(id){
  if(!premium())return;
  const p=findProductById(id);if(!p)return;
  const r=getRecord(id);
  editingInventoryId=id;
  document.getElementById('invEditProduct').innerHTML=`<strong>${esc(p.name)}</strong><span>${esc([p.sku,p.category].filter(Boolean).join(' · ')||'Be SKU / kategorijos')}</span>`;
  document.getElementById('invCurrentQty').textContent=num(r.qty).toLocaleString('lt-LT');
  document.getElementById('invCurrentReserved').textContent=num(r.reserved).toLocaleString('lt-LT');
  document.getElementById('invCurrentAvailable').textContent=(num(r.qty)-num(r.reserved)).toLocaleString('lt-LT');
  document.getElementById('invCurrentValue').textContent=money(num(r.qty)*num(p.cost));
  document.getElementById('invEditAction').value='add';
  document.getElementById('invEditQty').value='';
  document.getElementById('invEditReserved').value=r.reserved||0;
  const minEl=document.getElementById('invEditMin');
  if(minEl){
    minEl.value=(r.min===null||r.min===undefined||r.min===''||num(r.min)<0)?'':num(r.min);
    minEl.placeholder=`Numatytas: ${Math.max(0,num(getStore().settings.defaultMin))}`;
  }
  ensureInventoryAlertUi();
  const targetEl=document.getElementById('invEditTarget');if(targetEl)targetEl.value=r.target||0;
  document.getElementById('invEditLocation').value=r.location||'';
  document.getElementById('invEditBarcode').value=r.barcode||'';
  document.getElementById('invEditReference').value='';
  document.getElementById('invEditNote').value='';
  document.getElementById('inventoryModal').classList.add('open');
}
window.openInventoryEditor=openInventoryEditor;

function closeInventoryEditor(){
  document.getElementById('inventoryModal')?.classList.remove('open');editingInventoryId=null;
}
window.closeInventoryEditor=closeInventoryEditor;

function saveInventoryEditor(){
  const id=editingInventoryId,p=findProductById(id);if(!id||!p)return;
  const r=getRecord(id),before=num(r.qty);
  const action=document.getElementById('invEditAction').value;
  const q=Math.max(0,num(document.getElementById('invEditQty').value));
  let after=before,type='adjust',delta=0;
  if(action==='add'){after=before+q;type='inbound';delta=q}
  if(action==='remove'){after=before-q;type='writeoff';delta=-q}
  if(action==='set'){after=q;type='count-adjust';delta=after-before}
  const store=getStore();
  if(after<0&&!store.settings.allowNegative){
    alert('Neigiamas likutis išjungtas. Pirmiausia įjunk jį sandėlio nustatymuose arba pasirink mažesnį nurašymą.');return;
  }

  ensureFifoInitialized();
  let fifoMoveCost=num(p.cost);
  if(delta<0){const used=fifoConsume(id,-delta,{sourceRef:document.getElementById('invEditReference').value.trim()||type});if(used.unitCost>0)fifoMoveCost=used.unitCost;}

  patchRecord(id,{
    qty:after,
    reserved:Math.max(0,num(document.getElementById('invEditReserved').value)),
    min:(()=>{
      const raw=String(document.getElementById('invEditMin')?.value??'').trim();
      return raw===''?-1:Math.max(0,num(raw));
    })(),
    target:Math.max(0,num(document.getElementById('invEditTarget')?.value)),
    location:document.getElementById('invEditLocation').value.trim(),
    barcode:document.getElementById('invEditBarcode').value.trim(),
    notes:document.getElementById('invEditNote').value.trim()||r.notes||''
  });

  if(delta>0)fifoAddLayer(id,delta,fifoMoveCost,{sourceType:type==='inbound'?'manual-inbound':'count-adjust-in',sourceRef:document.getElementById('invEditReference').value.trim(),receivedAt:now(),note:document.getElementById('invEditNote').value.trim()});
  if(Math.abs(delta)>1e-9)addMove({
    productId:id,type,delta,before,after,
    reference:document.getElementById('invEditReference').value.trim(),
    note:document.getElementById('invEditNote').value.trim(),
    unitCost:fifoMoveCost
  });
  closeInventoryEditor();renderInventory();renderInventoryHistory();
}
window.saveInventoryEditor=saveInventoryEditor;

function typeLabel(t){
  return({
    inbound:'Priėmimas',
    writeoff:'Nurašymas',
    'count-adjust':'Inventorizacija',
    sale:'Pardavimas / SF',
    'invoice-update':'SF pakeitimas',
    'invoice-return':'SF grąžinimas',
    adjustment:'Koregavimas',
    purchase:'Pirkimas',
    'customer-return':'Kliento grąžinimas',
    'return-cancel':'Atšauktas grąžinimas',
    manufacture:'Pagaminta'
  })[t]||t||'Koregavimas';
}
function inventoryMovementReferenceHtml(m){
  const ref=String(m?.reference||m?.invoiceNo||'').trim();
  if(!ref)return '—';

  if(m.type==='purchase'){
    return `<button type="button" class="inventory-ref-link" title="Atidaryti pirkimo užsakymą" onclick="window.openPurchaseOrderByNo&&window.openPurchaseOrderByNo('${esc(ref)}')">${esc(ref)}</button>`;
  }

  if(['sale','invoice-update','invoice-return'].includes(m.type)){
    return `<button type="button" class="inventory-ref-link" title="Atidaryti sąskaitą" onclick="window.editInvoiceByNo&&window.editInvoiceByNo('${encodeURIComponent(ref)}')">${esc(ref)}</button>`;
  }

  return esc(ref);
}

function renderInventoryHistory(){
  const tb=document.getElementById('inventoryHistoryBody');if(!tb)return;
  const q=norm(document.getElementById('inventoryHistorySearch')?.value);
  const type=document.getElementById('inventoryHistoryType')?.value||'all';
  const from=document.getElementById('inventoryHistoryFrom')?.value||'';
  const to=document.getElementById('inventoryHistoryTo')?.value||'';
  let rows=getMoves().slice().reverse().filter(m=>{
    const hay=norm([m.productName,m.sku,m.reference,m.note,m.invoiceNo].join(' '));
    if(q&&!hay.includes(q))return false;
    if(type!=='all'&&m.type!==type)return false;
    const d=String(m.createdAt||'').slice(0,10);
    if(from&&d<from)return false;if(to&&d>to)return false;
    return true;
  });
  if(!rows.length){tb.innerHTML='<tr><td colspan="9"><div class="inventory-empty">Sandėlio judėjimų nėra.</div></td></tr>';return}
  tb.innerHTML=rows.map(m=>`<tr>
    <td>${esc(new Date(m.createdAt).toLocaleString('lt-LT'))}</td>
    <td><b>${esc(m.productName)}</b><div class="mini">${esc(m.sku||'')}</div></td>
    <td>${esc(typeLabel(m.type))}</td>
    <td class="${num(m.delta)>=0?'inventory-move-plus':'inventory-move-minus'}">${num(m.delta)>0?'+':''}${num(m.delta).toLocaleString('lt-LT')}</td>
    <td class="inventory-center">${num(m.before).toLocaleString('lt-LT')} → ${num(m.after).toLocaleString('lt-LT')}</td>
    <td>${inventoryMovementReferenceHtml(m)}</td>
    <td>${esc(m.note||'—')}</td>
    <td class="inventory-money">${m.unitCost===null?'—':money(m.unitCost)}</td>
    <td class="inventory-money">${m.unitCost===null?'—':money(Math.abs(num(m.delta))*num(m.unitCost))}</td>
  </tr>`).join('');
}
window.renderInventoryHistory=renderInventoryHistory;

function showProductHistory(id){
  const p=findProductById(id);if(!p)return;
  switchInventoryPane('history');
  const q=document.getElementById('inventoryHistorySearch');
  if(q){q.value=p.name;renderInventoryHistory()}
}
window.showProductHistory=showProductHistory;

const inventoryCountDrafts = new Map();

function inventoryCountSearchText(p,r){
  return [p?.name,p?.sku,p?.category,r?.location,r?.barcode].filter(Boolean).join(' ').toLowerCase();
}

function perfumeCountVariantInfo(p){
  const name=String(p?.name||'').trim();
  const m=name.match(/^(.*?)\s*[—–-]\s*(15|50|100)\s*ml\.?\s*$/i);
  if(!m)return null;
  const cat=norm(p?.category||'');
  if(cat && !cat.includes('kvepal'))return null;
  return{base:m[1].trim(),size:String(m[2])};
}

function setInventoryCountHeader(grouped){
  const tb=document.getElementById('inventoryCountBody');
  const thead=tb?.closest('table')?.querySelector('thead');
  if(!thead)return;
  if(grouped){
    thead.innerHTML=`<tr class="inventory-count-grouped-head">
      <th>Prekė</th>
      <th class="inventory-center">15 ml.</th>
      <th class="inventory-center">50 ml.</th>
      <th class="inventory-center">100 ml.</th>
    </tr>`;
  }else{
    thead.innerHTML=`<tr>
      <th>Prekė</th><th>Sistemoje</th><th>Faktinis kiekis</th><th>Skirtumas</th><th>Rezervuota</th><th>Min.</th><th>Vieta</th>
    </tr>`;
  }
}

function countVariantCell(item){
  if(!item)return`<td class="inventory-count-size missing"><span>—</span></td>`;
  const {p,r}=item;
  const draft=inventoryCountDrafts.has(p.inventoryId)?inventoryCountDrafts.get(p.inventoryId):'';
  const d=draft===''?null:num(draft)-num(r.qty);
  const diffText=d===null?'':(d>0?'+':'')+d.toLocaleString('lt-LT');
  const diffClass=d===null?'':(d>0?' plus':d<0?' minus':'');
  return`<td class="inventory-count-size">
    <div class="inventory-count-current">Dabar: <b>${num(r.qty).toLocaleString('lt-LT')}</b></div>
    <input class="inventory-count-input inventory-count-compact" type="number" step="1" min="0" placeholder="Kiekis" value="${esc(draft)}" data-count-id="${esc(p.inventoryId)}" oninput="updateCountDiff(this)">
    <div class="inventory-count-diff${diffClass}" data-diff-id="${esc(p.inventoryId)}">${diffText}</div>
  </td>`;
}

function renderInventoryCount(){
  const tb=document.getElementById('inventoryCountBody');if(!tb)return;
  const q=(document.getElementById('inventoryCountSearch')?.value||'').trim().toLowerCase();
  const rows=inventoryRows().filter(({p,r})=>!q||inventoryCountSearchText(p,r).includes(q));
  if(!rows.length){
    setInventoryCountHeader(false);
    tb.innerHTML=`<tr><td colspan="7"><div class="inventory-empty">${q?'Pagal paiešką prekių nėra.':'Prekių katalogas tuščias.'}</div></td></tr>`;
    return;
  }

  /* Kai paieška grąžina tik kvepalų 15/50/100 ml variantus, rodome po vieną kvapą eilutėje. */
  const perfumeRows=rows.map(x=>({x,info:perfumeCountVariantInfo(x.p)}));
  const groupedMode=!!q && perfumeRows.every(x=>!!x.info);

  if(groupedMode){
    setInventoryCountHeader(true);
    const groups=new Map();
    perfumeRows.forEach(({x,info})=>{
      const key=norm(info.base);
      if(!groups.has(key))groups.set(key,{base:info.base,variants:{}});
      groups.get(key).variants[info.size]=x;
    });
    const list=[...groups.values()].sort((a,b)=>a.base.localeCompare(b.base,'lt',{numeric:true,sensitivity:'base'}));
    tb.innerHTML=list.map(g=>`<tr class="inventory-count-group-row">
      <td>${(()=>{const ip=g.variants['15']?.p||g.variants['50']?.p||g.variants['100']?.p;return `<div class="moga-inv-product-with-img">${window.MOGA_SHOPIFY_IMG?.thumb?.(ip?.shopifyImageUrl,ip?.shopifyImageAlt||g.base,38)||''}<div><div class="inventory-product-name">${esc(g.base)}</div><div class="inventory-product-meta">Kvepalai</div></div></div>`})()}</td>
      ${countVariantCell(g.variants['15'])}
      ${countVariantCell(g.variants['50'])}
      ${countVariantCell(g.variants['100'])}
    </tr>`).join('');
    return;
  }

  setInventoryCountHeader(false);
  tb.innerHTML=rows.map(({p,r})=>{
    const draft=inventoryCountDrafts.has(p.inventoryId)?inventoryCountDrafts.get(p.inventoryId):'';
    const d=draft===''?null:num(draft)-num(r.qty);
    const diffText=d===null?'—':(d>0?'+':'')+d.toLocaleString('lt-LT');
    const diffClass=d===null?'':(d>0?' plus':d<0?' minus':'');
    return `<tr data-count-id="${p.inventoryId}">
      <td><div class="moga-inv-product-with-img">${window.MOGA_SHOPIFY_IMG?.thumb?.(p.shopifyImageUrl,p.shopifyImageAlt||p.name,38)||''}<div><div class="inventory-product-name">${esc(p.name)}</div><div class="inventory-product-meta">${esc([p.sku,p.category].filter(Boolean).join(' · '))}</div></div></div></td>
      <td class="inventory-center"><span class="inventory-system-qty">${num(r.qty).toLocaleString('lt-LT')}</span></td>
      <td><input class="inventory-count-input" type="number" step="1" placeholder="Faktinis kiekis" value="${esc(draft)}" oninput="updateCountDiff(this)"></td>
      <td class="inventory-center inventory-count-diff${diffClass}">${diffText}</td>
      <td class="inventory-center">${num(r.reserved).toLocaleString('lt-LT')}</td>
      <td class="inventory-center" title="Aktyvi įspėjimo riba pagal pasirinktą „MAŽAS“ režimą">${(()=>{
        const m=inventoryDisplayedMin(p,r);
        return typeof m==='number'
          ?m.toLocaleString('lt-LT',{maximumFractionDigits:2})
          :m;
      })()}</td>
      <td>${esc(r.location||'—')}</td>
    </tr>`;
  }).join('');
}
window.renderInventoryCount=renderInventoryCount;

function updateCountDiff(inp){
  const tr=inp.closest('tr');
  const id=String(inp.dataset.countId||tr?.dataset.countId||'');
  const r=getRecord(id,false);if(!r)return;
  if(inp.value==='')inventoryCountDrafts.delete(id);else inventoryCountDrafts.set(id,inp.value);
  const cell=tr?.querySelector(`.inventory-count-diff[data-diff-id="${CSS.escape(id)}"]`)||tr?.querySelector('.inventory-count-diff');
  if(!cell)return;
  if(inp.value===''){
    cell.textContent=cell.dataset.diffId?'':'—';
    cell.className='inventory-count-diff'+(cell.dataset.diffId?'':' inventory-center');
    return;
  }
  const d=num(inp.value)-num(r.qty);
  cell.textContent=(d>0?'+':'')+d.toLocaleString('lt-LT');
  cell.className='inventory-count-diff '+(d>0?'plus':d<0?'minus':'');
}
window.updateCountDiff=updateCountDiff;

async function applyInventoryCount(){
  const changes=[...inventoryCountDrafts.entries()].map(([id,value])=>{
    if(value==='')return null;
    const r=getRecord(id,false),after=Math.max(0,num(value)),before=num(r?.qty);
    return{id,before,after,delta:after-before};
  }).filter(x=>x&&Math.abs(x.delta)>1e-9);
  if(!changes.length)return alert('Inventorizacijos pakeitimų nėra.');
  if(!(await MOGA_UI.confirm(`Pritaikyti inventorizacijos pakeitimus ${changes.length} prekėms?`,{title:'Pritaikyti inventorizaciją?',danger:true,requireCheck:true,checkText:'Patvirtinu, kad faktiniai likučiai gali pakeisti sandėlio duomenis',confirmText:'PRITAIKYTI'})))return;
  ensureFifoInitialized();
  changes.forEach(x=>{
    const p=findProductById(x.id);let cost=num(p?.cost);
    if(x.delta<0){const used=fifoConsume(x.id,-x.delta,{sourceRef:'Inventorizacija'});if(used.unitCost>0)cost=used.unitCost;}
    patchRecord(x.id,{qty:x.after});
    if(x.delta>0)fifoAddLayer(x.id,x.delta,cost,{sourceType:'count-adjust-in',sourceRef:'Inventorizacija',receivedAt:now(),note:'Faktinio likučio sutikrinimas'});
    addMove({productId:x.id,type:'count-adjust',delta:x.delta,before:x.before,after:x.after,reference:'Inventorizacija',note:'Faktinio likučio sutikrinimas',unitCost:cost});
    inventoryCountDrafts.delete(x.id);
  });
  renderInventoryCount();renderInventory();renderInventoryHistory();
  alert('Inventorizacijos likučiai atnaujinti.');
}
window.applyInventoryCount=applyInventoryCount;

function exportInventoryCsv(){
  const rows=inventoryRows();
  const csv=[
    ['Prekė','SKU','Kategorija','Likutis','Rezervuota','Galima','Minimalus likutis','Savikaina','Pardavimo kaina','Sandėlio vertė','Vieta','Barkodas'],
    ...rows.map(({p,r})=>[p.name,p.sku,p.category,num(r.qty),num(r.reserved),num(r.qty)-num(r.reserved),inventoryDisplayedMin(p,r),num(p.cost),num(p.price),num(r.qty)*num(p.cost),r.location||'',r.barcode||''])
  ].map(row=>row.map(v=>`"${String(v??'').replace(/"/g,'""')}"`).join(';')).join('\n');
  const blob=new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');
  a.href=url;a.download=`SF_Sandelis_${new Date().toISOString().slice(0,10)}.csv`;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1200);
}
window.exportInventoryCsv=exportInventoryCsv;


function currentFilteredInventoryRows(){
  const rows=inventoryRows();
  const search=norm(document.getElementById('inventorySearch')?.value);
  const cat=document.getElementById('inventoryCategory')?.value||'all';
  const status=document.getElementById('inventoryStatus')?.value||'all';
  const lowOnly=!!document.getElementById('inventoryLowOnly')?.checked;
  return rows.filter(({p,r})=>{
    const st=inventoryStatus(p,r);
    const hay=norm([p.name,p.sku,p.category,r.location,r.barcode].join(' '));
    if(search&&!hay.includes(search))return false;
    if(cat!=='all'&&p.category!==cat)return false;
    if(status!=='all'&&st.key!==status)return false;
    if(lowOnly&&!['low','out'].includes(st.key))return false;
    return true;
  });
}

async function useDefaultMinForAll(){
  const s=getStore().settings;
  const count=inventoryRows().length;
  const ok=await MOGA_UI.confirm(
    `Visoms ${count} prekėms panaikinti individualų Min. ir naudoti numatytą ${Math.max(0,num(s.defaultMin))} vnt.?`,
    {title:'Naudoti numatytą Min. visoms?',danger:false,requireCheck:true,
     checkText:'Patvirtinu, kad individualūs Min. bus panaikinti',
     confirmText:'TAIKYTI VISOMS'}
  );
  if(!ok)return;
  const store=getStore();
  Object.values(store.records||{}).forEach(r=>{r.min=-1;r.updatedAt=now()});
  setStore(store);
  renderInventory();
  window.MOGA_NOTIFICATIONS?.refresh?.();
  alert('Visoms prekėms dabar taikomas numatytas minimalus likutis.');
}
window.useDefaultMinForAll=useDefaultMinForAll;

function inventoryBulkMinTargetRows(){
  const scope=document.getElementById('inventoryLowStockScope')?.value||getStore().settings?.lowStockScope||'all';
  if(scope==='selected'){
    const selected=new Set((getStore().settings?.lowStockSelected||[]).map(String));
    return inventoryRows().filter(({p})=>selected.has(String(p?.inventoryId||'')));
  }
  return currentFilteredInventoryRows();
}

function refreshInventoryBulkMinUi(){
  const btn=document.getElementById('inventoryBulkMinApply');
  const text=document.getElementById('inventoryBulkMinHelp');
  if(!btn||!text)return;
  const scope=document.getElementById('inventoryLowStockScope')?.value||getStore().settings?.lowStockScope||'all';
  if(scope==='selected'){
    const count=(getStore().settings?.lowStockSelected||[]).length;
    btn.textContent='TAIKYTI PASIRINKTOMS';
    text.textContent=`Pritaikys Min. tik aukščiau pažymėtoms prekėms (${count}). Lentelės paieška ir filtrai tam netrukdo.`;
  }else{
    btn.textContent='TAIKYTI RODOMOMS';
    text.textContent='Naudoja viršuje esančią sandėlio paiešką ir filtrus. Pvz. ieškok „Cotton“ → 2, „ženkliukas“ → 5.';
  }
}
window.refreshInventoryBulkMinUi=refreshInventoryBulkMinUi;

async function applyBulkMinToVisible(){
  const input=document.getElementById('inventoryBulkMin');
  const raw=String(input?.value??'').trim();
  if(raw==='')return alert('Įrašyk Min. reikšmę. 0 reiškia: perspėti tik kai prekės nebelieka.');
  const min=Math.max(0,num(raw));
  const scope=document.getElementById('inventoryLowStockScope')?.value||getStore().settings?.lowStockScope||'all';
  const rows=inventoryBulkMinTargetRows();
  if(!rows.length){
    return alert(scope==='selected'
      ?'Nėra pažymėtų prekių. Viršuje pažymėk prekes, kurioms nori nustatyti Min.'
      :'Pagal dabartinę sandėlio paiešką / filtrus nėra prekių.');
  }
  const sample=rows.slice(0,3).map(x=>x.p.name).join(', ');
  const targetText=scope==='selected'?'pasirinktoms':'dabar rodomoms';
  const ok=await MOGA_UI.confirm(
    `Nustatyti individualų Min. = ${min} ${rows.length} ${targetText} prekėms?\n\nPvz.: ${sample}${rows.length>3?'…':''}`,
    {title:'Masinis Min. nustatymas',danger:false,requireCheck:true,
     checkText:`Patvirtinu, kad keičiu ${targetText} prekių Min.`,
     confirmText:'PRITAIKYTI'}
  );
  if(!ok)return;
  rows.forEach(({p})=>{
    if(!p?.inventoryId)return;
    patchRecord(p.inventoryId,{min});
  });

  const settingsStore=getStore();
  settingsStore.settings=settingsStore.settings||{};
  settingsStore.settings.lowStockMode='individual';
  setStore(settingsStore);

  const modeEl=document.getElementById('inventoryLowStockMode');
  if(modeEl)modeEl.value='individual';
  updateInventoryAlertSettingsVisibility?.();

  const verify=getStore();
  const failed=rows.filter(({p})=>!p?.inventoryId||num(verify.records?.[p.inventoryId]?.min)!==min);

  renderInventory();
  renderInventoryAlertProductList();
  refreshInventoryBulkMinUi();
  window.MOGA_NOTIFICATIONS?.refresh?.();

  if(failed.length){
    alert(`Min. ${min} pritaikytas ${rows.length-failed.length} iš ${rows.length} prekių. ${failed.length} įrašų nepavyko atnaujinti.`);
  }else{
    alert(`Min. ${min} pritaikytas ${rows.length} ${scope==='selected'?'pasirinktoms':'rodomoms'} prekėms.`);
  }
}
window.applyBulkMinToVisible=applyBulkMinToVisible;

function ensureInventoryMinTools(){
  const defaultInput=document.getElementById('inventoryDefaultMin');
  const bar=defaultInput?.closest('.inventory-settings-bar');
  if(bar&&!document.getElementById('inventoryUseDefaultAll')){
    const btn=document.createElement('button');
    btn.id='inventoryUseDefaultAll';
    btn.type='button';
    btn.className='inventory-mini-action';
    btn.textContent='TAIKYTI NUMATYTĄ VISOMS';
    btn.title='Panaikina individualius Min. ir visoms prekėms palieka viršuje nustatytą numatytą minimumą';
    btn.onclick=useDefaultMinForAll;
    bar.appendChild(btn);
  }

  const details=document.getElementById('inventoryLowStockSettings');
  if(details&&!document.getElementById('inventoryBulkMinTools')){
    const note=document.getElementById('inventoryAlertModeNote');
    const box=document.createElement('div');
    box.id='inventoryBulkMinTools';
    box.className='inventory-bulk-min-tools';
    box.innerHTML=`
      <div>
        <b>MASINIS MIN. NUSTATYMAS</b>
        <small id="inventoryBulkMinHelp">Naudoja viršuje esančią sandėlio paiešką ir filtrus.</small>
      </div>
      <input id="inventoryBulkMin" type="number" min="0" step="1" value="0" title="0 = perspėti tik kai nebelieka">
      <button id="inventoryBulkMinApply" type="button" onclick="applyBulkMinToVisible()">TAIKYTI RODOMOMS</button>`;
    if(note)details.insertBefore(box,note);
    else details.appendChild(box);
  }
  refreshInventoryBulkMinUi();
}
window.ensureInventoryMinTools=ensureInventoryMinTools;

function saveInventorySettings(){
  ensureInventoryMinTools();
  const store=getStore();
  store.settings.allowNegative=!!document.getElementById('inventoryAllowNegative')?.checked;
  store.settings.defaultMin=Math.max(0,num(document.getElementById('inventoryDefaultMin')?.value));
  store.settings.lowStockMode=document.getElementById('inventoryLowStockMode')?.value||store.settings.lowStockMode||'individual';
  store.settings.lowStockQty=Math.max(0,num(document.getElementById('inventoryLowStockQty')?.value));
  store.settings.lowStockPercent=Math.max(0,Math.min(100,num(document.getElementById('inventoryLowStockPercent')?.value)));
  store.settings.lowStockScope=document.getElementById('inventoryLowStockScope')?.value||'all';
  // lowStockSelected valdome atskirai per toggleInventoryAlertProduct(), kad paieška
  // neištrintų tuo metu ekrane nematomų, bet anksčiau pažymėtų prekių.
  setStore(store);
  updateInventoryAlertSettingsVisibility();
  refreshInventoryBulkMinUi();
  renderInventory();
  window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.saveInventorySettings=saveInventorySettings;

function loadInventorySettings(){
  ensureInventoryAlertUi();
  ensureInventoryMinTools();
  const s=getStore().settings;
  const a=document.getElementById('inventoryAllowNegative');if(a)a.checked=!!s.allowNegative;
  const m=document.getElementById('inventoryDefaultMin');if(m)m.value=num(s.defaultMin);
  const mode=document.getElementById('inventoryLowStockMode');if(mode)mode.value=s.lowStockMode||'individual';
  const qty=document.getElementById('inventoryLowStockQty');if(qty)qty.value=num(s.lowStockQty||3);
  const pct=document.getElementById('inventoryLowStockPercent');if(pct)pct.value=num(s.lowStockPercent||25);
  const scope=document.getElementById('inventoryLowStockScope');if(scope)scope.value=s.lowStockScope||'all';
  renderInventoryAlertProductList();
  updateInventoryAlertSettingsVisibility();
}

function inventoryAlertFilteredProducts(){
  const q=norm(document.getElementById('inventoryAlertProductSearch')?.value);
  return products().filter(p=>!q||norm([p.name,p.sku,p.category].join(' ')).includes(q));
}

function toggleInventoryAlertProduct(id,checked){
  const store=getStore();
  store.settings=store.settings||{};
  const selected=new Set((store.settings.lowStockSelected||[]).map(String));
  if(checked)selected.add(String(id));else selected.delete(String(id));
  store.settings.lowStockSelected=[...selected];
  setStore(store);
  renderInventoryAlertSelectionTools();
  refreshInventoryBulkMinUi();
  renderInventory();
  window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.toggleInventoryAlertProduct=toggleInventoryAlertProduct;

function selectVisibleInventoryAlertProducts(checked=true){
  const store=getStore();
  store.settings=store.settings||{};
  const selected=new Set((store.settings.lowStockSelected||[]).map(String));
  inventoryAlertFilteredProducts().forEach(p=>{
    const id=String(p.inventoryId||'');if(!id)return;
    if(checked)selected.add(id);else selected.delete(id);
  });
  store.settings.lowStockSelected=[...selected];
  setStore(store);
  renderInventoryAlertProductList();
  refreshInventoryBulkMinUi();
  renderInventory();
  window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.selectVisibleInventoryAlertProducts=selectVisibleInventoryAlertProducts;

function clearInventoryAlertProducts(){
  const store=getStore();store.settings=store.settings||{};store.settings.lowStockSelected=[];setStore(store);
  renderInventoryAlertProductList();refreshInventoryBulkMinUi();renderInventory();window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.clearInventoryAlertProducts=clearInventoryAlertProducts;

function renderInventoryAlertSelectionTools(){
  const el=document.getElementById('inventoryAlertSelectionCount');
  if(el)el.textContent=`Pažymėta: ${(getStore().settings.lowStockSelected||[]).length}`;
}

function renderInventoryAlertProductList(){
  const host=document.getElementById('inventoryAlertProductList');if(!host)return;
  const selected=new Set((getStore().settings.lowStockSelected||[]).map(String));
  const arr=inventoryAlertFilteredProducts();
  host.innerHTML=arr.length?arr.map(p=>`<label class="inventory-alert-product"><input class="inventory-alert-product-check" type="checkbox" value="${esc(p.inventoryId)}" ${selected.has(String(p.inventoryId))?'checked':''} onchange="toggleInventoryAlertProduct('${esc(p.inventoryId)}',this.checked)"><span><b>${esc(p.name)}</b><small>${esc(p.sku||p.category||'')}</small></span></label>`).join(''):'<div class="mini">Prekių nerasta.</div>';
  renderInventoryAlertSelectionTools();
}
window.renderInventoryAlertProductList=renderInventoryAlertProductList;

function updateInventoryAlertSettingsVisibility(){
  const mode=document.getElementById('inventoryLowStockMode')?.value||'individual';
  const scope=document.getElementById('inventoryLowStockScope')?.value||'all';
  document.getElementById('inventoryLowStockQtyWrap')?.classList.toggle('hidden',mode!=='quantity');
  document.getElementById('inventoryLowStockPercentWrap')?.classList.toggle('hidden',mode!=='percent');
  document.getElementById('inventoryAlertSelectedWrap')?.classList.toggle('hidden',scope!=='selected');
  refreshInventoryBulkMinUi?.();
  const note=document.getElementById('inventoryAlertModeNote');
  if(note){
    note.innerHTML=mode==='individual'
      ?'<b>Individualus:</b> tuščias prekės „Min.“ naudoja viršuje nustatytą numatytą minimumą. Įrašius 0, prekė perspėja tik kai jos nebelieka.'
      :mode==='quantity'
      ?'<b>Pagal kiekį:</b> visoms taikomoms prekėms naudojama viena bendra vienetų riba. Ši riba rodoma ir lentelės „Min.“ stulpelyje.'
      :mode==='percent'
      ?'<b>Pagal procentą:</b> MAŽAS rodomas, kai „Galima“ pasiekia pasirinktą % nuo prekės tikslinio kiekio. Jei „Tikslinis“ = 0, naudojamas prekės „Min.“, o jei ir jis 0 – „Numatytas min. likutis“.'
      :'<b>Išjungta:</b> MAŽAS likučio perspėjimas nerodomas; NĖRA vis tiek rodomas, kai laisvas likutis ≤ 0.';
  }
}
window.updateInventoryAlertSettingsVisibility=updateInventoryAlertSettingsVisibility;

function ensureInventoryAlertUi(){
  const bar=document.querySelector('#warehouseSheet .inventory-settings-bar');
  if(bar&&!document.getElementById('inventoryLowStockSettings')){
    bar.insertAdjacentHTML('afterend',`<details id="inventoryLowStockSettings" class="inventory-alert-settings">
      <summary>LIKUČIŲ ĮSPĖJIMŲ NUSTATYMAI</summary>
      <div class="inventory-alert-settings-grid">
        <label>Kaip nustatyti „MAŽAS“
          <select id="inventoryLowStockMode" onchange="saveInventorySettings()">
            <option value="individual">Pagal kiekvienos prekės Min.</option>
            <option value="quantity">Pagal bendrą kiekį</option>
            <option value="percent">Pagal % nuo tikslinio kiekio</option>
            <option value="off">Išjungti „MAŽAS“ perspėjimus</option>
          </select>
        </label>
        <label id="inventoryLowStockQtyWrap">Mažas, kai lieka ≤
          <div class="inventory-setting-unit"><input id="inventoryLowStockQty" type="number" min="0" step="1" value="3" onchange="saveInventorySettings()"><span>vnt.</span></div>
        </label>
        <label id="inventoryLowStockPercentWrap">Mažas, kai lieka ≤
          <div class="inventory-setting-unit"><input id="inventoryLowStockPercent" type="number" min="0" max="100" step="1" value="25" onchange="saveInventorySettings()"><span>%</span></div>
        </label>
        <label>Kam taikyti
          <select id="inventoryLowStockScope" onchange="saveInventorySettings()">
            <option value="all">Visoms prekėms</option>
            <option value="selected">Tik pasirinktoms prekėms</option>
          </select>
        </label>
      </div>
      <div id="inventoryAlertModeNote" class="inventory-alert-mode-note"></div>
      <div id="inventoryAlertSelectedWrap" class="inventory-alert-selected-wrap hidden">
        <div class="inventory-alert-selected-head"><b>Pasirink prekės, kurioms taikyti perspėjimą</b><input id="inventoryAlertProductSearch" placeholder="Ieškoti prekės..." oninput="renderInventoryAlertProductList()"></div>
        <div class="inventory-alert-selection-tools">
          <span id="inventoryAlertSelectionCount">Pažymėta: 0</span>
          <button type="button" onclick="selectVisibleInventoryAlertProducts(true)">PAŽYMĖTI RODOMAS</button>
          <button type="button" onclick="selectVisibleInventoryAlertProducts(false)">NUIMTI RODOMAS</button>
          <button type="button" class="muted" onclick="clearInventoryAlertProducts()">NUIMTI VISAS</button>
        </div>
        <div id="inventoryAlertProductList" class="inventory-alert-product-list"></div>
      </div>
    </details>`);
  }
  const min=document.getElementById('invEditMin');
  if(min&&!document.getElementById('invEditTarget')){
    const label=min.closest('label');
    label?.insertAdjacentHTML('afterend','<label>Tikslinis kiekis (%)<input id="invEditTarget" type="number" min="0" step="1" value="0"><small style="font-weight:400;color:#777">Naudojamas procentiniam įspėjimui; 0 = naudoti Min.</small></label>');
  }
  const historyType=document.getElementById('inventoryHistoryType');
  if(historyType&&!historyType.querySelector('option[value="customer-return"]')){
    historyType.insertAdjacentHTML('beforeend','<option value="customer-return">Klientų grąžinimai</option><option value="return-cancel">Atšaukti grąžinimai</option>');
  }
  if(!document.getElementById('mogaInventoryAlertCss')){
    const st=document.createElement('style');st.id='mogaInventoryAlertCss';st.textContent=`
      .inventory-alert-settings{margin:10px 0 14px;border:1px solid #ddd;border-left:4px solid var(--accent);border-radius:10px;background:#fff}
      .inventory-alert-settings summary{cursor:pointer;padding:11px 13px;font-weight:900;font-size:11px;color:#111}
      .inventory-alert-settings-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:9px;padding:0 13px 12px}
      .inventory-alert-settings-grid label{display:flex;flex-direction:column;gap:5px;font-size:10px;font-weight:800;color:#555}
      .inventory-alert-settings-grid input,.inventory-alert-settings-grid select,.inventory-alert-selected-head input{border:1px solid #bbb;background:#fff;border-radius:8px;padding:8px;min-height:36px}
      .inventory-setting-unit{display:grid;grid-template-columns:1fr 42px;align-items:center;gap:5px}.inventory-setting-unit span{font-size:10px}
      .inventory-alert-mode-note{margin:0 13px 12px;padding:9px 10px;background:#fafafa;border:1px solid #eee;border-radius:8px;font-size:10px;line-height:1.45}
      .inventory-alert-selected-wrap{padding:0 13px 13px}.inventory-alert-selected-wrap.hidden,.inventory-alert-settings .hidden{display:none!important}
      .inventory-alert-selected-head{display:flex;justify-content:space-between;gap:10px;align-items:center;margin-bottom:8px;font-size:10px}.inventory-alert-selected-head input{width:min(320px,55%)}
      .inventory-alert-selection-tools{display:flex;align-items:center;gap:7px;flex-wrap:wrap;margin:0 0 8px}.inventory-alert-selection-tools span{font-size:10px;font-weight:900;margin-right:auto}.inventory-alert-selection-tools button{min-height:30px;border:0;border-radius:999px;padding:0 10px;font-size:9px;font-weight:900;cursor:pointer;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111}.inventory-alert-selection-tools button.muted{background:#222;color:#fff}
      .inventory-alert-product-list{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;max-height:230px;overflow:auto}
      .inventory-alert-product{display:flex;align-items:flex-start;gap:7px;border:1px solid #eee;border-radius:8px;padding:7px;background:#fafafa;font-size:9px}.inventory-alert-product b{display:block}.inventory-alert-product small{display:block;color:#777;margin-top:2px}
      #warehouseSheet #inventoryLowOnly,#warehouseSheet #inventoryAllowNegative,#warehouseSheet .inventory-alert-product-check{-webkit-appearance:none!important;appearance:none!important;width:20px!important;height:20px!important;min-width:20px!important;margin:0!important;border:1.5px solid #c8c8c8!important;border-radius:6px!important;background:#fff!important;display:inline-grid!important;place-content:center!important;cursor:pointer!important;vertical-align:middle!important;transition:.15s ease!important}
      #warehouseSheet #inventoryLowOnly:hover,#warehouseSheet #inventoryAllowNegative:hover,#warehouseSheet .inventory-alert-product-check:hover{border-color:#ff7a19!important;box-shadow:0 0 0 3px rgba(255,122,25,.10)!important}
      #warehouseSheet #inventoryLowOnly:checked,#warehouseSheet #inventoryAllowNegative:checked,#warehouseSheet .inventory-alert-product-check:checked{border-color:transparent!important;background:linear-gradient(135deg,#ff8a00 0%,#ff4b93 100%)!important}
      #warehouseSheet #inventoryLowOnly:checked::after,#warehouseSheet #inventoryAllowNegative:checked::after,#warehouseSheet .inventory-alert-product-check:checked::after{content:'✓';color:#fff;font-size:14px;font-weight:1000;line-height:1}
      @media(max-width:900px){.inventory-alert-settings-grid{grid-template-columns:1fr 1fr}.inventory-alert-product-list{grid-template-columns:1fr 1fr}}
      @media(max-width:600px){.inventory-alert-settings-grid,.inventory-alert-product-list{grid-template-columns:1fr}.inventory-alert-selected-head{display:block}.inventory-alert-selected-head input{width:100%;margin-top:6px}}
    `;document.head.appendChild(st);
  }
}
window.ensureInventoryAlertUi=ensureInventoryAlertUi;

function inventoryRefreshAll(){
  ensureInventoryAlertUi();normalizeInventoryUi();ensureProductIds();baselineLegacyInvoices();ensureFifoInitialized();loadInventorySettings();renderInventory();renderInventoryHistory();
}
window.inventoryRefreshAll=inventoryRefreshAll;

/* Full backup import is async; refresh warehouse shortly after restore. */
const baseImportEverything=window.importEverything;
if(typeof baseImportEverything==='function'){
  window.importEverything=function(event){
    baseImportEverything(event);
    setTimeout(inventoryRefreshAll,500);
  };
}

/* Plan changes may unlock/lock warehouse without page reload. */
window.addEventListener('moga:plan-change',()=>setTimeout(inventoryRefreshAll,0));
window.addEventListener('moga:data-ready',()=>setTimeout(inventoryRefreshAll,0));

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',inventoryRefreshAll);
else inventoryRefreshAll();


function normalizeInventoryUi(){
  const sheet=document.getElementById('warehouseSheet');
  if(!sheet)return;

  /* Paieška: trumpas universalus placeholderis. */
  const search=document.getElementById('inventorySearch');
  if(search)search.placeholder='Ieškoti';

  /* Viršutinėje juostoje nebedubliuojame vidinių tabų.
     Paliekame tik eksportus. */
  const actions=sheet.querySelector('.inventory-head-actions');
  if(actions){
    [...actions.querySelectorAll('button')].forEach(btn=>{
      const text=String(btn.textContent||'').trim().toUpperCase();
      if(['LIKUČIAI','JUDĖJIMAI','INVENTORIZACIJA'].includes(text))btn.remove();
    });

    if(!document.getElementById('inventoryExcelExportBtn')){
      const csv=[...actions.querySelectorAll('button')].find(b=>String(b.textContent||'').toUpperCase().includes('CSV'));
      const excel=document.createElement('button');
      excel.id='inventoryExcelExportBtn';
      excel.type='button';
      excel.className='gold';
      excel.textContent='EKSPORTUOTI EXCEL';
      excel.onclick=()=>window.exportInventoryExcel?.();
      if(csv)csv.insertAdjacentElement('afterend',excel);else actions.appendChild(excel);
    }
  }

  /* Shopify / temos input stiliai kai kur nudažo number lauką juodai.
     Sandėlio valdymo laukai visada turi būti aiškiai matomi. */
  if(!document.getElementById('mogaInventoryUiFixCss')){
    const st=document.createElement('style');
    st.id='mogaInventoryUiFixCss';
    st.textContent=`
      #warehouseSheet .inventory-settings-bar input[type="number"],
      #warehouseSheet .inventory-settings-bar input[type="text"],
      #warehouseSheet .inventory-alert-settings input,
      #warehouseSheet .inventory-alert-settings select,
      #warehouseSheet .inventory-tools input,
      #warehouseSheet .inventory-tools select{
        background:#fff!important;
        color:#111!important;
        -webkit-text-fill-color:#111!important;
        opacity:1!important;
      }
      #warehouseSheet .inventory-settings-bar input[type="number"]{
        min-width:78px;
      }
      #warehouseSheet .inventory-head-actions{
        display:flex;
        gap:8px;
        align-items:center;
        flex-wrap:wrap;
      }
      #warehouseSheet .inventory-head-actions button{
        white-space:nowrap;
      }
    `;
    document.head.appendChild(st);
  }
}

(function(){
  if(document.getElementById('mogaRecipeInventoryCss'))return;
  const st=document.createElement('style');st.id='mogaRecipeInventoryCss';st.textContent=`
    .inventory-recipe-badge{display:inline-flex;align-items:center;margin-left:7px;padding:2px 6px;border-radius:999px;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111;font-size:9px;font-weight:1000;vertical-align:1px}
  `;document.head.appendChild(st);
})();
window.normalizeInventoryUi=normalizeInventoryUi;

window.MOGA_INVENTORY={
  getStore,getMoves,getRecord,available,render:renderInventory,status:inventoryStatus,
  patchRecord,addMove,findProductById,findProductByName,products,
  exportCsv:exportInventoryCsv,refresh:inventoryRefreshAll,
  ensureFifoInitialized,fifoStartedAt,fifoSummary,fifoSummaryText,fifoLayers,
  fifoAddLayer,fifoConsume,fifoReconcileToQty,fifoAddPurchaseReceipt,
  fifoCanReverseSource,fifoReverseSource,fifoCanRemoveLayer,fifoRemoveLayer,
  fifoInvoiceItemCost,fifoAddCustomerReturn,
  recipeBuildableQty,recipeProducedQty,recipeMaterialNeeds,recipeUnitCost
};

/* Inline oninput anksčiau kvietė lokalią funkciją, todėl paieška atsinaujindavo tik pakeitus tabą.
   Dabar veikia ir globalus renderInventory, ir atsarginis listeneris. */
document.addEventListener('input',e=>{
  if(e.target?.id==='inventorySearch')renderInventory();
},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setTimeout(inventoryRefreshAll,0),{once:true});
else setTimeout(inventoryRefreshAll,0);
setTimeout(normalizeInventoryUi,100);
setTimeout(normalizeInventoryUi,700);
})();


/* PREKIŲ INFORMACIJA — kategorijų kompaktiškas UI */
(function(){
 const id='moga-product-category-compact-ui-v2';if(document.getElementById(id))return;
 const st=document.createElement('style');st.id=id;st.textContent=`
 #warehouseSheet .product-info-category-picker{position:relative!important;display:block!important;min-width:0!important}
 #warehouseSheet .product-info-category-picker #productInfoBulkCategory{width:100%!important;height:40px!important;min-height:40px!important;padding:0 32px 0 12px!important;border-radius:10px!important}
 #warehouseSheet .product-info-category-arrow{position:absolute!important;right:8px!important;top:50%!important;transform:translateY(-50%)!important;width:14px!important;height:14px!important;min-width:14px!important;min-height:14px!important;padding:0!important;margin:0!important;border:0!important;border-radius:0!important;background:transparent!important;color:#111!important;box-shadow:none!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:8px!important;line-height:1!important;font-weight:900!important}
 #warehouseSheet .product-info-category-arrow:hover{background:transparent!important;color:#111!important;border:0!important;box-shadow:none!important}
 #warehouseSheet .product-category-manage-btn{height:40px!important;min-height:40px!important;padding:0 12px!important;margin:0!important;border:1px solid #d6d6d6!important;border-radius:10px!important;background:#fff!important;color:#111!important;box-shadow:none!important;font-size:12px!important;line-height:1!important;font-weight:900!important;white-space:nowrap!important}
 #warehouseSheet .product-category-manage-btn:hover{background:#fffaf4!important;border-color:#e7a63b!important;color:#111!important}
 `;
 document.head.appendChild(st);
})();

/* ========================================================================== */
/* MOGA SF — SHOPIFY CSV SINCHRONIZACIJA                                      */
/* SFAPP -> Shopify inventoriaus CSV + produktų tagų CSV                      */
/* ========================================================================== */
(function(){
  if(window.MOGA_SHOPIFY_SYNC_LOADED)return;
  window.MOGA_SHOPIFY_SYNC_LOADED=true;

  const INV_TEMPLATE_KEY='moga_shopify_inventory_template_v1';
  const PRODUCT_TEMPLATE_KEY='moga_shopify_products_template_v1';
  const BASELINE_KEY='moga_shopify_inventory_baseline_v1';
  const SETTINGS_KEY='moga_shopify_sync_settings_v1';
  const MANUAL_MAP_KEY='moga_shopify_manual_variant_map_v1';
  const SHOPIFY_UNMANAGED_KEY='moga_shopify_unmanaged_items_v1';
  const SHOPIFY_API_BASE=String(window.MOGA_SF_SHOPIFY_API_BASE||'https://sfapi.moga.lt').replace(/\/+$/,'');
  const MOGA_SF_SESSION_KEY='moga_invoice_pro_session_v1';

  function mogaShopifyLicenseCode(){
    const direct=String(window.MOGA_LICENSE_SESSION?.code||'').trim();
    if(direct)return direct.replace(/\s+/g,'').toUpperCase();
    for(const storage of [localStorage,sessionStorage]){
      try{
        const raw=storage.getItem(MOGA_SF_SESSION_KEY);
        if(!raw)continue;
        const data=JSON.parse(raw);
        const code=String(data?.code||'').trim();
        if(code)return code.replace(/\s+/g,'').toUpperCase();
      }catch(_){}
    }
    return '';
  }
  function mogaShopifyAuthHeaders(extra={}){
    const code=mogaShopifyLicenseCode();
    return {...extra,...(code?{'X-MOGA-License-Code':code}:{})};
  }

  const SHOPIFY_MULTI_SHOP_KEY='moga_shopify_connected_shop_v1';
  const SHOPIFY_MULTI_LAST_SHOP_KEY='moga_shopify_last_shop_v1';
  const SHOPIFY_MULTI_DEFAULT_SHOP='vsy70z-fi.myshopify.com';
  function mogaShopifyConnectedShop(){
    const saved=String(localStorage.getItem(SHOPIFY_MULTI_SHOP_KEY)||'').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(saved)?saved:'';
  }
  function saveMogaShopifyConnectedShop(shop){
    shop=String(shop||'').trim().toLowerCase();
    if(!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop))return false;
    localStorage.setItem(SHOPIFY_MULTI_SHOP_KEY,shop);
    localStorage.setItem(SHOPIFY_MULTI_LAST_SHOP_KEY,shop);
    return true;
  }
  function mogaShopifyLastShop(){
    const saved=String(localStorage.getItem(SHOPIFY_MULTI_LAST_SHOP_KEY)||'').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(saved)?saved:'';
  }
  window.mogaShopifyConnectedShop=mogaShopifyConnectedShop;
  window.saveMogaShopifyConnectedShop=saveMogaShopifyConnectedShop;

  let shopifyConnectionState={checked:false,connected:false,loading:false,shop:'',shopName:'',locationId:'',locationName:'',locations:[],error:''};
  let shopifyConnectPollTimer=null;

  function normalizeMogaShopDomain(value){
    let v=String(value||'').trim().toLowerCase();
    v=v.replace(/^https?:\/\//,'').replace(/\/.*$/,'');
    if(!v)return '';
    if(!v.includes('.'))v+=`.myshopify.com`;
    return /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(v)?v:'';
  }

  function setShopifyConnectionState(patch){
    shopifyConnectionState={...shopifyConnectionState,...patch};
    applyShopifyConnectionUi();
  }

  function applyShopifyConnectionUi(){
    const modal=document.getElementById('mogaShopifySyncModal');
    const launch=document.getElementById('shopifySyncLaunch');
    const label=document.getElementById('shopifySyncLaunchLabel');
    const count=document.getElementById('shopifySyncLaunchCount');
    const panel=document.getElementById('mogaShopifyConnectionPanel');
    const connectedBar=document.getElementById('mogaShopifyConnectedBar');
    if(!modal||!launch)return;

    const st=shopifyConnectionState;
    modal.classList.toggle('is-shopify-connected',!!st.connected);
    modal.classList.toggle('is-shopify-disconnected',!st.connected);

    if(label)label.textContent=st.loading?'SHOPIFY SYNC · TIKRINAMA':st.connected?'SHOPIFY SYNC · PRIJUNGTA':'SHOPIFY SYNC · NEPRIJUNGTA';
    launch.classList.toggle('is-connected',!!st.connected);
    launch.classList.toggle('is-disconnected',!st.connected);
    if(count)count.style.display=st.connected?'inline-grid':'none';

    if(panel){
      const status=document.getElementById('mogaShopifyConnectStatus');
      if(status){
        status.textContent=st.loading?'Tikrinamas ryšys su Shopify…':st.error||'';
        status.className='moga-shopify-connect-status'+(st.error?' error':'');
      }
      const input=document.getElementById('mogaShopifyShopInput');
      if(input&&!input.value){
        const remembered=st.shop||mogaShopifyLastShop();
        if(remembered)input.value=remembered;
      }
    }

    if(connectedBar&&st.connected){
      const name=document.getElementById('mogaShopifyConnectedName');
      const domain=document.getElementById('mogaShopifyConnectedDomain');
      const loc=document.getElementById('mogaShopifyConnectedLocation');
      if(name)name.textContent=st.shopName||'Shopify';
      if(domain)domain.textContent=st.shop||'—';
      if(loc)loc.textContent=st.locationName?`Lokacija: ${st.locationName}`:'Lokacija dar nepasirinkta';
    }

    const locSetup=document.getElementById('mogaShopifyApiLocationSetup');
    if(locSetup){
      const needs=st.connected&&!st.locationId;
      locSetup.style.display=needs?'flex':'none';
      const sel=document.getElementById('mogaShopifyApiLocationSelect');
      if(sel){
        sel.innerHTML=(st.locations||[]).map(x=>`<option value="${esc(x.id)}">${esc(x.name)}</option>`).join('')||'<option value="">Lokacijų nėra</option>';
      }
    }
  }

  async function selectMogaShopifyApiLocation(locationId,quiet=false){
    const shop=mogaShopifyConnectedShop();
    if(!shop||!locationId)return false;
    try{
      const r=await fetch(`${SHOPIFY_API_BASE}/shopify/location/select`,{
        method:'POST',credentials:'include',headers:mogaShopifyAuthHeaders({'Content-Type':'application/json'}),
        body:JSON.stringify({shop,locationId})
      });
      const data=await r.json().catch(()=>null);
      if(!r.ok||!data?.ok)throw new Error(data?.message||`HTTP ${r.status}`);
      await refreshMogaShopifyConnectionState({quiet:true,autoSelect:false});
      return true;
    }catch(err){
      if(!quiet)window.MOGA_UI?.alert?.(`Nepavyko pasirinkti Shopify vietos.\n\n${err?.message||err}`,{title:'SHOPIFY SYNC'});
      return false;
    }
  }
  window.selectMogaShopifyApiLocation=selectMogaShopifyApiLocation;

  async function saveSelectedMogaShopifyApiLocation(){
    const id=document.getElementById('mogaShopifyApiLocationSelect')?.value||'';
    if(!id)return;
    await selectMogaShopifyApiLocation(id,false);
  }
  window.saveSelectedMogaShopifyApiLocation=saveSelectedMogaShopifyApiLocation;

  async function refreshMogaShopifyConnectionState(opts={}){
    const quiet=!!opts.quiet,autoSelect=opts.autoSelect!==false;
    setShopifyConnectionState({loading:true,error:''});
    try{
      // Serveris yra vienintelis autoritetingas šaltinis: ne localStorage.
      // /shopify/status ryšį parenka pagal patikrintą SFAPP licencijos identity.
      const sr=await fetch(`${SHOPIFY_API_BASE}/shopify/status`,{
        method:'GET',credentials:'include',headers:mogaShopifyAuthHeaders(),cache:'no-store'
      });
      const status=await sr.json().catch(()=>null);
      if(!sr.ok||!status?.ok)throw new Error(status?.message||`HTTP ${sr.status}`);

      if(!status.connected||!status.shop){
        localStorage.removeItem(SHOPIFY_MULTI_SHOP_KEY);
        setShopifyConnectionState({checked:true,connected:false,loading:false,shop:'',shopName:'',locationId:'',locationName:'',locations:[],error:''});
        return false;
      }

      const shop=normalizeMogaShopDomain(status.shop);
      if(!shop)throw new Error('API grąžino neteisingą Shopify domeną.');
      saveMogaShopifyConnectedShop(shop);

      const r=await fetch(`${SHOPIFY_API_BASE}/shopify/locations?shop=${encodeURIComponent(shop)}`,{
        method:'GET',credentials:'include',headers:mogaShopifyAuthHeaders(),cache:'no-store'
      });
      const data=await r.json().catch(()=>null);
      if(!r.ok||!data?.ok)throw new Error(data?.message||`HTTP ${r.status}`);
      const locations=Array.isArray(data.locations)?data.locations:[];
      setShopifyConnectionState({
        checked:true,connected:true,loading:false,shop,
        shopName:String(data.shop?.name||status.shopName||'Shopify'),
        locationId:String(data.selectedLocationId||status.locationId||''),
        locationName:String(data.selectedLocationName||status.locationName||''),
        locations,error:''
      });
      if(autoSelect&&!data.selectedLocationId&&locations.length===1){
        await selectMogaShopifyApiLocation(locations[0].id,true);
      }
      return true;
    }catch(err){
      localStorage.removeItem(SHOPIFY_MULTI_SHOP_KEY);
      setShopifyConnectionState({checked:true,connected:false,loading:false,shop:'',shopName:'',locationId:'',locationName:'',locations:[],error:quiet?'':`Ryšys dar neaktyvus: ${err?.message||err}`});
      return false;
    }
  }
  window.refreshMogaShopifyConnectionState=refreshMogaShopifyConnectionState;

  async function connectMogaShopify(){
    const input=document.getElementById('mogaShopifyShopInput');
    const shop=normalizeMogaShopDomain(input?.value||'');
    if(!shop){
      setShopifyConnectionState({error:'Įrašyk Shopify adresą, pvz. mano-parduotuve.myshopify.com'});
      input?.focus();return;
    }
    localStorage.setItem(SHOPIFY_MULTI_LAST_SHOP_KEY,shop);
    setShopifyConnectionState({shop,error:'',loading:true});
    let authorizeUrl='';
    try{
      const start=await fetch(`${SHOPIFY_API_BASE}/shopify/connect/start`,{
        method:'POST',
        credentials:'include',
        headers:mogaShopifyAuthHeaders({'Content-Type':'application/json'}),
        body:JSON.stringify({shop})
      });
      const data=await start.json().catch(()=>null);
      if(!start.ok||!data?.ok||!data?.authorizeUrl)throw new Error(data?.message||`HTTP ${start.status}`);
      authorizeUrl=String(data.authorizeUrl);
    }catch(err){
      setShopifyConnectionState({shop,loading:false,error:String(err?.message||err)});
      window.MOGA_UI?.alert?.(`Nepavyko pradėti Shopify prijungimo.\n\n${err?.message||err}`,{title:'SHOPIFY SYNC'});
      return;
    }
    const popup=window.open(authorizeUrl,'mogaShopifyConnect','width=720,height=760,resizable=yes,scrollbars=yes');
    if(!popup){
      window.location.href=authorizeUrl;
      return;
    }
    if(shopifyConnectPollTimer)clearInterval(shopifyConnectPollTimer);
    let tries=0;
    shopifyConnectPollTimer=setInterval(async()=>{
      tries++;
      const ok=await refreshMogaShopifyConnectionState({quiet:true});
      if(ok||tries>=90){
        clearInterval(shopifyConnectPollTimer);shopifyConnectPollTimer=null;
        if(ok){try{popup.close()}catch(_){}}
      }
    },2000);
  }
  window.connectMogaShopify=connectMogaShopify;

  async function disconnectMogaShopify(){
    const shop=mogaShopifyConnectedShop();
    if(!shop)return;
    const ok=await (window.MOGA_UI?.confirm
      ? window.MOGA_UI.confirm('Atjungti Shopify nuo SFAPP?\n\nShopify parduotuvė nebus pašalinta. Bus panaikintas tik SFAPP API ryšys ir serveryje saugomi autorizacijos tokenai.',{title:'ATJUNGTI SHOPIFY',okText:'ATJUNGTI',cancelText:'ATŠAUKTI',danger:true})
      : Promise.resolve(confirm('Atjungti Shopify nuo SFAPP?')));
    if(!ok)return;

    try{
      const r=await fetch(`${SHOPIFY_API_BASE}/shopify/disconnect`,{
        method:'POST',credentials:'include',headers:mogaShopifyAuthHeaders({'Content-Type':'application/json'}),
        body:JSON.stringify({shop})
      });
      const data=await r.json().catch(()=>null);
      if(!r.ok||!data?.ok)throw new Error(data?.message||`HTTP ${r.status}`);

      localStorage.setItem(SHOPIFY_MULTI_LAST_SHOP_KEY,shop);
      localStorage.removeItem(SHOPIFY_MULTI_SHOP_KEY);
      if(shopifyConnectPollTimer){clearInterval(shopifyConnectPollTimer);shopifyConnectPollTimer=null;}
      shopifyConnectionState={checked:true,connected:false,loading:false,shop:'',shopName:'',locationId:'',locationName:'',locations:[],error:''};
      const input=document.getElementById('mogaShopifyShopInput');
      if(input)input.value=shop;
      applyShopifyConnectionUi();
      renderShopifySync();
    }catch(err){
      window.MOGA_UI?.alert?.(`Nepavyko atjungti Shopify.\n\n${err?.message||err}`,{title:'SHOPIFY SYNC'});
    }
  }
  window.disconnectMogaShopify=disconnectMogaShopify;

  function forgetMogaShopifyConnection(){
    const shop=mogaShopifyConnectedShop()||mogaShopifyLastShop();
    if(shop)localStorage.setItem(SHOPIFY_MULTI_LAST_SHOP_KEY,shop);
    localStorage.removeItem(SHOPIFY_MULTI_SHOP_KEY);
    if(shopifyConnectPollTimer){clearInterval(shopifyConnectPollTimer);shopifyConnectPollTimer=null;}
    shopifyConnectionState={checked:true,connected:false,loading:false,shop:'',shopName:'',locationId:'',locationName:'',locations:[],error:''};
    const input=document.getElementById('mogaShopifyShopInput');if(input)input.value=shop||'';
    applyShopifyConnectionUi();
  }
  window.forgetMogaShopifyConnection=forgetMogaShopifyConnection;
  let shopifyCatalogRunning=false;
  let shopifyCatalogSnapshot=[];
  let shopifyCatalogNew=[];
  let shopifyCatalogIgnored=[];
  let shopifyCatalogKnownCount=0;
  let shopifyCatalogLikelyExisting=0;
  let shopifyCatalogActiveCount=0;
  let shopifyShowIgnored=false;
  const shopifyCatalogSelected=new Set();
  let shopifyShadowRunning=false;
  let shopifyShadowResults=[];
  const shopifyApiSyncSelected=new Set();
  let shopifyShadowOnlyDiffs=false;

  const SIZE_TAGS={
    '15ml':'yra15',
    '50ml':'yra50',
    '100ml':'yra100'
  };
  const MANAGED_TAGS=new Set(Object.values(SIZE_TAGS).map(x=>x.toLowerCase()));

  /* Eksporto pasirinkimas: pagal nutylėjimą visi rasti pakeitimai pažymėti.
     Nuimta varnelė išlieka iki kol konkretus pakeitimas dingsta arba vėl pažymimas. */
  const inventoryExcluded=new Set();
  const tagExcluded=new Set();

  const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  const norm=v=>String(v??'')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[–—−]/g,'-')
    .replace(/\s+/g,' ')
    .trim();
  const normLoose=v=>norm(v)
    .replace(/\s*-\s*/g,'-')
    .replace(/\b(15|50|100)\s*ml\.?\b/g,'$1ml')
    .replace(/[.!]+$/g,'')
    .trim();
  const number=v=>{const n=Number(String(v??'').trim().replace(',','.'));return Number.isFinite(n)?n:0;};

  /*
   * Shopify CSV šablonai gali būti kelių MB dydžio, todėl jų nelaikome localStorage.
   * localStorage paliekamas mažiems sync nustatymams / baseline, o INVENTORIAUS ir PRODUKTŲ
   * šablonai saugomi IndexedDB. Taip abu pilni Shopify CSV gali egzistuoti kartu ir nebeužkemša
   * naršyklės ~5 MB localStorage kvotos.
   */
  const SHOPIFY_TEMPLATE_DB='moga_sf_shopify_templates_v1';
  const SHOPIFY_TEMPLATE_STORE='templates';
  const SHOPIFY_TEMPLATE_KEYS=new Set([INV_TEMPLATE_KEY,PRODUCT_TEMPLATE_KEY]);
  const shopifyTemplateCache=new Map();
  let shopifyTemplateDbPromise=null;

  function openShopifyTemplateDb(){
    if(shopifyTemplateDbPromise)return shopifyTemplateDbPromise;
    shopifyTemplateDbPromise=new Promise((resolve,reject)=>{
      if(!('indexedDB' in window))return reject(new Error('IndexedDB nepalaikomas'));
      const req=indexedDB.open(SHOPIFY_TEMPLATE_DB,1);
      req.onupgradeneeded=()=>{const db=req.result;if(!db.objectStoreNames.contains(SHOPIFY_TEMPLATE_STORE))db.createObjectStore(SHOPIFY_TEMPLATE_STORE)};
      req.onsuccess=()=>resolve(req.result);
      req.onerror=()=>reject(req.error||new Error('IndexedDB atidaryti nepavyko'));
    });
    return shopifyTemplateDbPromise;
  }
  async function idbTemplateGet(key){
    const db=await openShopifyTemplateDb();
    return new Promise((resolve,reject)=>{const tx=db.transaction(SHOPIFY_TEMPLATE_STORE,'readonly');const rq=tx.objectStore(SHOPIFY_TEMPLATE_STORE).get(key);rq.onsuccess=()=>resolve(rq.result??null);rq.onerror=()=>reject(rq.error)});
  }
  async function idbTemplateSet(key,value){
    const db=await openShopifyTemplateDb();
    return new Promise((resolve,reject)=>{const tx=db.transaction(SHOPIFY_TEMPLATE_STORE,'readwrite');tx.objectStore(SHOPIFY_TEMPLATE_STORE).put(value,key);tx.oncomplete=()=>resolve(true);tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error||new Error('IndexedDB įrašymas nutrauktas'))});
  }
  async function hydrateShopifyTemplateCache(){
    try{
      for(const key of SHOPIFY_TEMPLATE_KEYS){
        let value=null;
        try{value=await idbTemplateGet(key)}catch(_){value=null}
        /* Vienkartinė migracija iš seno localStorage į IndexedDB. */
        if(value==null){
          try{const raw=localStorage.getItem(key);if(raw)value=JSON.parse(raw)}catch(_){value=null}
          if(value!=null){
            try{await idbTemplateSet(key,value);localStorage.removeItem(key)}catch(e){console.warn('Shopify šablono migracija į IndexedDB nepavyko',key,e)}
          }
        }else{
          /* Jei IndexedDB kopija jau yra, seną didelę localStorage kopiją saugiai pašaliname. */
          try{localStorage.removeItem(key)}catch(_){}
        }
        if(value!=null)shopifyTemplateCache.set(key,value);
      }
    }catch(e){console.warn('Shopify šablonų IndexedDB inicijavimas nepavyko',e)}
    try{renderShopifySync()}catch(_){}
  }

  function getJson(key,fallback){
    if(SHOPIFY_TEMPLATE_KEYS.has(key)){
      if(shopifyTemplateCache.has(key))return shopifyTemplateCache.get(key);
      /* Kol IndexedDB dar kraunasi, leidžiame nuskaityti seną localStorage kopiją. */
      try{const x=JSON.parse(localStorage.getItem(key)||'null');return x??fallback}catch(_){return fallback}
    }
    try{const x=JSON.parse(localStorage.getItem(key)||'null');return x??fallback}catch(_){return fallback}
  }
  function setJson(key,value){
    if(SHOPIFY_TEMPLATE_KEYS.has(key)){
      shopifyTemplateCache.set(key,value);
      /* Šabloną iš localStorage išimame iš karto, kad atlaisvintume kvotą. */
      try{localStorage.removeItem(key)}catch(_){}
      idbTemplateSet(key,value).catch(e=>{
        console.error('Shopify šablono IndexedDB įrašymo klaida',key,e);
        window.MOGA_UI?.alert?.('Nepavyko išsaugoti Shopify CSV šablono naršyklės duomenų bazėje.',{title:'SHOPIFY SINCHRONIZACIJA'});
      });
      return true;
    }
    const raw=JSON.stringify(value);
    try{localStorage.setItem(key,raw);return true}catch(e){
      console.error('Shopify sync localStorage klaida',key,e);
      /* Vidiniai render/saveSettings kvotos gedimai neturi sukurti neuždaromo alert ciklo. */
      try{window.MOGA_COMPACT_LOCAL_STORAGE_FOR_QUOTA?.()}catch(_){}
      try{localStorage.setItem(key,raw);return true}catch(e2){console.error('Shopify sync pakartotinis išsaugojimas nepavyko',key,e2);return false}
    }
  }
  setTimeout(hydrateShopifyTemplateCache,0);
  function getSettings(){return {...{location:''},...(getJson(SETTINGS_KEY,{})||{})}}
  function saveSettings(x){setJson(SETTINGS_KEY,{...getSettings(),...(x||{})})}
  function getManualMaps(){return getJson(MANUAL_MAP_KEY,{})||{}}
  function saveManualMaps(x){setJson(MANUAL_MAP_KEY,x||{})}
  function getUnmanagedShopify(){
    const raw=getJson(SHOPIFY_UNMANAGED_KEY,[]);
    return new Set(Array.isArray(raw)?raw.map(String):[]);
  }
  function saveUnmanagedShopify(set){setJson(SHOPIFY_UNMANAGED_KEY,[...set].map(String))}

  function parseCsv(text){
    text=String(text??'').replace(/^\uFEFF/,'');
    const first=text.split(/\r?\n/,1)[0]||'';
    const comma=(first.match(/,/g)||[]).length,semi=(first.match(/;/g)||[]).length;
    const delim=semi>comma?';':',';
    const out=[];let row=[],cell='',quoted=false;
    for(let i=0;i<text.length;i++){
      const ch=text[i];
      if(quoted){
        if(ch==='"'&&text[i+1]==='"'){cell+='"';i++;}
        else if(ch==='"')quoted=false;
        else cell+=ch;
      }else{
        if(ch==='"')quoted=true;
        else if(ch===delim){row.push(cell);cell='';}
        else if(ch==='\n'){row.push(cell.replace(/\r$/,''));out.push(row);row=[];cell='';}
        else cell+=ch;
      }
    }
    if(cell.length||row.length){row.push(cell.replace(/\r$/,''));out.push(row);}
    while(out.length&&out[out.length-1].every(v=>!String(v||'').trim()))out.pop();
    return out;
  }
  function csvCell(v){
    const s=String(v??'');
    return /[",\r\n]/.test(s)?`"${s.replace(/"/g,'""')}"`:s;
  }
  function encodeCsv(headers,rows){
    return '\uFEFF'+[headers,...rows].map(r=>r.map(csvCell).join(',')).join('\r\n');
  }
  function downloadCsv(name,headers,rows){
    const blob=new Blob([encodeCsv(headers,rows)],{type:'text/csv;charset=utf-8;'});
    const url=URL.createObjectURL(blob);const a=document.createElement('a');
    a.href=url;a.download=name;document.body.appendChild(a);a.click();a.remove();
    setTimeout(()=>URL.revokeObjectURL(url),1500);
  }
  function stamp(){
    const d=new Date(),z=n=>String(n).padStart(2,'0');
    return `${d.getFullYear()}-${z(d.getMonth()+1)}-${z(d.getDate())}_${z(d.getHours())}-${z(d.getMinutes())}`;
  }
  function indexOfHeader(headers,names){
    const hs=headers.map(x=>norm(x));
    for(const n of names){const i=hs.indexOf(norm(n));if(i>=0)return i;}
    return -1;
  }
  function tableObject(text,sourceName=''){
    const rows=parseCsv(text);if(rows.length<2)throw new Error('CSV failas tuščias arba netinkamas.');
    const headers=rows[0].map(x=>String(x??''));
    const width=headers.length;
    const data=rows.slice(1).map(r=>{const x=r.slice(0,width);while(x.length<width)x.push('');return x;});
    return {headers,rows:data,sourceName:String(sourceName||''),importedAt:new Date().toISOString()};
  }

  function productList(){
    try{return window.MOGA_INVENTORY?.products?.()||window.getProducts?.()||[]}catch(_){return[]}
  }
  function inventoryQty(p){
    try{return number(window.MOGA_INVENTORY?.getRecord?.(p.inventoryId)?.qty)}catch(_){return 0}
  }
  function sizeKey(v){
    const m=String(v||'').toLowerCase().match(/\b(15|50|100)\s*ml\.?\b/);
    return m?`${m[1]}ml`:'';
  }
  function cleanOption(v){
    v=String(v||'').trim();
    if(!v||/^(default title|default)$/i.test(v))return '';
    return v;
  }
  function shopifySfName(title,opts){
    const values=(opts||[]).map(cleanOption).filter(Boolean);
    return values.length?`${String(title||'').trim()} — ${values.join(' / ')}`:String(title||'').trim();
  }
  function variantKey(row,idx){
    const g=i=>i>=0?String(row[i]||'').trim():'';
    return [g(idx.handle),g(idx.location),g(idx.o1),g(idx.o2),g(idx.o3),g(idx.sku)].join('|');
  }
  function shopIdentity(row,idx){
    const g=i=>i>=0?String(row[i]||'').trim():'';
    return [g(idx.handle),g(idx.location),g(idx.o1),g(idx.o2),g(idx.o3)].join('|');
  }

  function inventoryIndexes(tpl){
    const h=tpl?.headers||[];
    return {
      handle:indexOfHeader(h,['Handle']),title:indexOfHeader(h,['Title']),
      o1:indexOfHeader(h,['Option1 Value','Option 1 Value']),o2:indexOfHeader(h,['Option2 Value','Option 2 Value']),o3:indexOfHeader(h,['Option3 Value','Option 3 Value']),
      sku:indexOfHeader(h,['SKU','Variant SKU']),location:indexOfHeader(h,['Location']),
      current:indexOfHeader(h,['On hand (current)','On hand']),next:indexOfHeader(h,['On hand (new)'])
    };
  }

  /* Shopify turi du oficialius Inventory CSV formatus:
     1) "All states" – Location + On hand (current) + On hand (new)
     2) "Available" – lokacijų pavadinimai yra atskiri stulpeliai.
     SFAPP viduje viską normalizuojame į 1 formatą, todėl likusi sync logika nekinta. */
  function availableInventoryLocationColumns(tpl){
    const h=tpl?.headers||[];
    const fixed=new Set([
      'handle','title','option1 name','option 1 name','option1 value','option 1 value',
      'option2 name','option 2 name','option2 value','option 2 value',
      'option3 name','option 3 name','option3 value','option 3 value',
      'sku','variant sku','hs code','coo','country of origin','barcode',
      'variant id','inventory item id','id'
    ].map(norm));
    return h.map((name,i)=>({name:String(name||'').trim(),i,key:norm(name)}))
      .filter(x=>x.name&&!fixed.has(x.key));
  }

  function isAvailableInventoryTemplate(tpl){
    const h=tpl?.headers||[];
    const hasHandle=indexOfHeader(h,['Handle'])>=0;
    const hasTitle=indexOfHeader(h,['Title'])>=0;
    const hasTags=indexOfHeader(h,['Tags'])>=0;
    const inv=inventoryIndexes(tpl);
    if(!hasHandle||!hasTitle||hasTags||inv.location>=0||inv.next>=0)return false;
    return availableInventoryLocationColumns(tpl).length>0;
  }

  function normalizeAvailableInventoryTemplate(tpl){
    if(!isAvailableInventoryTemplate(tpl))return tpl;
    const sourceHeaders=tpl.headers||[];
    const locations=availableInventoryLocationColumns(tpl);
    const locationIndexes=new Set(locations.map(x=>x.i));
    const baseIndexes=sourceHeaders.map((_,i)=>i).filter(i=>!locationIndexes.has(i));
    const headers=[...baseIndexes.map(i=>sourceHeaders[i]),'Location','On hand (current)','On hand (new)'];
    const rows=[];
    for(const row of (tpl.rows||[])){
      for(const loc of locations){
        const raw=row?.[loc.i];
        const qty=String(raw??'').trim();
        /* Tuščias langelis = šioje lokacijoje nėra reikšmės; jo be reikalo nedubliuojame. */
        if(qty==='')continue;
        rows.push([...baseIndexes.map(i=>row?.[i]??''),loc.name,qty,'']);
      }
    }
    return {...tpl,headers,rows,sourceFormat:'available',sourceHeaders:[...sourceHeaders],availableLocations:locations.map(x=>x.name)};
  }
  function productIndexes(tpl){
    const h=tpl?.headers||[];
    return {
      handle:indexOfHeader(h,['Handle']),title:indexOfHeader(h,['Title']),tags:indexOfHeader(h,['Tags']),
      o1:indexOfHeader(h,['Option1 Value','Option 1 Value']),o2:indexOfHeader(h,['Option2 Value','Option 2 Value']),o3:indexOfHeader(h,['Option3 Value','Option 3 Value']),
      sku:indexOfHeader(h,['Variant SKU','SKU'])
    };
  }

  function buildSfMaps(){
    const products=productList();
    const sku=new Map(),skuAmbiguous=new Set(),name=new Map(),loose=new Map();
    products.forEach(p=>{
      const s=norm(p.sku);
      if(s){
        if(sku.has(s)){skuAmbiguous.add(s);sku.delete(s);}
        else if(!skuAmbiguous.has(s))sku.set(s,p);
      }
      const n=norm(p.name);if(n&&!name.has(n))name.set(n,p);
      const l=normLoose(p.name);if(l&&!loose.has(l))loose.set(l,p);
    });
    return {products,sku,skuAmbiguous,name,loose};
  }

  function inventoryMappings(){
    const tpl=getJson(INV_TEMPLATE_KEY,null);if(!tpl)return {tpl:null,idx:null,rows:[],mapped:[],unmatched:[],locations:[]};
    const idx=inventoryIndexes(tpl);
    if([idx.handle,idx.title,idx.location,idx.next].some(i=>i<0))return {tpl,idx,rows:tpl.rows||[],mapped:[],unmatched:tpl.rows||[],locations:[]};
    const products=productList();
    const locations=[...new Set((tpl.rows||[]).map(r=>String(r[idx.location]||'').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'lt'));
    const settings=getSettings();
    const location=settings.location&&locations.includes(settings.location)?settings.location:(locations[0]||'');
    if(location!==settings.location)saveSettings({location});

    const raw=[];
    (tpl.rows||[]).forEach((row,rowIndex)=>{
      if(location&&String(row[idx.location]||'').trim()!==location)return;
      const sku=idx.sku>=0?String(row[idx.sku]||'').trim():'';
      const title=String(row[idx.title]||'').trim();
      const opts=[idx.o1,idx.o2,idx.o3].map(i=>i>=0?row[i]:'');
      const candidate=shopifySfName(title,opts);
      raw.push({row,rowIndex,sku,skuKey:norm(sku),title,opts,candidate,key:variantKey(row,idx),shopId:shopIdentity(row,idx),location,handle:String(row[idx.handle]||'').trim()});
    });

    const sf=products.map((p,i)=>({
      p,i,id:String(p.inventoryId||('sf-'+i)),sku:String(p.sku||'').trim(),skuKey:norm(p.sku),
      name:String(p.name||'').trim(),nameKey:norm(p.name),looseKey:normLoose(p.name)
    }));
    const mapped=[],unmatched=[];
    const usedSf=new Set(),usedShop=new Set();
    const addMap=(x,y,matchType)=>{usedShop.add(x.rowIndex);usedSf.add(y.id);mapped.push({...x,p:y.p,matchType});};

    // 0) Išsaugotas rankinis susiejimas visada laimi. Tai stabilus Shopify Handle + vieta + variantų identitetas.
    const manualMaps=getManualMaps();
    raw.forEach(x=>{
      const saved=manualMaps[x.shopId];
      const savedId=typeof saved==='string'?saved:String(saved?.inventoryId||'');
      if(!savedId)return;
      const y=sf.find(z=>z.id===savedId);
      if(y&&!usedSf.has(y.id))addMap(x,y,'Rankinis');
    });

    // 1) SKU yra absoliutus prioritetas, bet tik kai jis vienareikšmis ABIEJOSE pusėse.
    const shopBySku=new Map(),sfBySku=new Map();
    raw.forEach(x=>{if(x.skuKey){if(!shopBySku.has(x.skuKey))shopBySku.set(x.skuKey,[]);shopBySku.get(x.skuKey).push(x);}});
    sf.forEach(y=>{if(y.skuKey){if(!sfBySku.has(y.skuKey))sfBySku.set(y.skuKey,[]);sfBySku.get(y.skuKey).push(y);}});
    shopBySku.forEach((xs,k)=>{
      const ys=sfBySku.get(k)||[];
      if(xs.length===1&&ys.length===1)addMap(xs[0],ys[0],'SKU');
    });

    const remainingShop=()=>raw.filter(x=>!usedShop.has(x.rowIndex));
    const remainingSf=()=>sf.filter(y=>!usedSf.has(y.id));

    // 2) Automatinis pavadinimo susiejimas leidžiamas TIK jei toks pavadinimas yra unikalus visame
    // Shopify ir visame SFAPP rinkinyje. Jei egzistuoja du vienodi produktai, sistema nespėlioja net
    // tada, kai po SKU susiejimų lieka po vieną — tokius atvejus susiejame rankiniu būdu vieną kartą.
    function pairGloballyUnique(shopKeyFn,sfKeyFn,matchType){
      const allShop=new Map(),allSf=new Map();
      raw.forEach(x=>{const k=shopKeyFn(x);if(!k)return;if(!allShop.has(k))allShop.set(k,[]);allShop.get(k).push(x);});
      sf.forEach(y=>{const k=sfKeyFn(y);if(!k)return;if(!allSf.has(k))allSf.set(k,[]);allSf.get(k).push(y);});
      remainingShop().forEach(x=>{
        const k=shopKeyFn(x);if(!k)return;
        const xs=allShop.get(k)||[],ys=allSf.get(k)||[];
        if(xs.length!==1||ys.length!==1)return;
        const y=ys[0];if(!usedSf.has(y.id))addMap(x,y,matchType);
      });
    }
    pairGloballyUnique(x=>norm(x.candidate),y=>y.nameKey,'Pavadinimas');
    pairGloballyUnique(x=>x.opts.map(cleanOption).filter(Boolean).length?'':norm(x.title),y=>y.nameKey,'Title');
    pairGloballyUnique(x=>normLoose(x.candidate),y=>y.looseKey,'Pavadinimas (tolerantiškas)');

    remainingShop().forEach(x=>{
      const sameNameShop=remainingShop().filter(z=>norm(z.candidate)===norm(x.candidate)).length;
      const sameNameSf=remainingSf().filter(y=>y.nameKey===norm(x.candidate)).length;
      let reason='Nerastas atitikmuo';
      if(x.skuKey&&(shopBySku.get(x.skuKey)||[]).length>1)reason='Dublikuotas Shopify SKU';
      else if(x.skuKey&&(sfBySku.get(x.skuKey)||[]).length>1)reason='Dublikuotas SFAPP SKU';
      else if(x.skuKey&&(sfBySku.get(x.skuKey)||[]).length===0)reason='Shopify SKU nerastas SFAPP';
      else if(sameNameShop>1||sameNameSf>1)reason='Dviprasmiškas vienodas pavadinimas';
      unmatched.push({...x,p:null,reason});
    });
    return {tpl,idx,rows:tpl.rows||[],mapped,unmatched,locations,location};
  }

  function ensureBaselineFromTemplate(force=false){
    const m=inventoryMappings();if(!m.tpl||m.idx.current<0)return;
    const old=getJson(BASELINE_KEY,{})||{};let changed=false;
    m.mapped.forEach(x=>{
      if(force||old[x.key]===undefined){old[x.key]=number(x.row[m.idx.current]);changed=true;}
    });
    if(changed)setJson(BASELINE_KEY,old);
  }

  function inventoryDirty(){
    const m=inventoryMappings();
    /* Baseline = paskutinė patvirtinta Shopify būsena.
       - Įkėlus naują Inventory CSV, commitInventoryTemplate() baseline pilnai
         perkuria pagal realų Shopify "On hand (current)".
       - Pažymėjus "JAU SINCHRONIZUOTA", tik pasirinktos eilutės baseline
         atnaujinamas į dabartinį SFAPP likutį.
       - Jei po to SFAPP likutis vėl pasikeičia, prekė automatiškai vėl atsiranda. */
    const saved=getJson(BASELINE_KEY,{})||{};
    const baseline={...saved};
    let changed=false;
    if(m.idx&&m.idx.current>=0){
      m.mapped.forEach(x=>{
        if(baseline[x.key]===undefined){
          baseline[x.key]=number(x.row[m.idx.current]);
          changed=true;
        }
      });
    }
    if(changed)setJson(BASELINE_KEY,baseline);
    const dirty=m.mapped.filter(x=>number(inventoryQty(x.p))!==number(baseline[x.key]));
    return {...m,baseline,dirty};
  }

  function productTemplateGroups(){
    const tpl=getJson(PRODUCT_TEMPLATE_KEY,null);if(!tpl)return {tpl:null,idx:null,groups:new Map()};
    const idx=productIndexes(tpl);const groups=new Map();let lastTitle='';
    (tpl.rows||[]).forEach((row,rowIndex)=>{
      const handle=idx.handle>=0?String(row[idx.handle]||'').trim():'';if(!handle)return;
      const titleRaw=idx.title>=0?String(row[idx.title]||'').trim():'';
      if(titleRaw)lastTitle=titleRaw;
      if(!groups.has(handle))groups.set(handle,{handle,title:titleRaw||lastTitle,rows:[],firstRowIndex:rowIndex});
      const g=groups.get(handle);if(titleRaw)g.title=titleRaw;g.rows.push({row,rowIndex});
    });
    return {tpl,idx,groups};
  }

  function desiredManagedTagsForHandle(group,invMap){
    const found=new Set();
    invMap.mapped.forEach(x=>{
      const handle=String(x.row[invMap.idx.handle]||'').trim();if(handle!==group.handle)return;
      const opts=[invMap.idx.o1,invMap.idx.o2,invMap.idx.o3].map(i=>i>=0?x.row[i]:'');
      const sk=opts.map(sizeKey).find(Boolean)||sizeKey(x.candidate);
      const tag=SIZE_TAGS[sk];
      if(tag&&inventoryQty(x.p)>0)found.add(tag);
    });
    return found;
  }
  function splitTags(v){return String(v||'').split(',').map(x=>x.trim()).filter(Boolean)}
  function mergeManagedTags(existing,desired){
    const keep=splitTags(existing).filter(t=>!MANAGED_TAGS.has(t.toLowerCase()));
    const order=['yra15','yra50','yra100'];
    order.forEach(t=>{if(desired.has(t))keep.push(t)});
    return keep.join(', ');
  }
  function productTagDirty(){
    const pg=productTemplateGroups();const inv=inventoryMappings();
    if(!pg.tpl||pg.idx.tags<0||pg.idx.handle<0)return {...pg,inv,dirty:[]};
    const dirty=[];
    pg.groups.forEach(group=>{
      const desired=desiredManagedTagsForHandle(group,inv);
      // Valdom tik tuos produktus, kurie turi 15/50/100 ml variantą Shopify inventoriaus šablone.
      const hasManagedVariant=inv.mapped.some(x=>{
        if(String(x.row[inv.idx.handle]||'').trim()!==group.handle)return false;
        return [inv.idx.o1,inv.idx.o2,inv.idx.o3].some(i=>i>=0&&!!sizeKey(x.row[i]));
      });
      if(!hasManagedVariant)return;
      const first=group.rows[0]?.row;if(!first)return;
      const oldTags=String(first[pg.idx.tags]||'');
      const nextTags=mergeManagedTags(oldTags,desired);
      const managedOld=new Set(splitTags(oldTags).map(x=>x.toLowerCase()).filter(x=>MANAGED_TAGS.has(x)));
      const managedNext=new Set(splitTags(nextTags).map(x=>x.toLowerCase()).filter(x=>MANAGED_TAGS.has(x)));
      if(JSON.stringify([...managedOld].sort())!==JSON.stringify([...managedNext].sort()))dirty.push({group,oldTags,nextTags});
    });
    return {...pg,inv,dirty};
  }

  function selectedInventoryDirty(d=inventoryDirty()){
    return d.dirty.filter(x=>!inventoryExcluded.has(x.key));
  }
  function selectedTagDirty(d=productTagDirty()){
    return d.dirty.filter(x=>!tagExcluded.has(x.group.handle));
  }

  function exportInventoryChanges(){
    const d=inventoryDirty();
    if(!d.tpl)return window.MOGA_UI?.alert?.('Pirmiausia įkelk Shopify inventoriaus CSV šabloną.',{title:'SHOPIFY INVENTORIUS'});
    if(!d.dirty.length)return window.MOGA_UI?.alert?.('Shopify inventoriaus pakeitimų nėra.',{title:'SHOPIFY INVENTORIUS'});
    const selected=selectedInventoryDirty(d);
    if(!selected.length)return window.MOGA_UI?.alert?.('Nė vienas inventoriaus pakeitimas nepažymėtas eksportui.',{title:'SHOPIFY INVENTORIUS'});
    const rows=selected.map(x=>{
      const r=[...x.row];r[d.idx.next]=String(inventoryQty(x.p));return r;
    });
    downloadCsv(`MOGA_Shopify_INVENTORIUS_${stamp()}.csv`,d.tpl.headers,rows);
    // Nauju atskaitos tašku tampa tik faktiškai eksportuotos eilutės.
    const baseline={...(d.baseline||{})};
    selected.forEach(x=>{baseline[x.key]=number(inventoryQty(x.p));inventoryExcluded.delete(x.key);});
    setJson(BASELINE_KEY,baseline);
    renderShopifySync();
  }
  window.exportShopifyInventoryChanges=exportInventoryChanges;

  function exportProductTagChanges(){
    const d=productTagDirty();
    if(!d.tpl)return window.MOGA_UI?.alert?.('Pirmiausia įkelk Shopify produktų CSV šabloną.',{title:'SHOPIFY TAGAI'});
    if(!d.inv.tpl)return window.MOGA_UI?.alert?.('Pirmiausia įkelk Shopify inventoriaus CSV šabloną.',{title:'SHOPIFY TAGAI'});
    if(!d.dirty.length)return window.MOGA_UI?.alert?.('Shopify tagų pakeitimų nėra.',{title:'SHOPIFY TAGAI'});
    const selected=selectedTagDirty(d);
    if(!selected.length)return window.MOGA_UI?.alert?.('Nė vienas tagų pakeitimas nepažymėtas eksportui.',{title:'SHOPIFY TAGAI'});
    const changedHandles=new Set(selected.map(x=>x.group.handle));
    const desiredByHandle=new Map(selected.map(x=>[x.group.handle,x.nextTags]));

    // FULL SAFE Shopify Product CSV:
    // - paliekame VISUS originalaus Shopify Products eksporto laukus ir reikšmes,
    //   todėl preview išlaiko realias kainas, SKU, aprašymus, paveikslėlius ir kt.;
    // - vienintelį "Variant Inventory Qty" stulpelį VISIŠKAI PAŠALINAME iš CSV,
    //   todėl Product CSV importas negali perrašyti sandėlio kiekio;
    // - Tags pakeičiame tik pirmoje konkretaus produkto eilutėje, kaip Shopify eksporte.
    // SVARBU: nepaliekame inventory stulpelio tuščio — jo faile apskritai nėra.
    const inventoryQtyCol=d.tpl.headers.findIndex(h=>String(h||'').trim().toLowerCase()==='variant inventory qty');
    const exportCols=d.tpl.headers.map((name,i)=>({name,i})).filter(x=>x.i!==inventoryQtyCol);
    const exportHeaders=exportCols.map(x=>x.name);
    const rows=[];
    d.tpl.rows.forEach(row=>{
      const handle=String(row[d.idx.handle]||'').trim();if(!changedHandles.has(handle))return;
      const group=d.groups.get(handle);
      const isFirst=!!(group&&group.rows[0]?.row===row);
      rows.push(exportCols.map(col=>{
        if(col.i===d.idx.tags)return isFirst?(desiredByHandle.get(handle)||''):'';
        return row[col.i]??'';
      }));
    });
    downloadCsv(`MOGA_Shopify_TAGAI_FULL_SAFE_${stamp()}.csv`,exportHeaders,rows);
    // Lokaliai patvirtiname tik faktiškai eksportuotus tagų pakeitimus.
    selected.forEach(x=>{const first=x.group.rows[0]?.row;if(first)first[d.idx.tags]=x.nextTags;tagExcluded.delete(x.group.handle);});
    setJson(PRODUCT_TEMPLATE_KEY,d.tpl);
    renderShopifySync();
  }
  window.exportShopifyProductTagChanges=exportProductTagChanges;

  function exportBoth(){
    const inv=inventoryDirty(),tags=productTagDirty();
    if(!inv.tpl||!tags.tpl)return window.MOGA_UI?.alert?.('Pirmiausia įkelk abu Shopify CSV šablonus: inventoriaus ir produktų.',{title:'SHOPIFY SINCHRONIZACIJA'});
    if(!inv.dirty.length&&!tags.dirty.length)return window.MOGA_UI?.alert?.('Shopify pakeitimų nėra.',{title:'SHOPIFY SINCHRONIZACIJA'});
    const invSelected=selectedInventoryDirty(inv),tagSelected=selectedTagDirty(tags);
    if(!invSelected.length&&!tagSelected.length)return window.MOGA_UI?.alert?.('Nė vienas pakeitimas nepažymėtas eksportui.',{title:'SHOPIFY SINCHRONIZACIJA'});
    if(invSelected.length)exportInventoryChanges();
    if(tagSelected.length)setTimeout(exportProductTagChanges,180);
  }
  window.exportShopifyAllChanges=exportBoth;

  function toggleShopifyInventoryChange(key,on){
    key=String(key||'');if(!key)return;
    if(on)inventoryExcluded.delete(key);else inventoryExcluded.add(key);
    renderShopifySync();
  }
  function toggleShopifyTagChange(handle,on){
    handle=String(handle||'');if(!handle)return;
    if(on)tagExcluded.delete(handle);else tagExcluded.add(handle);
    renderShopifySync();
  }
  function markSelectedShopifyInventorySynced(){
    const d=inventoryDirty();
    const selected=selectedInventoryDirty(d);
    if(!selected.length)return window.MOGA_UI?.alert?.('Pažymėk bent vieną jau sinchronizuotą likučio pakeitimą.',{title:'SHOPIFY SINCHRONIZACIJA'});
    const baseline={...(d.baseline||{})};
    selected.forEach(x=>{
      baseline[x.key]=number(inventoryQty(x.p));
      inventoryExcluded.delete(x.key);
    });
    setJson(BASELINE_KEY,baseline);
    renderShopifySync();
  }
  window.markSelectedShopifyInventorySynced=markSelectedShopifyInventorySynced;

  function toggleAllShopifyInventoryChanges(on){
    const d=inventoryDirty();
    d.dirty.forEach(x=>on?inventoryExcluded.delete(x.key):inventoryExcluded.add(x.key));
    renderShopifySync();
  }
  function toggleAllShopifyTagChanges(on){
    const d=productTagDirty();
    d.dirty.forEach(x=>on?tagExcluded.delete(x.group.handle):tagExcluded.add(x.group.handle));
    renderShopifySync();
  }
  window.toggleShopifyInventoryChange=toggleShopifyInventoryChange;
  window.toggleShopifyTagChange=toggleShopifyTagChange;
  window.toggleAllShopifyInventoryChanges=toggleAllShopifyInventoryChanges;
  window.toggleAllShopifyTagChanges=toggleAllShopifyTagChanges;

  function classifyShopifyTemplate(tpl){
    const inv=inventoryIndexes(tpl),prod=productIndexes(tpl);
    const isProducts=[prod.handle,prod.title,prod.tags].every(i=>i>=0);
    const isAllStatesInventory=[inv.handle,inv.title,inv.location,inv.current,inv.next].every(i=>i>=0);
    const isAvailableInventory=isAvailableInventoryTemplate(tpl);
    /* Produktų CSV turi Tags ir neturi būti palaikytas Inventory vien dėl papildomų stulpelių. */
    if(isProducts&&isAllStatesInventory)return {type:'ambiguous',label:'NEAIŠKUS'};
    if(isAllStatesInventory)return {type:'inventory',label:'INVENTORIAUS',format:'all-states'};
    if(isAvailableInventory)return {type:'inventory',label:'INVENTORIAUS',format:'available'};
    if(isProducts)return {type:'products',label:'PRODUKTŲ'};
    return {type:'unknown',label:'NEATPAŽINTAS'};
  }

  function prepareInventoryTemplate(tpl){
    tpl=normalizeAvailableInventoryTemplate(tpl);
    const idx=inventoryIndexes(tpl);
    const required=[['Handle',idx.handle],['Title',idx.title],['Location',idx.location],['On hand (current)',idx.current],['On hand (new)',idx.next]];
    const missing=required.filter(x=>x[1]<0).map(x=>x[0]);
    if(missing.length)throw new Error('Inventoriaus CSV trūksta stulpelių: '+missing.join(', '));
    return {tpl,idx};
  }
  function prepareProductTemplate(tpl){
    const idx=productIndexes(tpl);
    const missing=[['Handle',idx.handle],['Title',idx.title],['Tags',idx.tags]].filter(x=>x[1]<0).map(x=>x[0]);
    if(missing.length)throw new Error('Produktų CSV trūksta stulpelių: '+missing.join(', '));
    return {tpl,idx};
  }
  function commitInventoryTemplate(tpl,idx){
    setJson(INV_TEMPLATE_KEY,tpl);
    const locations=[...new Set(tpl.rows.map(r=>String(r[idx.location]||'').trim()).filter(Boolean))];
    const cur=getSettings().location;saveSettings({location:locations.includes(cur)?cur:(locations[0]||'')});
    setJson(BASELINE_KEY,{});ensureBaselineFromTemplate(true);
  }
  function commitProductTemplate(tpl){setJson(PRODUCT_TEMPLATE_KEY,tpl);}

  async function onAutoFiles(input){
    const files=[...(input?.files||[])];if(!files.length)return;
    try{
      if(files.length>2)throw new Error('Pasirink daugiausia 2 CSV failus: vieną inventoriaus ir vieną produktų. Nieko neįkelta.');

      /* Pirmiausia VISUS failus perskaitome ir atpažįstame. Tik jei visas rinkinys
         tvarkingas, tada ką nors keičiame saugykloje — jokio dalinio importo. */
      const prepared=[];
      for(const file of files){
        if(!/\.csv$/i.test(file.name||''))throw new Error(`„${file.name}“ nėra CSV failas. Nieko neįkelta.`);
        const text=await file.text();
        const tpl=tableObject(text,file.name);
        const kind=classifyShopifyTemplate(tpl);
        if(kind.type==='ambiguous')throw new Error(`„${file.name}“ turi ir inventoriaus, ir produktų požymių. Saugumo sumetimais failas neįkeltas.`);
        if(kind.type==='unknown')throw new Error(`„${file.name}“ neatpažintas kaip Shopify inventoriaus ar produktų CSV. Nieko neįkelta.`);
        prepared.push({file,tpl,kind});
      }

      const invs=prepared.filter(x=>x.kind.type==='inventory');
      const prods=prepared.filter(x=>x.kind.type==='products');
      if(invs.length>1)throw new Error('Pasirinkti keli INVENTORIAUS CSV failai. Palik tik vieną. Nieko neįkelta.');
      if(prods.length>1)throw new Error('Pasirinkti keli PRODUKTŲ CSV failai. Palik tik vieną. Nieko neįkelta.');

      let invPrepared=null,prodPrepared=null;
      if(invs[0])invPrepared=prepareInventoryTemplate(invs[0].tpl);
      if(prods[0])prodPrepared=prepareProductTemplate(prods[0].tpl);

      if(invPrepared)commitInventoryTemplate(invPrepared.tpl,invPrepared.idx);
      if(prodPrepared)commitProductTemplate(prodPrepared.tpl);
      renderShopifySync();

      const loaded=[];
      if(invs[0])loaded.push(`INVENTORIAUS: ${invs[0].file.name}`);
      if(prods[0])loaded.push(`PRODUKTŲ: ${prods[0].file.name}`);
      await window.MOGA_UI?.alert?.(`Sistema pati atpažino failus.\n\n${loaded.join('\n')}`,{title:'SHOPIFY CSV ĮKELTA'});
    }catch(e){
      console.error(e);
      await window.MOGA_UI?.alert?.(e?.message||String(e),{title:'SHOPIFY CSV APSAUGA'});
    }
    input.value='';
  }
  window.mogaShopifyAutoFiles=onAutoFiles;

  function setLocation(v){saveSettings({location:String(v||'')});ensureBaselineFromTemplate(false);renderShopifySync()}
  window.setMogaShopifyLocation=setLocation;

  let manualMapTargetRow=null;
  function closeShopifyManualMap(){
    document.getElementById('mogaShopifyManualMapModal')?.remove();
    manualMapTargetRow=null;
  }
  function manualMapResults(query=''){
    const holder=document.getElementById('mogaShopifyManualResults');if(!holder)return;
    const q=norm(query);
    const inv=inventoryMappings();
    const usedIds=new Set(inv.mapped.filter(x=>x.matchType==='Rankinis').map(x=>String(x.p?.inventoryId||'')));
    const products=productList().filter(p=>{
      if(!q)return true;
      return norm(p.name).includes(q)||norm(p.sku).includes(q);
    }).slice(0,120);
    holder.innerHTML=products.length?products.map(p=>{
      const id=String(p.inventoryId||'');const used=usedIds.has(id);
      return `<button type="button" class="moga-shopify-manual-result" ${used?'disabled':''} onclick="saveShopifyManualMap('${esc(id)}')"><span><b>${esc(p.name||'—')}</b><small>SKU: ${esc(p.sku||'—')} · Likutis: ${number(inventoryQty(p)).toLocaleString('lt-LT')}</small></span><em>${used?'JAU SUSIETA':'SUSIETI'}</em></button>`;
    }).join(''):'<div class="moga-shopify-change-empty">Nerasta SFAPP prekių.</div>';
  }
  function openShopifyManualMap(rowIndex){
    const inv=inventoryMappings();const x=inv.unmatched.find(z=>z.rowIndex===Number(rowIndex));if(!x)return;
    manualMapTargetRow=x;closeShopifyManualMap();manualMapTargetRow=x;
    const modal=document.createElement('div');modal.id='mogaShopifyManualMapModal';modal.className='moga-shopify-manual-modal';
    modal.innerHTML=`<div class="moga-shopify-manual-card"><div class="moga-shopify-manual-head"><div><small>SHOPIFY → SFAPP</small><h4>RANKINIS SUSIEJIMAS</h4></div><button type="button" onclick="closeShopifyManualMap()">×</button></div><div class="moga-shopify-manual-target"><b>${esc(x.candidate||x.title||'—')}</b><span>Shopify SKU: ${esc(x.sku||'—')}</span><span>Handle: ${esc(x.handle||'—')}</span></div><input id="mogaShopifyManualSearch" class="moga-shopify-manual-search" placeholder="Ieškoti SFAPP prekės pagal pavadinimą arba SKU..." oninput="renderShopifyManualMapResults(this.value)"><div id="mogaShopifyManualResults" class="moga-shopify-manual-results"></div><div class="moga-shopify-manual-note">Susiejimas išsaugomas naršyklėje pagal Shopify Handle + variantą. Kitą kartą sistema šios poros nebespėlios.</div></div>`;
    document.body.appendChild(modal);manualMapResults(x.title||x.candidate||'');
    setTimeout(()=>document.getElementById('mogaShopifyManualSearch')?.focus(),30);
  }
  function saveShopifyManualMap(inventoryId){
    const x=manualMapTargetRow;if(!x)return;
    const p=productList().find(z=>String(z.inventoryId||'')===String(inventoryId||''));if(!p)return;
    const maps=getManualMaps();
    for(const [k,v] of Object.entries(maps)){
      const id=typeof v==='string'?v:String(v?.inventoryId||'');
      if(id===String(inventoryId)&&k!==x.shopId){
        window.MOGA_UI?.alert?.('Ši SFAPP prekė jau rankiniu būdu susieta su kitu Shopify produktu. Pirmiausia pašalink seną susiejimą.',{title:'SHOPIFY SUSIEJIMAS'});return;
      }
    }
    maps[x.shopId]={inventoryId:String(inventoryId),shopifyName:x.candidate||x.title||'',handle:x.handle||'',sku:x.sku||'',createdAt:new Date().toISOString()};
    saveManualMaps(maps);
    // Rankiniu būdu susiejus laikome dabartinį įkelto Shopify CSV kiekį nauju atskaitos tašku šiai konkrečiai eilutei.
    const tpl=getJson(INV_TEMPLATE_KEY,null),idx=inventoryIndexes(tpl);
    if(tpl&&idx.current>=0){const baseline=getJson(BASELINE_KEY,{})||{};baseline[x.key]=number(x.row[idx.current]);setJson(BASELINE_KEY,baseline);}
    closeShopifyManualMap();renderShopifySync();
  }
  async function removeShopifyManualMap(encodedShopId){
    const shopId=decodeURIComponent(String(encodedShopId||''));const maps=getManualMaps();if(!maps[shopId])return;
    const ok=window.MOGA_UI?.confirm?await window.MOGA_UI.confirm('Pašalinti šį rankinį Shopify ↔ SFAPP susiejimą? Sandėlio kiekiai nebus keičiami.',{title:'Pašalinti susiejimą?',danger:true,confirmText:'PAŠALINTI'}):confirm('Pašalinti susiejimą?');
    if(!ok)return;delete maps[shopId];saveManualMaps(maps);renderShopifySync();
  }
  window.openShopifyManualMap=openShopifyManualMap;window.closeShopifyManualMap=closeShopifyManualMap;window.saveShopifyManualMap=saveShopifyManualMap;window.removeShopifyManualMap=removeShopifyManualMap;window.renderShopifyManualMapResults=manualMapResults;

  async function resetSetup(){
    const ok=window.MOGA_UI?.confirm?await window.MOGA_UI.confirm('Pašalinti išsaugotus Shopify CSV šablonus ir sinchronizacijos atskaitos tašką? SF sandėlio likučiai nebus keičiami.',{title:'Atstatyti Shopify sinchronizaciją?',danger:true,requireCheck:true,checkText:'Patvirtinu Shopify sinchronizacijos nustatymų išvalymą',confirmText:'IŠVALYTI'}):confirm('Išvalyti Shopify sinchronizacijos nustatymus?');
    if(!ok)return;
    [INV_TEMPLATE_KEY,PRODUCT_TEMPLATE_KEY,BASELINE_KEY,SETTINGS_KEY].forEach(k=>localStorage.removeItem(k));
    inventoryExcluded.clear();tagExcluded.clear();
    renderShopifySync();
  }
  window.resetMogaShopifySync=resetSetup;

  function ensureShopifySyncUi(){
    const sheet=document.getElementById('warehouseSheet');if(!sheet)return false;
    const actions=sheet.querySelector('.inventory-head-actions');
    if(actions&&!document.getElementById('shopifySyncLaunch')){
      const b=document.createElement('button');b.type='button';b.id='shopifySyncLaunch';b.className='gold shopify-sync-launch';b.onclick=()=>openShopifySync();
      b.innerHTML='<span id="shopifySyncLaunchLabel">SHOPIFY SYNC · NEPRIJUNGTA</span><span id="shopifySyncLaunchCount" style="display:none">0</span>';
      actions.appendChild(b);
    }
    if(!document.getElementById('mogaShopifySyncModal')){
      document.body.insertAdjacentHTML('beforeend',`
      <div id="mogaShopifySyncModal" class="moga-shopify-sync-modal screen-only" aria-hidden="true">
        <div class="moga-shopify-sync-card" role="dialog" aria-modal="true" aria-labelledby="mogaShopifySyncTitle">
          <div class="moga-shopify-sync-scroll">
          <div class="moga-shopify-sync-head">
            <div><small>MOGA SF</small><h3 id="mogaShopifySyncTitle">SHOPIFY SINCHRONIZACIJA</h3></div>
            <button type="button" class="moga-shopify-sync-close" onclick="closeShopifySync()">×</button>
          </div>
          <div id="mogaShopifyConnectionPanel" class="moga-shopify-connect-panel">
            <div class="moga-shopify-connect-main">
              <div class="moga-shopify-connect-kicker">PREMIUM SHOPIFY SYNC</div>
              <h4>PRIJUNKITE SAVO SHOPIFY PARDUOTUVĘ</h4>
              <p>Prisijunkite prie savo Shopify parduotuvės per saugų OAuth. Prisijungimo tokenai laikomi užšifruoti serveryje — SFAPP jų nesaugo naršyklėje.</p>
              <div class="moga-shopify-shop-label">JŪSŲ SHOPIFY PARDUOTUVĖS ADRESAS</div>
              <div class="moga-shopify-connect-form">
                <input id="mogaShopifyShopInput" type="text" autocomplete="off" spellcheck="false" placeholder="pvz. mano-parduotuve.myshopify.com">
                <button type="button" onclick="connectMogaShopify()">PRIJUNGTI SHOPIFY</button>
              </div>
              <div class="moga-shopify-shop-help">Naudokite būtent <b>.myshopify.com</b> adresą, ne savo viešą domeną.</div>
              <div id="mogaShopifyConnectStatus" class="moga-shopify-connect-status"></div>
            </div>
            <div class="moga-shopify-connect-steps">
              <b>KAIP TAI VEIKIA?</b>
              <span>① Prijungi savo Shopify parduotuvę.</span>
              <span>② Sistema nuskaito aktyvias lokacijas.</span>
              <span>③ Pasirenki vietą, kurios likučius valdysi.</span>
              <span>④ SHADOW palygina Shopify ↔ SFAPP.</span>
              <span>⑤ SAFE SYNC keičia tik pažymėtus likučius su CAS apsauga.</span>
            </div>
          </div>
          <div id="mogaShopifyConnectedBar" class="moga-shopify-connected-bar">
            <div class="moga-shopify-connected-dot"></div>
            <div class="moga-shopify-connected-info">
              <b id="mogaShopifyConnectedName">Shopify</b>
              <span id="mogaShopifyConnectedDomain">—</span>
              <small id="mogaShopifyConnectedLocation">Lokacija: —</small>
            </div>
            <button type="button" onclick="refreshMogaShopifyConnectionState()">ATNAUJINTI RYŠĮ</button>
            <button type="button" class="secondary" onclick="disconnectMogaShopify()">ATJUNGTI SHOPIFY</button>
          </div>
          <div id="mogaShopifyApiLocationSetup" class="moga-shopify-api-location-setup" style="display:none">
            <div><b>PASIRINKITE SHOPIFY VIETĄ</b><span>Šios vietos inventorius bus lyginamas ir sinchronizuojamas su SFAPP.</span></div>
            <select id="mogaShopifyApiLocationSelect"></select>
            <button type="button" onclick="saveSelectedMogaShopifyApiLocation()">NAUDOTI ŠIĄ VIETĄ</button>
          </div>
          <div class="moga-shopify-sync-warning"><b>Prieš sinchronizaciją:</b> užregistruok SFAPP visas dar neįtrauktas Shopify pardavimo sąskaitas, kad SF likutis būtų aktualus.</div>
          <div class="moga-shopify-sync-grid">
            <div class="moga-shopify-sync-stat"><span>INVENTORIAUS ŠABLONAS</span><strong id="shopifyInvTemplateStatus">—</strong></div>
            <div class="moga-shopify-sync-stat"><span>PRODUKTŲ ŠABLONAS</span><strong id="shopifyProductTemplateStatus">—</strong></div>
            <div class="moga-shopify-sync-stat"><span>SUSIETA</span><strong id="shopifyMappedStatus">—</strong></div>
            <div class="moga-shopify-sync-stat accent"><span>LIKUČIŲ PAKEITIMAI</span><strong id="shopifyInventoryDirty">0</strong></div>
            <div class="moga-shopify-sync-stat accent"><span>TAGŲ PAKEITIMAI</span><strong id="shopifyTagsDirty">0</strong></div>
          </div>
          <div class="moga-shopify-sync-setup">
            <div class="moga-shopify-sync-field"><label>Shopify vieta</label><select id="shopifySyncLocation" onchange="setMogaShopifyLocation(this.value)"></select></div>
            <div class="moga-shopify-sync-template-actions">
              <button type="button" onclick="document.getElementById('shopifyAutoTemplateFiles').click()">ĮKELTI SHOPIFY CSV</button>
              <input id="shopifyAutoTemplateFiles" type="file" accept=".csv,text/csv" multiple hidden onchange="mogaShopifyAutoFiles(this)">
            </div>
          </div>
          <div class="moga-shopify-change-panels">
            <details class="moga-shopify-changes" open>
              <summary><span>LIKUČIŲ PAKEITIMAI</span><b id="shopifyInventoryChangeSummary">0 / 0 pažymėta</b></summary>
              <div class="moga-shopify-change-tools"><label><input id="shopifyInventoryAllCheck" type="checkbox" onchange="toggleAllShopifyInventoryChanges(this.checked)"><span>Pažymėti visus</span></label><button type="button" id="shopifyInventorySyncedBtn" class="moga-shopify-synced-btn" onclick="markSelectedShopifyInventorySynced()">JAU SINCHRONIZUOTA</button></div>
              <div id="shopifyInventoryChangeList" class="moga-shopify-change-list"></div>
            </details>
            <details class="moga-shopify-changes" open>
              <summary><span>TAGŲ PAKEITIMAI</span><b id="shopifyTagChangeSummary">0 / 0 pažymėta</b></summary>
              <div class="moga-shopify-change-tools"><label><input id="shopifyTagAllCheck" type="checkbox" onchange="toggleAllShopifyTagChanges(this.checked)"><span>Pažymėti visus</span></label></div>
              <div id="shopifyTagChangeList" class="moga-shopify-change-list"></div>
            </details>
          </div>
          <details class="moga-shopify-unmatched"><summary id="shopifyUnmatchedSummary">Nevaldomos per SFAPP: 0</summary><div id="shopifyUnmatchedList"></div></details>
          <details class="moga-shopify-unmatched moga-shopify-api-new" open>
            <summary><span>SHOPIFY → SFAPP · NAUJOS / NESUSIETOS PREKĖS</span><b id="shopifyCatalogSummary">NEPATIKRINTA</b></summary>
            <div class="moga-shopify-catalog-tools">
              <button id="shopifyCatalogRefreshBtn" type="button" onclick="refreshMogaShopifyCatalog()">ATNAUJINTI IŠ SHOPIFY</button>
              <button id="shopifyCatalogSelectAllBtn" type="button" onclick="toggleAllMogaShopifyNew(true)" style="display:none">PAŽYMĖTI VISAS NAUJAS</button>
              <button id="shopifyCatalogImportBtn" type="button" class="moga-shopify-import-action is-disabled" onclick="importMogaShopifySelected()" style="display:none">IMPORTUOTI Į SFAPP</button>
              <button id="shopifyCatalogIgnoreBtn" type="button" onclick="ignoreMogaShopifySelected()" style="display:none">NEVALDYTI PER SFAPP</button>
              <button id="shopifyCatalogIgnoredBtn" type="button" onclick="toggleMogaShopifyIgnored()" style="display:none">RODYTI NEVALDOMAS</button>
              <span id="shopifyCatalogHint">Nuskaito Shopify ir parodo tik tas prekes / variantus, kurių SFAPP dar neturi.</span>
            </div>
            <div id="shopifyCatalogList" class="moga-shopify-catalog-list"></div>
          </details>
          <details class="moga-shopify-unmatched moga-shopify-api-shadow" open>
            <summary><span>API SHADOW PATIKRA</span><b id="shopifyShadowSummary">NEPATIKRINTA</b></summary>
            <div class="moga-shopify-shadow-tools">
              <button id="shopifyShadowCheckBtn" type="button" onclick="runMogaShopifyShadowCheck()">PATIKRINTI PER API — NIEKO NEKEISTI</button>
              <button id="shopifyShadowDiffBtn" type="button" onclick="toggleMogaShopifyShadowDiffs()" style="display:none">RODYTI TIK SKIRTUMUS</button>
              <button id="shopifyApiSyncBtn" type="button" onclick="syncMogaShopifySelected()" style="display:none">SINCHRONIZUOTI PAŽYMĖTUS</button>
              <span id="shopifyApiSyncHint">SAFE API: prijungta parduotuvė + pasirinkta lokacija iš D1. Patikra nieko nekeičia.</span>
            </div>
            <div id="shopifyShadowList" class="moga-shopify-shadow-list"></div>
          </details>
          <div class="moga-shopify-sync-export">
            <button id="shopifyExportInventoryBtn" type="button" class="primary" onclick="exportShopifyInventoryChanges()">EKSPORTUOTI INVENTORIAUS PAKEITIMUS</button>
            <button id="shopifyExportTagsBtn" type="button" class="primary" onclick="exportShopifyProductTagChanges()">EKSPORTUOTI TAGŲ PAKEITIMUS</button>
            <button id="shopifyExportAllBtn" type="button" class="mega" onclick="exportShopifyAllChanges()">PARUOŠTI ABU SHOPIFY FAILUS</button>
          </div>
          <div class="moga-shopify-sync-foot"><span>Inventoriaus CSV keičia tik <b>naują sandėlio kiekį</b>. Tagų CSV neturi inventoriaus laukų ir koreguoja tik sistemos valdomus tagus; likučius keičia tik Inventoriaus CSV.</span><button type="button" onclick="resetMogaShopifySync()">ATSTATYTI NUSTATYMUS</button></div>
          </div>
        </div>
      </div>`);
      const modal=document.getElementById('mogaShopifySyncModal');
      modal.addEventListener('mousedown',e=>{if(e.target===modal)closeShopifySync()});
    }
    if(!document.getElementById('mogaShopifySyncCss')){
      const st=document.createElement('style');st.id='mogaShopifySyncCss';st.textContent=`
        #shopifySyncLaunch{display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important}
        #shopifySyncLaunch #shopifySyncLaunchLabel{display:inline!important;min-width:0!important;height:auto!important;padding:0!important;border-radius:0!important;background:transparent!important;color:inherit!important;font-size:inherit!important;font-weight:inherit!important}
        #shopifySyncLaunch #shopifySyncLaunchCount{display:inline-grid;place-items:center;min-width:22px;height:22px;padding:0 6px;border-radius:999px;background:#111;color:#fff;font-size:10px;font-weight:1000}
        .moga-shopify-connect-panel{display:none;margin:18px 22px;padding:20px;border:1px solid #3a3a3a;border-radius:16px;background:linear-gradient(135deg,#1d1d1d,#181818);grid-template-columns:minmax(0,1.3fr) minmax(250px,.8fr);gap:24px}
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-connect-panel{display:grid}
        .moga-shopify-connect-kicker{color:#ff9418;font-size:9px;font-weight:1000;letter-spacing:.11em}
        .moga-shopify-connect-main h4{margin:5px 0 8px;color:#fff;font-size:18px;line-height:1.2}
        .moga-shopify-connect-main p{margin:0;color:#aaa;font-size:11px;line-height:1.55;max-width:620px}
        .moga-shopify-shop-label{margin-top:15px;color:#e7e7e7;font-size:9px;font-weight:1000;letter-spacing:.055em}
        .moga-shopify-connect-form{display:grid;grid-template-columns:minmax(220px,1fr) auto;gap:9px;margin-top:6px}
        .moga-shopify-shop-help{margin-top:6px;color:#7f7f7f;font-size:9px;line-height:1.4}
        .moga-shopify-shop-help b{color:#aaa}
        .moga-shopify-connect-form input{height:42px;border:1px solid #474747;border-radius:10px;background:#fff;color:#111;padding:0 12px;font-size:11px;font-weight:800;outline:none}
        .moga-shopify-connect-form input::placeholder{color:#8a8a8a!important;opacity:1!important;font-weight:700!important}
        .moga-shopify-connect-form input:focus{border-color:#ff8a00;box-shadow:0 0 0 3px rgba(255,138,0,.12)}
        .moga-shopify-connect-form button,.moga-shopify-api-location-setup button{height:42px;border:0;border-radius:10px;padding:0 16px;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111;font-size:10px;font-weight:1000;cursor:pointer}
        .moga-shopify-connect-status{min-height:16px;margin-top:8px;color:#8d8d8d;font-size:9px;font-weight:800}
        .moga-shopify-connect-status.error{color:#ff808b}
        .moga-shopify-connect-steps{display:flex;flex-direction:column;gap:9px;padding-left:20px;border-left:1px solid #343434;color:#aaa;font-size:10px;line-height:1.4}
        .moga-shopify-connect-steps>b{color:#fff;font-size:10px}
        .moga-shopify-connected-bar{display:none;align-items:center;gap:11px;margin:16px 22px 0;padding:11px 12px;border:1px solid #31463a;border-radius:12px;background:#18201b}
        .moga-shopify-sync-modal.is-shopify-connected .moga-shopify-connected-bar{display:flex}
        .moga-shopify-connected-dot{width:10px;height:10px;border-radius:50%;background:#52db87;box-shadow:0 0 0 4px rgba(82,219,135,.10)}
        .moga-shopify-connected-info{display:flex;flex-direction:column;min-width:0;margin-right:auto}
        .moga-shopify-connected-info b{font-size:11px;color:#fff}
        .moga-shopify-connected-info span{font-size:9px;color:#9d9d9d;overflow-wrap:anywhere}
        .moga-shopify-connected-info small{margin-top:2px;color:#69df94;font-size:9px;font-weight:900}
        .moga-shopify-connected-bar button{height:34px;border:1px solid #485149;border-radius:9px;background:#222b25;color:#fff;padding:0 10px;font-size:8px;font-weight:1000;cursor:pointer}
        .moga-shopify-connected-bar button.secondary{background:#202020;border-color:#444;color:#aaa}
        .moga-shopify-api-location-setup{display:flex;align-items:center;gap:10px;margin:12px 22px 0;padding:12px;border:1px solid #6a4b20;border-radius:12px;background:#241d14}
        .moga-shopify-api-location-setup>div{display:flex;flex-direction:column;min-width:0;margin-right:auto}
        .moga-shopify-api-location-setup b{font-size:10px;color:#fff}
        .moga-shopify-api-location-setup span{margin-top:2px;color:#ad9a81;font-size:9px}
        .moga-shopify-api-location-setup select{min-width:200px;height:40px;border:1px solid #555;border-radius:9px;background:#fff;color:#111;padding:0 9px;font-size:10px;font-weight:800}
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-sync-warning,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-sync-grid,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-sync-setup,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-change-panels,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-unmatched,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-api-new,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-api-shadow,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-sync-export,
        .moga-shopify-sync-modal.is-shopify-disconnected .moga-shopify-sync-foot{display:none!important}
        .moga-shopify-sync-modal{
          position:fixed;inset:0;z-index:2147482500;display:none;align-items:center;justify-content:center;
          padding:16px!important;box-sizing:border-box!important;background:rgba(0,0,0,.64);backdrop-filter:blur(5px)
        }
        .moga-shopify-sync-modal.open{display:flex}
        .moga-shopify-sync-card{
          width:min(900px,calc(100vw - 32px));max-height:calc(100dvh - 32px);
          overflow:hidden!important;border:1px solid transparent;border-radius:22px!important;
          background-image:linear-gradient(#151515,#151515),linear-gradient(135deg,#ff8a00,#ff4b93);
          background-origin:border-box;background-clip:padding-box,border-box;color:#fff;
          box-shadow:0 28px 90px rgba(0,0,0,.55);box-sizing:border-box!important
        }
        .moga-shopify-sync-scroll{
          width:100%;max-height:calc(100dvh - 34px);overflow-y:auto;overflow-x:hidden;
          border-radius:21px!important;scrollbar-gutter:stable;box-sizing:border-box;background:#151515
        }
        .moga-shopify-sync-head{position:sticky;top:0;z-index:4;display:flex;align-items:center;justify-content:space-between;padding:20px 22px 16px;background:#151515;border-bottom:1px solid #303030;border-radius:21px 21px 0 0}
        .moga-shopify-sync-head small{display:block;color:#ff9717;font-weight:1000;letter-spacing:.1em;font-size:10px}.moga-shopify-sync-head h3{margin:3px 0 0;font-size:23px;color:#fff}
        .moga-shopify-sync-close{width:38px;height:38px;border-radius:50%;border:1px solid #444;background:#242424;color:#fff;font-size:24px;cursor:pointer}
        .moga-shopify-sync-warning{margin:18px 22px 0;padding:12px 14px;border:1px solid #664b26;border-radius:12px;background:#241d14;color:#f7dfbd;font-size:12px;line-height:1.45}
        .moga-shopify-sync-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:9px;padding:16px 22px 0}.moga-shopify-sync-stat{padding:11px;border:1px solid #353535;border-radius:12px;background:#1d1d1d;min-width:0}.moga-shopify-sync-stat span{display:block;color:#999;font-size:9px;font-weight:1000;letter-spacing:.04em}.moga-shopify-sync-stat strong{display:block;margin-top:5px;font-size:16px;white-space:normal;overflow-wrap:anywhere;line-height:1.2}.moga-shopify-sync-stat.accent strong{color:#ff9b19;font-size:22px}
        .moga-shopify-sync-setup{display:flex;gap:12px;align-items:end;justify-content:space-between;padding:16px 22px}.moga-shopify-sync-field{min-width:220px}.moga-shopify-sync-field label{display:block;margin-bottom:5px;color:#aaa;font-size:10px;font-weight:900}.moga-shopify-sync-field select{width:100%;height:40px;border:1px solid #484848;border-radius:10px;background:#fff;color:#111;padding:0 10px;font-weight:800}.moga-shopify-sync-template-actions{display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end}.moga-shopify-sync-template-actions button,.moga-shopify-sync-foot button{height:40px;border:1px solid #484848;border-radius:10px;background:#242424;color:#fff;padding:0 12px;font-size:10px;font-weight:1000;cursor:pointer}.moga-shopify-sync-template-actions button:hover{border-color:#ff8a00}
        .moga-shopify-change-panels{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:0 22px 16px}
        .moga-shopify-changes{border:1px solid #353535;border-radius:12px;background:#1b1b1b;overflow:hidden}.moga-shopify-changes summary{display:flex;justify-content:space-between;gap:12px;align-items:center;padding:12px 13px;cursor:pointer;list-style:none;font-size:10px;font-weight:1000;color:#fff}.moga-shopify-changes summary::-webkit-details-marker{display:none}.moga-shopify-changes summary b{color:#ff9b19;font-size:10px}
        .moga-shopify-change-tools{padding:9px 12px;border-top:1px solid #2d2d2d;border-bottom:1px solid #2d2d2d;background:#181818}.moga-shopify-change-tools label{display:inline-flex;align-items:center;gap:8px;color:#aaa;font-size:10px;font-weight:900;cursor:pointer}
        .moga-shopify-change-list{max-height:240px;overflow-y:auto;overflow-x:hidden;min-width:0;width:100%;scrollbar-gutter:stable}.moga-shopify-change-row{display:grid;grid-template-columns:24px minmax(0,1fr) 72px;gap:8px;align-items:start;padding:10px 20px 10px 12px;border-top:1px solid #292929;min-width:0;width:100%;box-sizing:border-box}.moga-shopify-change-row:first-child{border-top:0}.moga-shopify-change-row>div{min-width:0}.moga-shopify-change-row .name{min-width:0;color:#fff;font-size:11px;font-weight:850;white-space:normal;overflow:visible;text-overflow:clip;overflow-wrap:anywhere;word-break:normal;line-height:1.28;max-width:100%;padding-right:4px}.moga-shopify-change-row .meta{margin-top:3px;color:#777;font-size:9px;white-space:normal;overflow-wrap:anywhere;line-height:1.25}.moga-shopify-change-row .delta{width:72px;white-space:nowrap;color:#ddd;font-size:11px;font-weight:900;justify-self:end;text-align:right;align-self:center;padding-right:4px}.moga-shopify-change-row .delta .from{color:#aaa}.moga-shopify-change-row .delta .arrow{padding:0 4px;color:#ff8a00}.moga-shopify-change-row .delta .to{color:#fff}.moga-shopify-change-row.off{opacity:.45}
        .moga-shopify-tag-row{grid-template-columns:24px minmax(0,1fr);grid-template-rows:auto auto;column-gap:8px;row-gap:4px;align-items:start;padding-right:20px}.moga-shopify-tag-row>input{grid-column:1;grid-row:1 / span 2}.moga-shopify-tag-row>div:nth-of-type(1){grid-column:2;grid-row:1}.moga-shopify-tag-row .delta{grid-column:2;grid-row:2;width:100%;max-width:100%;white-space:normal;overflow-wrap:anywhere;word-break:normal;line-height:1.3;text-align:left;justify-self:stretch;align-self:start;padding:0 0 1px 0}.moga-shopify-tag-row .delta .from,.moga-shopify-tag-row .delta .to{white-space:normal;overflow-wrap:anywhere}.moga-shopify-tag-row .delta .arrow{display:inline-block;white-space:nowrap;padding-left:0}
        .moga-shopify-change-row input,.moga-shopify-change-tools input{-webkit-appearance:none;appearance:none;width:18px;height:18px;margin:0;border:1.5px solid #555;border-radius:5px;background:#fff;display:inline-grid;place-content:center;cursor:pointer}.moga-shopify-change-row input:checked,.moga-shopify-change-tools input:checked{border-color:transparent;background:linear-gradient(135deg,#ff8a00,#ff4b93)}.moga-shopify-change-row input:checked::after,.moga-shopify-change-tools input:checked::after{content:'✓';color:#fff;font-size:12px;font-weight:1000;line-height:1}.moga-shopify-change-tools input:indeterminate{border-color:transparent;background:linear-gradient(135deg,#ff8a00,#ff4b93)}.moga-shopify-change-tools input:indeterminate::after{content:'−';color:#fff;font-size:12px;font-weight:1000;line-height:1}
        .moga-shopify-change-empty{padding:16px 12px;color:#777;font-size:10px}
        .moga-shopify-unmatched{margin:0 22px 16px;border:1px solid #333;border-radius:12px;background:#1b1b1b}.moga-shopify-unmatched summary{cursor:pointer;padding:11px 13px;color:#bbb;font-size:11px;font-weight:900}.moga-shopify-unmatched #shopifyUnmatchedList,.moga-shopify-unmatched #shopifyManualMapList{max-height:210px;overflow:auto;padding:0 13px 12px}.moga-shopify-unmatched .row{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:8px 0;border-top:1px solid #292929;font-size:10px;color:#ddd}.moga-shopify-unmatched .row>span{min-width:0;overflow-wrap:anywhere}.moga-shopify-unmatched .row small{color:#777}.moga-shopify-unmatched .row-actions{display:flex;align-items:center;gap:8px;flex:0 0 auto}.moga-shopify-unmatched .row button{height:28px;border:1px solid #4b4b4b;border-radius:8px;background:#262626;color:#fff;padding:0 9px;font-size:9px;font-weight:1000;cursor:pointer}.moga-shopify-unmatched .row button:hover{border-color:#ff8a00}.moga-shopify-manual-modal{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.72);backdrop-filter:blur(5px)}.moga-shopify-manual-card{width:min(650px,calc(100vw - 30px));max-height:min(720px,calc(100vh - 30px));display:flex;flex-direction:column;border:1px solid transparent;border-radius:18px;background-image:linear-gradient(#171717,#171717),linear-gradient(135deg,#ff8a00,#ff4b93);background-origin:border-box;background-clip:padding-box,border-box;color:#fff;overflow:hidden;box-shadow:0 30px 90px rgba(0,0,0,.6)}.moga-shopify-manual-head{display:flex;align-items:center;justify-content:space-between;padding:16px 18px;border-bottom:1px solid #303030}.moga-shopify-manual-head small{color:#ff9717;font-size:9px;font-weight:1000;letter-spacing:.1em}.moga-shopify-manual-head h4{margin:3px 0 0;font-size:18px}.moga-shopify-manual-head button{width:34px;height:34px;border:1px solid #444;border-radius:50%;background:#242424;color:#fff;font-size:22px;cursor:pointer}.moga-shopify-manual-target{display:grid;gap:3px;padding:13px 18px;background:#201b16;border-bottom:1px solid #493620}.moga-shopify-manual-target b{font-size:12px}.moga-shopify-manual-target span{font-size:9px;color:#aaa}.moga-shopify-manual-search{margin:14px 16px 10px;height:42px;border:1px solid #555;border-radius:10px;background:#fff;color:#111;padding:0 12px;font-size:12px;font-weight:700}.moga-shopify-manual-results{min-height:120px;max-height:420px;overflow:auto;padding:0 16px 12px}.moga-shopify-manual-result{width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 11px;border:1px solid #333;border-radius:10px;background:#202020;color:#fff;text-align:left;cursor:pointer;margin-bottom:7px}.moga-shopify-manual-result:hover:not(:disabled){border-color:#ff8a00;background:#25211d}.moga-shopify-manual-result:disabled{opacity:.38;cursor:not-allowed}.moga-shopify-manual-result span{min-width:0}.moga-shopify-manual-result b{display:block;font-size:11px;overflow-wrap:anywhere}.moga-shopify-manual-result small{display:block;margin-top:3px;color:#888;font-size:9px}.moga-shopify-manual-result em{flex:0 0 auto;color:#ff9b19;font-size:9px;font-weight:1000;font-style:normal}.moga-shopify-manual-note{padding:11px 16px 14px;border-top:1px solid #303030;color:#888;font-size:9px;line-height:1.4}
        .moga-shopify-api-new{margin:0 22px 16px!important;border:1px solid #4b3a28!important;border-radius:12px!important;background:#1b1b1b!important;overflow:hidden}
        .moga-shopify-api-new>summary{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 13px;cursor:pointer;list-style:none;color:#fff;font-size:11px;font-weight:1000}
        .moga-shopify-api-new>summary::-webkit-details-marker{display:none}
        .moga-shopify-api-new>summary b{color:#ff9b19;font-size:10px;white-space:nowrap}
        .moga-shopify-catalog-tools{display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:10px 12px;border-top:1px solid #303030;border-bottom:1px solid #303030;background:#181818}
        .moga-shopify-catalog-tools button{height:36px;border:1px solid #454545;border-radius:9px;padding:0 11px;background:#252525;color:#fff;font-size:9px;font-weight:1000;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;text-align:center}
        .moga-shopify-catalog-tools #shopifyCatalogRefreshBtn,.moga-shopify-catalog-tools #shopifyCatalogImportBtn{border:0;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#fff}
        .moga-shopify-catalog-tools #shopifyCatalogIgnoreBtn{border-color:#5c3c3c;color:#ffb4b4}
        .moga-shopify-catalog-tools button:disabled{opacity:.4;cursor:not-allowed}
        .moga-shopify-catalog-tools span{color:#888;font-size:9px;font-weight:800;line-height:1.35}
        .moga-shopify-catalog-list{max-height:300px;overflow-y:auto;overflow-x:hidden;scrollbar-gutter:stable;background:#151515}
        .moga-shopify-catalog-empty{padding:14px;color:#888;font-size:10px;font-weight:800}
        .moga-shopify-catalog-row{display:grid;grid-template-columns:28px minmax(0,1fr) auto;gap:11px;align-items:center;padding:9px 12px;border-bottom:1px solid #292929;min-width:0}
        .moga-shopify-catalog-row:last-child{border-bottom:0}
        .moga-shopify-catalog-row>div{min-width:0}
        .moga-shopify-catalog-row .pick{display:flex;align-items:center;justify-content:center;cursor:pointer}
        .moga-shopify-catalog-row .pick input{position:absolute;opacity:0;pointer-events:none}
        .moga-shopify-catalog-row .pick .moga-api-check{width:18px;height:18px;border:2px solid #5b5b5b;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#202020;transition:.15s ease;box-sizing:border-box}
        .moga-shopify-catalog-row .pick input:checked+.moga-api-check{border-color:#ff7b18;background:linear-gradient(135deg,#ff8a00,#ff4b93);box-shadow:0 0 0 2px rgba(255,123,24,.12)}
        .moga-shopify-catalog-row .pick input:checked+.moga-api-check:after{content:"✓";color:#fff;font-size:12px;font-weight:1000;line-height:1}
        .moga-shopify-catalog-row .name{color:#fff;font-size:10px;font-weight:900;line-height:1.28;overflow-wrap:anywhere}
        .moga-shopify-catalog-row .meta{margin-top:3px;color:#777;font-size:8px;line-height:1.3;overflow-wrap:anywhere}
        .moga-shopify-catalog-row .state{text-align:right;font-size:9px;font-weight:1000;color:#ff9b19;white-space:nowrap}
        .moga-shopify-catalog-row.ignored{grid-template-columns:minmax(0,1fr) auto;opacity:.72}
        .moga-shopify-catalog-row.ignored .state{color:#aaa}
                .moga-shopify-catalog-row.likely-existing{background:#191713}
        .moga-shopify-catalog-row .likely{margin-top:5px;color:#ff9b19;font-size:8px;font-weight:1000;letter-spacing:.04em}
        .moga-shopify-catalog-row .link-existing{display:block;margin-top:6px;border-color:#76501f;background:#2b2116;color:#ffad35;white-space:nowrap}
.moga-shopify-catalog-row .restore{height:30px;border:1px solid #555;border-radius:8px;background:#242424;color:#fff;padding:0 9px;font-size:8px;font-weight:1000;cursor:pointer}
        .moga-shopify-api-shadow{margin:0 22px 16px;border:1px solid #3b3b3b;border-radius:12px;background:#1b1b1b;overflow:hidden}
        .moga-shopify-api-shadow>summary{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 13px;cursor:pointer;list-style:none;color:#fff;font-size:11px;font-weight:1000}
        .moga-shopify-api-shadow>summary::-webkit-details-marker{display:none}
        .moga-shopify-api-shadow>summary b{color:#ff9b19;font-size:10px;white-space:nowrap}
        .moga-shopify-shadow-tools{display:flex;align-items:center;gap:10px;flex-wrap:wrap;padding:10px 12px;border-top:1px solid #303030;border-bottom:1px solid #303030;background:#181818}
        .moga-shopify-shadow-tools button{height:36px;border:0;border-radius:9px;padding:0 12px;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111;font-size:9px;font-weight:1000;cursor:pointer}
        .moga-shopify-shadow-tools button:disabled{opacity:.45;cursor:wait}
        .moga-shopify-shadow-tools span{color:#888;font-size:9px;font-weight:800}
        .moga-shopify-shadow-list{max-height:250px;overflow-y:auto;overflow-x:hidden;scrollbar-gutter:stable;background:#171717}
        .moga-shopify-shadow-row{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:12px;align-items:center;padding:9px 12px;border-bottom:1px solid #292929;min-width:0}
        .moga-shopify-shadow-row:last-child{border-bottom:0}
        .moga-shopify-shadow-row>div{min-width:0}
        .moga-shopify-shadow-row .name{color:#fff;font-size:10px;font-weight:900;line-height:1.25;overflow-wrap:anywhere}
        .moga-shopify-shadow-row .meta{margin-top:3px;color:#777;font-size:8px;line-height:1.25;overflow-wrap:anywhere}
        .moga-shopify-shadow-row .state{font-size:9px;font-weight:1000;white-space:nowrap;text-align:right}
        .moga-shopify-shadow-row.ok .state{color:#70d99a}
        .moga-shopify-shadow-row.diff .state{color:#ff9b19}
        .moga-shopify-shadow-row.error .state{color:#ff6b7a}
.moga-shopify-shadow-row.diff{grid-template-columns:28px minmax(0,1fr) auto}
        .moga-shopify-shadow-row .pick{display:flex;align-items:center;justify-content:center;cursor:pointer}
        .moga-shopify-shadow-row .pick input{position:absolute;opacity:0;pointer-events:none}
        .moga-shopify-shadow-row .pick .moga-api-check{width:18px;height:18px;border:2px solid #5b5b5b;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#202020;transition:.15s ease;box-sizing:border-box}
        .moga-shopify-shadow-row .pick input:checked+.moga-api-check{border-color:#ff7b18;background:linear-gradient(135deg,#ff8a00,#ff4b93);box-shadow:0 0 0 2px rgba(255,123,24,.12)}
        .moga-shopify-shadow-row .pick input:checked+.moga-api-check:after{content:"✓";color:#fff;font-size:12px;font-weight:1000;line-height:1}
        #shopifyApiSyncBtn,#shopifyShadowDiffBtn{display:inline-flex;align-items:center;justify-content:center;text-align:center;line-height:1.1}
        #shopifyApiSyncBtn{background:linear-gradient(135deg,#ff8a00,#ff4b93)!important;color:#fff!important}
        #shopifyApiSyncBtn:disabled{cursor:not-allowed!important;opacity:.42!important}
        #shopifyShadowDiffBtn{background:#252525!important;color:#fff!important;border:1px solid #454545!important}
        #shopifyShadowDiffBtn.active{border-color:#ff8a00!important;color:#ff9b19!important;background:#2a2118!important}

        .moga-shopify-sync-export{display:grid;grid-template-columns:1fr 1fr;gap:9px;padding:0 22px 18px}.moga-shopify-sync-export button{min-height:44px;border-radius:11px;font-size:11px;font-weight:1000;cursor:pointer}.moga-shopify-sync-export .primary{border:1px solid #555;background:#262626;color:#fff}.moga-shopify-sync-export .mega{grid-column:1/-1;border:0;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#111;font-size:12px}.moga-shopify-sync-export button:disabled{opacity:.34;cursor:not-allowed}
        .moga-shopify-sync-foot{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px 22px 20px;border-top:1px solid #303030;color:#aaa;font-size:10px;line-height:1.5}.moga-shopify-sync-foot button{flex:0 0 auto;color:#ffb4b4;border-color:#5c3434}

        .moga-shopify-sync-confirm-overlay{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.72);backdrop-filter:blur(5px);display:flex;align-items:center;justify-content:center;padding:18px}
        .moga-shopify-sync-confirm-modal{width:min(520px,96vw);max-height:min(680px,90vh);display:flex;flex-direction:column;background:#171717;border:1px solid #3a3a3a;border-radius:18px;box-shadow:0 28px 80px rgba(0,0,0,.55);overflow:hidden;color:#fff}
        .moga-shopify-sync-confirm-head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:18px 20px 15px;background:#111;border-bottom:1px solid #303030}
        .moga-shopify-sync-confirm-head .eyebrow{font-size:9px;font-weight:1000;letter-spacing:.12em;color:#ff8a00;margin-bottom:5px}
        .moga-shopify-sync-confirm-head h3{margin:0;font-size:16px;line-height:1.2}
        .moga-shopify-sync-confirm-head .close{width:32px;height:32px;display:flex;align-items:center;justify-content:center;border:1px solid #3c3c3c;border-radius:9px;background:#202020;color:#aaa;font-size:21px;cursor:pointer;line-height:1}
        .moga-shopify-sync-confirm-body{padding:16px 20px;min-height:0;display:flex;flex-direction:column}
        .moga-shopify-sync-confirm-info{padding:12px 13px;border:1px solid #3b342a;border-radius:11px;background:#211c16;color:#eee;font-size:11px;font-weight:800;line-height:1.45}
        .moga-shopify-sync-confirm-info span{display:block;margin-top:5px;color:#aaa;font-size:9px;font-weight:700}
        .moga-shopify-sync-confirm-label{margin:15px 2px 7px;color:#8d8d8d;font-size:9px;font-weight:1000;letter-spacing:.08em}
        .moga-shopify-sync-confirm-list{max-height:280px;overflow-y:auto;overflow-x:hidden;border:1px solid #303030;border-radius:11px;background:#121212;scrollbar-gutter:stable}
        .moga-shopify-sync-confirm-item{display:flex;gap:9px;align-items:flex-start;padding:9px 11px;border-bottom:1px solid #272727}
        .moga-shopify-sync-confirm-item:last-child{border-bottom:0}
        .moga-shopify-sync-confirm-item .dot{color:#ff8a00;font-size:16px;line-height:1}
        .moga-shopify-sync-confirm-item div{min-width:0}
        .moga-shopify-sync-confirm-item b{display:block;font-size:10px;line-height:1.3;overflow-wrap:anywhere}
        .moga-shopify-sync-confirm-item small{display:block;margin-top:3px;color:#888;font-size:9px;font-weight:800}
        .moga-shopify-sync-confirm-actions{display:grid;grid-template-columns:1fr 1fr;gap:9px;padding:14px 20px 18px;background:#111;border-top:1px solid #303030}
        .moga-shopify-sync-confirm-actions button{height:40px;border-radius:10px;font-size:10px;font-weight:1000;cursor:pointer;display:flex;align-items:center;justify-content:center}
        .moga-shopify-sync-confirm-actions .cancel{border:1px solid #404040;background:#202020;color:#ddd}
        .moga-shopify-sync-confirm-actions .confirm{border:0;background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#fff}
        .moga-link-existing-modal{max-width:720px}
        .moga-link-compare{display:grid;grid-template-columns:1fr 1fr;gap:8px}
        .moga-link-compare>div{padding:11px;border:1px solid #353535;border-radius:11px;background:#1c1c1c;min-width:0}
        .moga-link-compare small{display:block;color:#ff9717;font-size:8px;font-weight:1000}
        .moga-link-compare b{display:block;margin-top:4px;font-size:11px;overflow-wrap:anywhere}
        .moga-link-compare span{display:block;margin-top:4px;color:#999;font-size:9px;line-height:1.45}
        .moga-link-warning{margin-top:10px;padding:11px;border:1px solid #8c3d3d;border-radius:11px;background:#281717}
        .moga-link-warning.qty{border-color:#7b5a16;background:#282114}
        .moga-link-warning>b{display:block;color:#ff6868;font-size:9px}
        .moga-link-warning.qty>b{color:#ffb52b}
        .moga-link-warning>span{display:block;margin:4px 0 8px;color:#ddd;font-size:9px;line-height:1.45}
        .moga-link-warning label{display:flex;align-items:center;gap:7px;margin-top:7px;color:#fff;font-size:9px;font-weight:800;cursor:pointer}
        .moga-link-warning input[type=radio]{accent-color:#ff8a00}
        .moga-link-syncqty input,.moga-link-confirm-check input{position:absolute;opacity:0;pointer-events:none}
        .moga-link-confirm-check{display:flex;align-items:center;gap:9px;margin-top:12px;padding:11px;border:1px solid #444;border-radius:11px;background:#202020;cursor:pointer;font-size:9px}
        .moga-link-confirm-check .moga-api-check,.moga-link-syncqty .moga-api-check{flex:0 0 auto}
        .moga-link-ok{margin-top:10px;padding:10px;border:1px solid #275b3a;border-radius:10px;background:#15251b;color:#65d78a;font-size:9px;font-weight:900}
        .moga-shopify-sync-confirm-actions .confirm:disabled{opacity:.38;cursor:not-allowed;filter:grayscale(.4)}
        @media(max-width:800px){.moga-shopify-connect-panel{grid-template-columns:1fr;margin:12px;padding:15px;gap:16px}.moga-shopify-connect-steps{padding-left:0;padding-top:14px;border-left:0;border-top:1px solid #343434}.moga-shopify-connect-form{grid-template-columns:1fr}.moga-shopify-connected-bar{margin:12px;flex-wrap:wrap}.moga-shopify-connected-bar .moga-shopify-connected-info{flex:1 1 calc(100% - 30px)}.moga-shopify-api-location-setup{margin:10px 12px;align-items:stretch;flex-direction:column}.moga-shopify-api-location-setup select{min-width:0;width:100%}}
        @media(max-width:800px){.moga-shopify-api-new,.moga-shopify-api-shadow{margin-left:12px!important;margin-right:12px!important}.moga-shopify-catalog-list,.moga-shopify-shadow-list{max-height:220px}.moga-shopify-catalog-row{grid-template-columns:28px minmax(0,1fr);gap:7px}.moga-shopify-catalog-row .state{grid-column:2;text-align:left;white-space:normal}.moga-shopify-shadow-row{grid-template-columns:minmax(0,1fr);gap:5px}.moga-shopify-shadow-row .state{text-align:left;white-space:normal}}
        @media(max-width:800px){.moga-shopify-change-panels{grid-template-columns:1fr}.moga-shopify-sync-grid{grid-template-columns:1fr 1fr}.moga-shopify-sync-setup{display:block}.moga-shopify-sync-template-actions{justify-content:flex-start;margin-top:10px}.moga-shopify-sync-field{min-width:0}.moga-shopify-sync-export{grid-template-columns:1fr}.moga-shopify-sync-export .mega{grid-column:auto}.moga-shopify-sync-foot{display:block}.moga-shopify-sync-foot button{margin-top:10px}.moga-shopify-sync-card{width:calc(100vw - 20px);max-height:calc(100dvh - 20px);border-radius:18px!important}.moga-shopify-sync-scroll{max-height:calc(100dvh - 22px);border-radius:17px!important}}
      `;document.head.appendChild(st);
    }
    const rememberedShop=mogaShopifyConnectedShop()||mogaShopifyLastShop();
    const shopInput=document.getElementById('mogaShopifyShopInput');
    if(shopInput&&!shopInput.value&&rememberedShop)shopInput.value=rememberedShop;
    renderShopifySync();
    if(!shopifyConnectionState.checked&&!shopifyConnectionState.loading){
      refreshMogaShopifyConnectionState({quiet:true}).then(()=>renderShopifySync());
    }
    return true;
  }


  function snapshotSfCandidate(row){
    const opts=(row?.selectedOptions||[]).map(x=>cleanOption(x?.value)).filter(Boolean);
    return shopifySfName(row?.productTitle||'',opts);
  }

  function catalogMatchKey(v){
    return String(v||'')
      .normalize('NFD').replace(/\p{M}/gu,'')
      .normalize('NFKC')
      .toLowerCase()
      .replace(/[–—−]/g,'-')
      .replace(/[\/|\\]+/g,' ')
      .replace(/-/g,' ')
      .replace(/[.,;:()[\]{}]+/g,' ')
      .replace(/\b(15|50|100)\s*ml\b/g,'$1ml')
      .replace(/\s+/g,' ')
      .trim();
  }

  function shortShopifyId(v){
    const s=String(v||'');
    const m=s.match(/\/(\d+)$/);
    return m?m[1]:s;
  }
  function sfShopifyLinkMap(){
    const map=new Map();
    productList().forEach(p=>{
      const sh=String(p.shopifyInventoryItemId||'').trim();
      if(sh)map.set(sh,String(p.inventoryId||''));
    });
    return map;
  }

  function buildApiCatalogClassification(snapshot){
    const sf=productList();
    const ignoredSet=getUnmanagedShopify();
    const knownIds=new Set();
    const linkedBySfId=new Map();
    // Naujų / nesusietų kataloge domina tik realiai parduodamos Shopify prekės:
    // ACTIVE + paskelbtos Online Store. Draft / Archived / Unlisted ir nepaskelbtos nerodomos.
    const catalogRows=(snapshot||[]).filter(row=>
      String(row?.productStatus||'').toUpperCase()==='ACTIVE' && !!row?.publishedAt
    );

    // A) Jau anksčiau per API importuotos / susietos SFAPP prekės.
    sf.forEach(p=>{
      const id=String(p.shopifyInventoryItemId||'').trim();
      if(id){knownIds.add(id);linkedBySfId.set(String(p.inventoryId||''),id);}
    });

    // B) Dabartiniai saugūs CSV/rankiniai susiejimai — tai leidžia vieną kartą
    // "užrakinti" Shopify ID ir vėliau nebebūti priklausomam nuo CSV.
    try{
      const invMap=inventoryMappings();
      (invMap.mapped||[]).forEach(x=>{
        const row=snapshotFindRow(snapshot,x);
        if(!row?.inventoryItemId)return;
        knownIds.add(String(row.inventoryItemId));
        if(x.p?.inventoryId)linkedBySfId.set(String(x.p.inventoryId),String(row.inventoryItemId));
      });
    }catch(_){}

    // C) API-only saugus 1↔1 SKU arba pavadinimo match.
    const sfSku=new Map(),sfName=new Map(),shSku=new Map(),shName=new Map();
    const push=(map,key,val)=>{if(!key)return;if(!map.has(key))map.set(key,[]);map.get(key).push(val)};
    sf.forEach(p=>{
      push(sfSku,norm(p.sku),p);
      push(sfName,norm(snapshotSfCandidate({productTitle:p.name,selectedOptions:[]})),p);
      push(sfName,norm(p.name),p);
    });
    const shCanonical=new Map(),sfCanonical=new Map();
    sf.forEach(p=>push(sfCanonical,catalogMatchKey(p.name),p));
    catalogRows.forEach(row=>{
      push(shSku,norm(row.sku),row);
      push(shName,norm(snapshotSfCandidate(row)),row);
      push(shCanonical,catalogMatchKey(snapshotSfCandidate(row)),row);
    });

    catalogRows.forEach(row=>{
      const id=String(row.inventoryItemId||'');
      if(!id||knownIds.has(id))return;
      const s=norm(row.sku);
      const n=norm(snapshotSfCandidate(row));
      if(s && (shSku.get(s)||[]).length===1 && (sfSku.get(s)||[]).length===1){
        const p=sfSku.get(s)[0];
        knownIds.add(id);
        linkedBySfId.set(String(p.inventoryId||''),id);
        return;
      }
      if(n && (shName.get(n)||[]).length===1 && (sfName.get(n)||[]).length===1){
        const p=sfName.get(n)[0];
        knownIds.add(id);
        linkedBySfId.set(String(p.inventoryId||''),id);
        return;
      }
      const ck=catalogMatchKey(snapshotSfCandidate(row));
      if(ck && (shCanonical.get(ck)||[]).length===1 && (sfCanonical.get(ck)||[]).length===1){
        const p=sfCanonical.get(ck)[0];
        knownIds.add(id);
        linkedBySfId.set(String(p.inventoryId||''),id);
      }
    });

    // Saugiai įrašome Shopify identitetą į jau egzistuojančias SFAPP prekes.
    // Kiekių ir kainų čia NELIEČIAME.
    if(linkedBySfId.size){
      let changed=false;
      const byShopId=new Map(snapshot.map(x=>[String(x.inventoryItemId||''),x]));
      const next=sf.map(p=>{
        const shId=linkedBySfId.get(String(p.inventoryId||''));
        const row=shId?byShopId.get(shId):null;
        if(!row)return p;
        const fields={
          shopifyInventoryItemId:String(row.inventoryItemId||''),
          shopifyVariantId:String(row.variantId||''),
          shopifyProductId:String(row.productId||''),
          shopifyHandle:String(row.handle||''),
          shopifyImageUrl:String(row.imageUrl||''),
          shopifyImageAlt:String(row.imageAlt||row.productTitle||p.name||'')
        };
        if(String(p.shopifyInventoryItemId||'')===fields.shopifyInventoryItemId &&
           String(p.shopifyVariantId||'')===fields.shopifyVariantId &&
           String(p.shopifyProductId||'')===fields.shopifyProductId &&
           String(p.shopifyHandle||'')===fields.shopifyHandle &&
           String(p.shopifyImageUrl||'')===fields.shopifyImageUrl &&
           String(p.shopifyImageAlt||'')===fields.shopifyImageAlt)return p;
        changed=true;
        return {...p,...fields};
      });
      if(changed)window.setProducts?.(next);
    }

    const fresh=[],ignored=[];
    catalogRows.forEach(row=>{
      const id=String(row.inventoryItemId||'');
      if(!id||knownIds.has(id))return;
      const candidate=snapshotSfCandidate(row);
      const n=norm(candidate);
      const ck=catalogMatchKey(candidate);
      const exactLikely=(sfName.get(n)||[]);
      const canonicalLikely=(sfCanonical.get(ck)||[]);
      const likely=[...new Map([...exactLikely,...canonicalLikely].map(p=>[String(p.inventoryId||''),p])).values()];
      const item={...row,candidate,likelySf:likely.map(p=>({inventoryId:p.inventoryId,name:p.name,sku:p.sku||'',qty:window.MOGA_INVENTORY?.getRecord?.(p.inventoryId,false)?.qty||0}))};
      if(ignoredSet.has(id))ignored.push(item);
      else fresh.push(item);
    });

    return {fresh,ignored,knownCount:knownIds.size,likelyExisting:fresh.filter(x=>x.likelySf?.length).length,catalogCount:catalogRows.length};
  }

  function renderMogaShopifyCatalog(){
    const summary=document.getElementById('shopifyCatalogSummary');
    const list=document.getElementById('shopifyCatalogList');
    const refresh=document.getElementById('shopifyCatalogRefreshBtn');
    const selectAll=document.getElementById('shopifyCatalogSelectAllBtn');
    const importBtn=document.getElementById('shopifyCatalogImportBtn');
    const ignoreBtn=document.getElementById('shopifyCatalogIgnoreBtn');
    const ignoredBtn=document.getElementById('shopifyCatalogIgnoredBtn');
    const hint=document.getElementById('shopifyCatalogHint');

    if(refresh){
      refresh.disabled=shopifyCatalogRunning;
      refresh.textContent=shopifyCatalogRunning?'SKAITOMA SHOPIFY...':'ATNAUJINTI IŠ SHOPIFY';
    }
    if(summary){
      if(shopifyCatalogRunning)summary.textContent='TIKRINAMA...';
      else if(!shopifyCatalogSnapshot.length)summary.textContent='NEPATIKRINTA';
      else summary.textContent=shopifyCatalogNew.length?`NESUSIETOS ${shopifyCatalogNew.length}`:'NAUJŲ NĖRA ✓';
    }

    const liveNewIds=new Set(shopifyCatalogNew.map(x=>String(x.inventoryItemId||'')));
    [...shopifyCatalogSelected].forEach(id=>{if(!liveNewIds.has(id))shopifyCatalogSelected.delete(id)});

    if(selectAll){
      selectAll.style.display=shopifyCatalogNew.length?'inline-flex':'none';
      selectAll.textContent=shopifyCatalogSelected.size===shopifyCatalogNew.length&&shopifyCatalogNew.length?'NUIMTI VISAS':'PAŽYMĖTI VISAS NAUJAS';
      selectAll.onclick=()=>toggleAllMogaShopifyNew(!(shopifyCatalogSelected.size===shopifyCatalogNew.length&&shopifyCatalogNew.length));
    }
    if(importBtn){
      const canImport=shopifyCatalogSelected.size>0;
      importBtn.style.display=shopifyCatalogNew.length?'inline-flex':'none';
      importBtn.classList.toggle('is-disabled',!canImport);
      importBtn.setAttribute('aria-disabled',canImport?'false':'true');
      importBtn.textContent=`IMPORTUOTI Į SFAPP (${shopifyCatalogSelected.size})`;
    }
    if(ignoreBtn){
      ignoreBtn.style.display=shopifyCatalogNew.length?'inline-flex':'none';
      ignoreBtn.disabled=!shopifyCatalogSelected.size;
      ignoreBtn.textContent=`NEVALDYTI PER SFAPP (${shopifyCatalogSelected.size})`;
    }
    if(ignoredBtn){
      ignoredBtn.style.display=shopifyCatalogIgnored.length?'inline-flex':'none';
      ignoredBtn.classList.toggle('active',shopifyShowIgnored);
      ignoredBtn.textContent=shopifyShowIgnored?`SLĖPTI NEVALDOMAS (${shopifyCatalogIgnored.length})`:`RODYTI NEVALDOMAS (${shopifyCatalogIgnored.length})`;
    }
    if(hint){
      hint.textContent=shopifyCatalogSnapshot.length
        ? `Shopify iš viso: ${shopifyCatalogSnapshot.length} · Aktyvūs/paskelbti: ${shopifyCatalogActiveCount} · SFAPP atpažinta: ${shopifyCatalogKnownCount} · Naujos / nesusietos: ${shopifyCatalogNew.length} · Galimai jau yra SFAPP: ${shopifyCatalogLikelyExisting} · Nevaldomos: ${shopifyCatalogIgnored.length}`
        : 'Nuskaito Shopify ir parodo tik tas prekes / variantus, kurių SFAPP dar neturi.';
    }
    if(!list)return;

    if(shopifyCatalogRunning){
      list.innerHTML='<div class="moga-shopify-catalog-empty">Skaitomas Shopify katalogas...</div>';
      return;
    }
    if(!shopifyCatalogSnapshot.length){
      list.innerHTML='<div class="moga-shopify-catalog-empty">Spausk „ATNAUJINTI IŠ SHOPIFY“. Sistema nieko nekeis, tik palygins katalogą.</div>';
      return;
    }

    const rows=shopifyShowIgnored?shopifyCatalogIgnored:shopifyCatalogNew;
    if(!rows.length){
      list.innerHTML=`<div class="moga-shopify-catalog-empty">${shopifyShowIgnored?'Nevaldomų Shopify prekių nėra.':'Naujų Shopify prekių nėra — SFAPP katalogas aktualus. ✓'}</div>`;
      return;
    }

    list.innerHTML=rows.map(row=>{
      const id=String(row.inventoryItemId||'');
      const name=row.candidate||row.productTitle||'—';
      const qty=number(row.onHand);
      const price=String(row.price||'').trim();
      const meta=`SKU: ${row.sku||'—'} · Handle: ${row.handle||'—'} · Shopify ID: ${shortShopifyId(row.inventoryItemId)}${price?` · Kaina: ${price} €`:''}`;
      if(shopifyShowIgnored){
        return `<div class="moga-shopify-catalog-row ignored"><div class="moga-shop-catalog-product">${window.MOGA_SHOPIFY_IMG?.thumb?.(row.imageUrl,row.imageAlt||name,44)||''}<div><div class="name">${esc(name)}</div><div class="meta">${esc(meta)}</div></div></div><div class="state">Shopify: ${qty}<br><button class="restore" type="button" onclick="restoreMogaShopifyIgnored('${esc(id)}')">GRĄŽINTI</button></div></div>`;
      }
      const likelyCount=row.likelySf?.length||0;
      const likelyText=likelyCount?`<div class="likely">GALIMAI JAU YRA SFAPP${likelyCount>1?` (${likelyCount})`:''}</div>`:'';
      const linkBtn=`<button class="restore link-existing" type="button" onclick="linkMogaShopifyExisting('${esc(id)}')">SUSIETI SU ESAMA SFAPP PREKE</button>`;
      return `<div class="moga-shopify-catalog-row ${likelyCount?'likely-existing':''}">
        <label class="pick" title="Pažymėti"><input type="checkbox" ${shopifyCatalogSelected.has(id)?'checked':''} onchange="toggleMogaShopifyNew('${esc(id)}',this.checked)"><span class="moga-api-check"></span></label>
        <div class="moga-shop-catalog-product">${window.MOGA_SHOPIFY_IMG?.thumb?.(row.imageUrl,row.imageAlt||name,44)||''}<div><div class="name">${esc(name)}</div><div class="meta">${esc(meta)}</div>${likelyText}</div></div>
        <div class="state">Shopify likutis: ${qty}<div class="moga-shop-row-actions">${linkBtn}</div></div>
      </div>`;
    }).join('');
  }

  async function refreshMogaShopifyCatalog(){
    if(shopifyCatalogRunning)return;
    shopifyCatalogRunning=true;
    shopifyCatalogSelected.clear();
    renderMogaShopifyCatalog();
    try{
      const shop=mogaShopifyConnectedShop();

const r=await fetch(
  `${SHOPIFY_API_BASE}/shopify/multi/inventory/snapshot?shop=${encodeURIComponent(shop)}`,
  {
    method:'GET',
    credentials:'include',
    headers:mogaShopifyAuthHeaders(),
    cache:'no-store'
  }
);
            const data=await r.json().catch(()=>({}));
      if(!r.ok||!data?.ok||!Array.isArray(data.items))throw new Error(data?.message||`HTTP ${r.status}`);

      shopifyCatalogSnapshot=data.items;

      const classified=buildApiCatalogClassification(data.items);

      shopifyCatalogNew=classified.fresh;
      shopifyCatalogIgnored=classified.ignored;
      shopifyCatalogKnownCount=classified.knownCount;
      shopifyCatalogLikelyExisting=classified.likelyExisting||0;
      shopifyCatalogActiveCount=classified.catalogCount||0;
      shopifyShowIgnored=false;

    }catch(e){
  shopifyCatalogSnapshot=[];
  shopifyCatalogNew=[];
  shopifyCatalogIgnored=[];
  shopifyCatalogKnownCount=0;
  shopifyCatalogLikelyExisting=0;
  shopifyCatalogActiveCount=0;

  window.MOGA_UI?.alert?.(
    `Nepavyko nuskaityti Shopify katalogo: ${e?.message || 'nežinoma klaida'}`,
    {title:'SHOPIFY → SFAPP'}
  );
}

    shopifyCatalogRunning=false;
    renderMogaShopifyCatalog();
    renderShopifySync();
  }

  window.refreshMogaShopifyCatalog=refreshMogaShopifyCatalog;

  function toggleMogaShopifyNew(id,checked){
    if(checked)shopifyCatalogSelected.add(String(id));
    else shopifyCatalogSelected.delete(String(id));
    renderMogaShopifyCatalog();
  }
  window.toggleMogaShopifyNew=toggleMogaShopifyNew;

  function toggleAllMogaShopifyNew(checked){
    shopifyCatalogSelected.clear();
    if(checked)shopifyCatalogNew.forEach(x=>shopifyCatalogSelected.add(String(x.inventoryItemId||'')));
    renderMogaShopifyCatalog();
  }
  window.toggleAllMogaShopifyNew=toggleAllMogaShopifyNew;

  function toggleMogaShopifyIgnored(){
    shopifyShowIgnored=!shopifyShowIgnored;
    shopifyCatalogSelected.clear();
    renderMogaShopifyCatalog();
  }
  window.toggleMogaShopifyIgnored=toggleMogaShopifyIgnored;

  function restoreMogaShopifyIgnored(id){
    const set=getUnmanagedShopify();
    set.delete(String(id));
    saveUnmanagedShopify(set);
    const classified=buildApiCatalogClassification(shopifyCatalogSnapshot);
    shopifyCatalogNew=classified.fresh;
    shopifyCatalogIgnored=classified.ignored;
    shopifyCatalogKnownCount=classified.knownCount;
    shopifyCatalogLikelyExisting=classified.likelyExisting||0;
    shopifyCatalogActiveCount=classified.catalogCount||0;
    renderMogaShopifyCatalog();
  }
  window.restoreMogaShopifyIgnored=restoreMogaShopifyIgnored;


  function possibleShopifyRowsForSf(p){
    const key=catalogMatchKey(p?.name||'');
    const sku=norm(p?.sku||'');
    const rows=(shopifyCatalogSnapshot||[]).filter(r=>{
      if(String(r?.productStatus||'').toUpperCase()!=='ACTIVE' || !r?.publishedAt)return false;
      if(sku && norm(r?.sku||'')===sku)return true;
      return key && catalogMatchKey(snapshotSfCandidate(r))===key;
    });
    const seen=new Set();
    return rows.filter(r=>{
      const id=String(r?.inventoryItemId||'');
      if(!id||seen.has(id))return false;
      seen.add(id); return true;
    });
  }

  async function linkMogaShopifyExisting(shopifyId){
    const row=shopifyCatalogNew.find(x=>String(x.inventoryItemId||'')===String(shopifyId));
    if(!row)return;
    const sf=productList();
    const exact=(row.likelySf||[]).map(x=>sf.find(p=>String(p.inventoryId)===String(x.inventoryId))).filter(Boolean);

    const old=document.getElementById('mogaShopifyExistingLinkModal');
    if(old)old.remove();
    const overlay=document.createElement('div');
    overlay.id='mogaShopifyExistingLinkModal';
    overlay.className='moga-shopify-sync-confirm-overlay';
    overlay.innerHTML=`
      <div class="moga-shopify-sync-confirm-modal moga-link-existing-modal" role="dialog" aria-modal="true">
        <div class="moga-shopify-sync-confirm-head">
          <div><div class="eyebrow">SHOPIFY → SFAPP</div><h3>Susieti su esama SFAPP preke</h3></div>
          <button type="button" class="close">×</button>
        </div>
        <div class="moga-shopify-sync-confirm-body">
          <div class="moga-shopify-sync-confirm-info">
            <div class="moga-shop-link-source">${window.MOGA_SHOPIFY_IMG?.thumb?.(row.imageUrl,row.imageAlt||row.candidate||row.productTitle,58)||''}<div>
              <b>${esc(row.candidate||row.productTitle||'—')}</b>
              <span>Shopify likutis: ${number(row.onHand)} · SKU: ${esc(row.sku||'—')} · Handle: ${esc(row.handle||'—')} · Shopify ID: ${esc(shortShopifyId(row.inventoryItemId))}</span>
            </div></div>
          </div>
          <div class="moga-shopify-sync-confirm-label">PASIRINK SFAPP PREKĘ</div>
          <input id="mogaShopifyExistingSearch" type="text" placeholder="Ieškoti pagal pavadinimą arba SKU..." style="width:100%;height:38px;border:1px solid #454545;border-radius:9px;background:#fff;color:#111;padding:0 11px;font-size:11px;box-sizing:border-box;margin-bottom:8px">
          <div id="mogaShopifyExistingResults" class="moga-shopify-sync-confirm-list"></div>
        </div>
      </div>`;
    document.body.appendChild(overlay);

    const results=overlay.querySelector('#mogaShopifyExistingResults');
    const search=overlay.querySelector('#mogaShopifyExistingSearch');
    const close=()=>overlay.remove();
    overlay.querySelector('.close').onclick=close;
    overlay.addEventListener('pointerdown',e=>{if(e.target===overlay)close()});

    const openConfirm=(p)=>{
      const alreadyShopify=String(p.shopifyInventoryItemId||'').trim();
      if(alreadyShopify && alreadyShopify!==String(row.inventoryItemId||'')){
        return window.MOGA_UI?.alert?.(
          `Ši SFAPP prekė jau susieta su kitu Shopify Inventory Item ID: ${shortShopifyId(alreadyShopify)}.\n\nPirmiausia reikėtų atsieti seną susiejimą — sistema jo automatiškai neperrašys.`,
          {title:'SUSIEJIMO KONFLIKTAS'}
        );
      }
      const usedByOther=productList().find(x=>
        String(x.inventoryId)!==String(p.inventoryId) &&
        String(x.shopifyInventoryItemId||'')===String(row.inventoryItemId||'')
      );
      if(usedByOther){
        return window.MOGA_UI?.alert?.(
          `Šis Shopify ID jau susietas su SFAPP preke „${usedByOther.name}“.`,
          {title:'SUSIEJIMO KONFLIKTAS'}
        );
      }

      const sfQty=Math.max(0,Math.trunc(number(window.MOGA_INVENTORY?.getRecord?.(p.inventoryId,false)?.qty ?? getRecord(p.inventoryId,false)?.qty)));
      const shopQty=Math.max(0,Math.trunc(number(row.onHand)));
      const shopName=String(row.candidate||row.productTitle||'').trim();
      const sfName=String(p.name||'').trim();
      const namesDiffer=catalogMatchKey(shopName)!==catalogMatchKey(sfName);
      const qtyDiffer=sfQty!==shopQty;

      overlay.querySelector('.moga-shopify-sync-confirm-modal').innerHTML=`
        <div class="moga-shopify-sync-confirm-head">
          <div><div class="eyebrow">SHOPIFY → SFAPP</div><h3>Patvirtinti prekių susiejimą</h3></div>
          <button type="button" class="close">×</button>
        </div>
        <div class="moga-shopify-sync-confirm-body">
          <div class="moga-link-compare">
            <div><small>SHOPIFY</small><b>${esc(shopName||'—')}</b><span>SKU: ${esc(row.sku||'—')} · Likutis: ${shopQty} · ID: ${esc(shortShopifyId(row.inventoryItemId))}</span></div>
            <div><small>SFAPP</small><b>${esc(sfName||'—')}</b><span>SKU: ${esc(p.sku||'—')} · Likutis: ${sfQty} · ID: ${esc(String(p.inventoryId||'').slice(-10))}</span></div>
          </div>
          ${namesDiffer?`<div class="moga-link-warning"><b>PAVADINIMAI NESUTAMPA</b><span>Susiejimui tai netrukdo. Kad vėliau būtų lengviau atpažinti prekę, rekomenduojama pavadinimus suvienodinti.</span>
            <label><input type="radio" name="mogaLinkName" value="keep" checked> PALIKTI SKIRTINGUS</label>
            <label><input type="radio" name="mogaLinkName" value="shopifyToSf"> NAUDOTI SHOPIFY PAVADINIMĄ SFAPP'e</label>
          </div>`:''}
          ${qtyDiffer?`<div class="moga-link-warning qty"><b>LIKUČIAI SKIRIASI</b><span>SFAPP: <strong>${sfQty} vnt.</strong> · Shopify: <strong>${shopQty} vnt.</strong><br>Susiejant SFAPP likutis nebus perrašytas.</span>
            <label class="moga-link-syncqty"><input type="checkbox" id="mogaLinkSyncQty"><span class="moga-api-check"></span> NUSTATYTI SHOPIFY LIKUTĮ PAGAL SFAPP (${sfQty} VNT.)</label>
          </div>`:`<div class="moga-link-ok">Likučiai sutampa: ${sfQty} vnt. ✓</div>`}
          <label class="moga-link-confirm-check"><input type="checkbox" id="mogaLinkConfirm"><span class="moga-api-check"></span><b>Patvirtinu, kad tai ta pati prekė / variantas.</b></label>
        </div>
        <div class="moga-shopify-sync-confirm-actions">
          <button type="button" class="cancel">ATŠAUKTI</button>
          <button type="button" class="confirm" disabled>SUSIETI PREKES</button>
        </div>`;

      const modal=overlay.querySelector('.moga-shopify-sync-confirm-modal');
      const x=modal.querySelector('.close');
      const cancel=modal.querySelector('.cancel');
      const confirmBtn=modal.querySelector('.confirm');
      const check=modal.querySelector('#mogaLinkConfirm');
      x.onclick=close; cancel.onclick=close;
      check.onchange=()=>{confirmBtn.disabled=!check.checked};

      confirmBtn.onclick=async()=>{
        if(!check.checked)return;
        confirmBtn.disabled=true;
        confirmBtn.textContent='SUSIEJAMA...';
        let linkSaved=false;
        try{
          const nameMode=modal.querySelector('input[name="mogaLinkName"]:checked')?.value||'keep';
          const syncQty=!!modal.querySelector('#mogaLinkSyncQty')?.checked;
          const next=productList().map(x=>String(x.inventoryId)===String(p.inventoryId)?{
            ...x,
            name:nameMode==='shopifyToSf'&&shopName?shopName:x.name,
            shopifyInventoryItemId:String(row.inventoryItemId||''),
            shopifyVariantId:String(row.variantId||''),
            shopifyProductId:String(row.productId||''),
            shopifyHandle:String(row.handle||''),
            shopifyImageUrl:String(row.imageUrl||x.shopifyImageUrl||''),
            shopifyImageAlt:String(row.imageAlt||row.candidate||row.productTitle||x.shopifyImageAlt||p.name||''),
            shopifyImportedAt:String(x.shopifyImportedAt||new Date().toISOString())
          }:x);
          window.setProducts?.(next);
          linkSaved=true;

          if(syncQty&&qtyDiffer){
            const shop=mogaShopifyConnectedShop();
            const r=await fetch(`${SHOPIFY_API_BASE}/shopify/multi/inventory/sync-selected`,{
              method:'POST',
              credentials:'include',
              headers:mogaShopifyAuthHeaders({'Content-Type':'application/json'}),
              body:JSON.stringify({
                shop,
                changes:[{
                  inventoryItemId:row.inventoryItemId,
                  quantity:sfQty,
                  changeFromQuantity:shopQty
                }]
              })
            });
            const data=await r.json().catch(()=>({}));
            if(!r.ok||!data?.ok){
              const detail=(data?.errors||[]).map(e=>e.message).filter(Boolean).join(' | ');
              throw new Error(detail||data?.message||`HTTP ${r.status}`);
            }
            row.onHand=sfQty;
          }

          close();
          const classified=buildApiCatalogClassification(shopifyCatalogSnapshot);
          shopifyCatalogNew=classified.fresh;
          shopifyCatalogIgnored=classified.ignored;
          shopifyCatalogKnownCount=classified.knownCount;
          shopifyCatalogLikelyExisting=classified.likelyExisting||0;
          shopifyCatalogActiveCount=classified.catalogCount||shopifyCatalogActiveCount;
          renderInventory();
          renderMogaShopifyCatalog();
          renderShopifySync();
          window.MOGA_UI?.alert?.(
            syncQty&&qtyDiffer
              ? 'Prekės susietos. Shopify likutis nustatytas pagal SFAPP.'
              : 'Prekės susietos. SFAPP likutis nepakeistas.',
            {title:'SHOPIFY → SFAPP'}
          );
        }catch(err){
          confirmBtn.disabled=false;
          confirmBtn.textContent='SUSIETI PREKES';
          window.MOGA_UI?.alert?.(
            linkSaved
              ? `Prekių susiejimas išsaugotas, tačiau Shopify likučio sinchronizuoti nepavyko: ${err?.message||err}. SFAPP likutis nepakeistas.`
              : `Prekių susieti nepavyko: ${err?.message||err}`,
            {title:'SHOPIFY → SFAPP'}
          );
        }
      };
    };

    const render=(q='')=>{
      const nq=norm(q);
      let arr=sf.filter(p=>!nq||norm(p.name).includes(nq)||norm(p.sku).includes(nq));
      arr.sort((a,b)=>{
        const ae=exact.some(x=>x.inventoryId===a.inventoryId)?0:1;
        const be=exact.some(x=>x.inventoryId===b.inventoryId)?0:1;
        return ae-be||String(a.name).localeCompare(String(b.name),'lt',{numeric:true,sensitivity:'base'});
      });
      results.innerHTML=arr.slice(0,100).map(p=>{
        const possible=possibleShopifyRowsForSf(p);
        const storedThumb=window.MOGA_SHOPIFY_IMG?.thumb?.(p.shopifyImageUrl,p.shopifyImageAlt||p.name,42)||'';
        const possibleThumbs=!p.shopifyImageUrl && possible.length
          ? `<span class="moga-shop-link-possible"><small>GALIMI SHOPIFY:</small><span>${possible.slice(0,5).map(r=>window.MOGA_SHOPIFY_IMG?.thumb?.(r.imageUrl,r.imageAlt||snapshotSfCandidate(r),34)||'').join('')}</span></span>`
          : '';
        const already=String(p.shopifyInventoryItemId||'').trim();
        const conflict=already&&already!==String(row.inventoryItemId||'');
        return `<button type="button" data-id="${esc(p.inventoryId)}" class="moga-shop-link-choice" ${conflict?'style="opacity:.48"':''}>
          ${storedThumb}
          <span class="moga-shop-link-choice-text"><b style="font-size:10px">${esc(p.name)}</b>
          <small style="display:block;margin-top:3px;color:#888;font-size:9px">SKU: ${esc(p.sku||'—')} · SFAPP likutis: ${number(window.MOGA_INVENTORY?.getRecord?.(p.inventoryId,false)?.qty)} · SFAPP ID: ${esc(String(p.inventoryId||'').slice(-10))}${already?` · Susieta su Shopify ID: ${esc(shortShopifyId(already))}`:''}</small>
          ${possibleThumbs}</span>
        </button>`;
      }).join('')||'<div class="moga-shopify-catalog-empty">Nieko nerasta.</div>';
      results.querySelectorAll('button[data-id]').forEach(btn=>btn.onclick=()=>{
        const p=sf.find(x=>String(x.inventoryId)===String(btn.dataset.id));
        if(p)openConfirm(p);
      });
    };

    search.addEventListener('input',()=>render(search.value));
    render('');
    setTimeout(()=>search.focus(),30);
  }
  window.linkMogaShopifyExisting=linkMogaShopifyExisting;



  async function importMogaShopifyOne(id){
    id=String(id||'');
    const row=shopifyCatalogNew.find(x=>String(x.inventoryItemId||'')===id);
    if(!row){
      return window.MOGA_UI?.alert?.('Šios Shopify prekės nebėra nesusietų sąraše. Atnaujink katalogą ir bandyk dar kartą.',{title:'SHOPIFY → SFAPP'});
    }
    shopifyCatalogSelected.clear();
    shopifyCatalogSelected.add(id);
    renderMogaShopifyCatalog();
    return importMogaShopifySelected();
  }
  window.importMogaShopifyOne=importMogaShopifyOne;

  async function importMogaShopifySelected(){
    const selected=shopifyCatalogNew.filter(x=>shopifyCatalogSelected.has(String(x.inventoryItemId||'')));
    if(!selected.length)return;

    const current=productList();
    const currentSku=new Map(),currentName=new Map();
    current.forEach(p=>{
      const s=norm(p.sku);if(s){if(!currentSku.has(s))currentSku.set(s,[]);currentSku.get(s).push(p)}
      const n=norm(p.name);if(n){if(!currentName.has(n))currentName.set(n,[]);currentName.get(n).push(p)}
    });

    const drafts=selected.map(row=>({
      row,
      name:snapshotSfCandidate(row),
      sku:String(row.sku||'').trim()
    }));

    function conflictFor(d,all=drafts){
      const sku=norm(d.sku), nameKey=norm(d.name);
      const skuExisting=sku&&(currentSku.get(sku)||[]).length>0;
      const nameExisting=nameKey&&(currentName.get(nameKey)||[]).length>0;
      const skuOther=sku&&all.some(x=>x!==d&&norm(x.sku)===sku);
      const nameOther=nameKey&&all.some(x=>x!==d&&norm(x.name)===nameKey);
      return {sku:!!(skuExisting||skuOther),name:!!(nameExisting||nameOther)};
    }

    if(drafts.some(d=>{const c=conflictFor(d);return c.sku||c.name})){
      const overlay=document.createElement('div');
      overlay.className='moga-shopify-sync-confirm-overlay';
      overlay.style.zIndex='2147483600';
      overlay.innerHTML=`<div class="moga-shopify-sync-confirm-modal moga-shopify-import-rename-modal" role="dialog" aria-modal="true">
        <div class="moga-shopify-sync-confirm-head"><div><div class="eyebrow">SHOPIFY → SFAPP</div><h3>Paruošti naujas SFAPP prekes</h3></div><button type="button" class="close">×</button></div>
        <div class="moga-shopify-sync-confirm-body">
          <p class="moga-shop-import-note">Kai Shopify prekės pavadinimas ar SKU jau naudojamas SFAPP, pakeisk tik <b>SFAPP pavadinimą / SKU</b>. Shopify prekė nebus keičiama, o ryšys bus saugomas pagal tikslų Shopify ID.</p>
          <div class="moga-shop-import-edit-list"></div>
          <div class="moga-shop-import-actions">
            <button type="button" class="cancel">ATŠAUKTI</button>
            <button type="button" class="save">IMPORTUOTI Į SFAPP</button>
          </div>
        </div>
      </div>`;
      document.body.appendChild(overlay);
      const list=overlay.querySelector('.moga-shop-import-edit-list');

      const render=()=>{
        list.innerHTML=drafts.map((d,i)=>{
          const c=conflictFor(d);
          const r=d.row;
          return `<div class="moga-shop-import-edit-row" data-i="${i}">
            <div class="moga-shop-import-source">
              ${window.MOGA_SHOPIFY_IMG?.thumb?.(r.imageUrl,r.imageAlt||r.productTitle,52)||''}
              <div><b>${esc(snapshotSfCandidate(r))}</b><small>Shopify: ${number(r.onHand)} vnt. · ID ${esc(shortShopifyId(r.inventoryItemId))} · Handle: ${esc(r.handle||'—')}</small></div>
            </div>
            <label>SFAPP PAVADINIMAS ${c.name?'<em>JAU NAUDOJAMAS</em>':''}<input data-field="name" value="${esc(d.name)}"></label>
            <label>SFAPP SKU ${c.sku?'<em>JAU NAUDOJAMAS</em>':''}<input data-field="sku" value="${esc(d.sku)}" placeholder="SKU nebūtinas"></label>
          </div>`;
        }).join('');
      };
      render();

      list.addEventListener('input',e=>{
        const row=e.target.closest('.moga-shop-import-edit-row');
        if(!row)return;
        const d=drafts[Number(row.dataset.i)];
        if(e.target.dataset.field==='name')d.name=e.target.value;
        if(e.target.dataset.field==='sku')d.sku=e.target.value;
        render();
        const rr=list.querySelector(`.moga-shop-import-edit-row[data-i="${row.dataset.i}"]`);
        const inp=rr?.querySelector(`[data-field="${e.target.dataset.field}"]`);
        inp?.focus(); if(inp)inp.setSelectionRange(inp.value.length,inp.value.length);
      });

      const close=()=>overlay.remove();
      overlay.querySelector('.close').onclick=close;
      overlay.querySelector('.cancel').onclick=close;
      overlay.addEventListener('pointerdown',e=>{if(e.target===overlay)close()});
      overlay.querySelector('.save').onclick=async()=>{
        const invalid=drafts.filter(d=>!String(d.name||'').trim()||(()=>{const c=conflictFor(d);return c.name||c.sku})());
        if(invalid.length){
          return window.MOGA_UI?.alert?.('Dar yra pasikartojančių SFAPP pavadinimų / SKU. Pakeisk pažymėtus laukus ir bandyk dar kartą.',{title:'NEGALIMA IMPORTUOTI'});
        }
        try{
          doImport(drafts);
          close();
        }catch(err){
          console.error('[MOGA Shopify import]',err);
          const msg=`Importuoti nepavyko: ${err?.message||err}`;
          if(window.MOGA_UI?.alert)await window.MOGA_UI.alert(msg,{title:'SHOPIFY → SFAPP'});
          else alert(msg);
        }
      };
      return;
    }

    const ok=window.MOGA_UI?.confirm
      ? await window.MOGA_UI.confirm(`Importuoti ${drafts.length} naujas Shopify prekes / variantus į SFAPP? Pradinis SFAPP likutis bus paimtas iš dabartinio Shopify on_hand kiekio.`,{title:'IMPORTUOTI IŠ SHOPIFY?',confirmText:'IMPORTUOTI',cancelText:'ATŠAUKTI'})
      : confirm(`Importuoti ${drafts.length} naujas Shopify prekes į SFAPP?`);
    if(!ok)return;
    try{
      doImport(drafts);
    }catch(err){
      console.error('[MOGA Shopify import]',err);
      const msg=`Importuoti nepavyko: ${err?.message||err}`;
      if(window.MOGA_UI?.alert)await window.MOGA_UI.alert(msg,{title:'SHOPIFY → SFAPP'});
      else alert(msg);
    }

    function doImport(items){
      const stamp=new Date().toISOString();
      const additions=items.map((d,i)=>{
        const row=d.row;
        return {
          name:String(d.name||'').trim(),
          price:String(row.price||'').trim(),
          sku:String(d.sku||'').trim(),
          category:'',
          cost:'',
          inventoryId:`inv_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,10)}_${i}`,
          shopifyInventoryItemId:String(row.inventoryItemId||''),
          shopifyVariantId:String(row.variantId||''),
          shopifyProductId:String(row.productId||''),
          shopifyHandle:String(row.handle||''),
          shopifyImageUrl:String(row.imageUrl||''),
          shopifyImageAlt:String(row.imageAlt||row.productTitle||d.name||''),
          shopifyImportedAt:stamp
        };
      });

      if(typeof window.setProducts!=='function'){
        throw new Error('window.setProducts funkcija nerasta');
      }
      const saved=window.setProducts([...productList(),...additions])||productList();

      // Use the actually saved SFAPP record (by exact Shopify Inventory Item ID),
      // because the product sanitizer/wrapper is the final authority for inventoryId.
      items.forEach((d,i)=>{
        const row=d.row;
        const savedProduct=(saved||[]).find(p=>
          String(p.shopifyInventoryItemId||'')===String(row.inventoryItemId||'')
        );
        if(!savedProduct){
          throw new Error(`Importuota prekė neišsisaugojo SFAPP: ${d.name}`);
        }
        const importedQty=Math.max(0,Math.trunc(number(row.onHand)));
        window.MOGA_INVENTORY?.patchRecord?.(savedProduct.inventoryId,{qty:importedQty});
        window.MOGA_INVENTORY?.fifoReconcileToQty?.(savedProduct.inventoryId,importedQty,{sourceType:'shopify-import',sourceRef:'Shopify',receivedAt:new Date().toISOString(),note:'Shopify importo likučio sutikrinimas'});
        shopifyCatalogSelected.delete(String(row.inventoryItemId||''));
      });

      const classified=buildApiCatalogClassification(shopifyCatalogSnapshot);
      shopifyCatalogNew=classified.fresh;
      shopifyCatalogIgnored=classified.ignored;
      shopifyCatalogKnownCount=classified.knownCount;
      shopifyCatalogLikelyExisting=classified.likelyExisting||0;
      shopifyCatalogActiveCount=classified.catalogCount||0;
      renderInventory();
      renderMogaShopifyCatalog();
      renderShopifySync();
      window.MOGA_UI?.alert?.(`Importuota į SFAPP: ${additions.length}. Shopify prekės nepakeistos.`,{title:'SHOPIFY → SFAPP'});
    }
  }

  window.importMogaShopifySelected=importMogaShopifySelected;

  async function ignoreMogaShopifySelected(){
    const selected=shopifyCatalogNew.filter(x=>shopifyCatalogSelected.has(String(x.inventoryItemId||'')));
    if(!selected.length)return;
    const ok=window.MOGA_UI?.confirm
      ? await window.MOGA_UI.confirm(`Pažymėti ${selected.length} Shopify prekes / variantus kaip nevaldomus per SFAPP? Juos bet kada galėsi grąžinti į naujų prekių sąrašą.`,{title:'NEVALDYTI PER SFAPP?',confirmText:'NEVALDYTI',cancelText:'ATŠAUKTI'})
      : confirm(`Nevaldyti ${selected.length} Shopify prekių per SFAPP?`);
    if(!ok)return;
    const set=getUnmanagedShopify();
    selected.forEach(x=>set.add(String(x.inventoryItemId||'')));
    saveUnmanagedShopify(set);
    shopifyCatalogSelected.clear();
    const classified=buildApiCatalogClassification(shopifyCatalogSnapshot);
    shopifyCatalogNew=classified.fresh;
    shopifyCatalogIgnored=classified.ignored;
    shopifyCatalogKnownCount=classified.knownCount;
    shopifyCatalogLikelyExisting=classified.likelyExisting||0;
    shopifyCatalogActiveCount=classified.catalogCount||0;
    renderMogaShopifyCatalog();
    renderShopifySync();
  }
  window.ignoreMogaShopifySelected=ignoreMogaShopifySelected;



  function renderShopifyShadow(){
    const summary=document.getElementById('shopifyShadowSummary');
    const list=document.getElementById('shopifyShadowList');
    const btn=document.getElementById('shopifyShadowCheckBtn');
    if(btn){btn.disabled=shopifyShadowRunning;btn.textContent=shopifyShadowRunning?'TIKRINAMA...':'PATIKRINTI PER API — NIEKO NEKEISTI';}
    if(summary){
      if(shopifyShadowRunning)summary.textContent='TIKRINAMA...';
      else if(!shopifyShadowResults.length)summary.textContent='NEPATIKRINTA';
      else{
        const dif=shopifyShadowResults.filter(x=>x.kind==='diff').length;
        const err=shopifyShadowResults.filter(x=>x.kind==='error').length;
        summary.textContent=err?`KLAIDOS ${err}`:(dif?`SKIRTUMAI ${dif}`:'VISKAS SUTAMPA');
      }
    }
    if(!list)return;
    if(!shopifyShadowResults.length){
      list.innerHTML='<div class="moga-shopify-change-empty">Paspausk patikrą. API tik perskaitys Shopify ir nieko nekeis.</div>';
      return;
    }
    const diffs=shopifyShadowResults.filter(x=>x.kind==='diff');
    const syncBtn=document.getElementById('shopifyApiSyncBtn');
    const diffBtn=document.getElementById('shopifyShadowDiffBtn');
    const hint=document.getElementById('shopifyApiSyncHint');
    if(syncBtn){
      syncBtn.style.display=diffs.length?'inline-flex':'none';
      syncBtn.textContent=`SINCHRONIZUOTI PAŽYMĖTUS (${shopifyApiSyncSelected.size})`;
      syncBtn.disabled=shopifyShadowRunning||!shopifyApiSyncSelected.size;
    }
    if(diffBtn){
      diffBtn.style.display=diffs.length?'inline-flex':'none';
      diffBtn.classList.toggle('active',shopifyShadowOnlyDiffs);
      diffBtn.textContent=shopifyShadowOnlyDiffs?'RODYTI VISAS PREKES':`RODYTI TIK SKIRTUMUS (${diffs.length})`;
    }
    if(hint)hint.textContent=diffs.length?`Skirtumai: ${diffs.length}. Pažymėk tik tai, ką nori sulyginti su SFAPP.`:'VISKAS SUTAMPA ✓';
    const visible=shopifyShadowOnlyDiffs?shopifyShadowResults.filter(x=>x.kind==='diff'||x.kind==='error'):shopifyShadowResults;
    list.innerHTML=visible.map(x=>{
      const pick=x.kind==='diff'?`<label class="pick" title="Pažymėti sinchronizavimui"><input type="checkbox" ${shopifyApiSyncSelected.has(x.key)?'checked':''} onchange="toggleMogaShopifyApiSync('${x.key}',this.checked)"><span class="moga-api-check"></span></label>`:'';
      return `<div class="moga-shopify-shadow-row ${x.kind}">${pick}<div><div class="name">${esc(x.name||'—')}</div><div class="meta">${esc(x.meta||'')}</div></div><div class="state">${esc(x.state||'')}</div></div>`;
    }).join('');
  }

  function normShopifyKey(v){return String(v||'').trim().toLowerCase();}

  function snapshotFindRow(snapshotItems,x){
    const handle=normShopifyKey(x.handle);
    const sku=normShopifyKey(x.sku||x.p?.sku);
    const opts=(x.opts||[]).map(cleanOption).map(normShopifyKey).filter(Boolean);

    let rows=snapshotItems.filter(i=>normShopifyKey(i.handle)===handle);

    if(sku){
      const bySku=rows.filter(i=>normShopifyKey(i.sku)===sku);
      if(bySku.length===1)return bySku[0];
      if(bySku.length>1)rows=bySku;
    }

    if(opts.length){
      const byOpts=rows.filter(i=>{
        const got=(i.selectedOptions||[]).map(o=>normShopifyKey(o.value)).filter(Boolean);
        return got.length===opts.length && opts.every((v,n)=>v===got[n]);
      });
      if(byOpts.length===1)return byOpts[0];
      if(byOpts.length>1)rows=byOpts;
    }

    return rows.length===1?rows[0]:null;
  }

  function apiShadowCandidates(){
    const products=productList();
    const direct=[];
    const usedInventoryIds=new Set();

    // Naujas pagrindinis kelias: jei SFAPP prekė jau susieta su Shopify per API,
    // CSV šablono nebereikia. Shopify Inventory Item ID yra stabiliausias ryšys.
    products.forEach(p=>{
      const inventoryItemId=String(p?.shopifyInventoryItemId||'').trim();
      if(!inventoryItemId)return;
      direct.push({
        p,
        inventoryItemId,
        candidate:String(p.name||'').trim()||'—',
        handle:String(p.shopifyHandle||'').trim(),
        sku:String(p.sku||'').trim(),
        opts:[],
        matchType:'Shopify ID'
      });
      usedInventoryIds.add(String(p.inventoryId||''));
    });

    // Suderinamumas su senesniais susiejimais / CSV: pridedame tik tas prekes,
    // kurios neturi tiesioginio Shopify Inventory Item ID.
    const mapped=inventoryMappings().mapped||[];
    mapped.forEach(x=>{
      const sfId=String(x?.p?.inventoryId||'');
      if(sfId&&usedInventoryIds.has(sfId))return;
      direct.push(x);
    });
    return direct;
  }

  async function runMogaShopifyShadowCheck(){
    if(shopifyShadowRunning)return;
    const candidates=apiShadowCandidates();
    if(!candidates.length)return window.MOGA_UI?.alert?.('Nėra su Shopify susietų SFAPP prekių. Importuok / susiek prekes per Shopify integraciją.',{title:'API SHADOW'});

    shopifyShadowRunning=true;
    shopifyShadowResults=[];
    shopifyApiSyncSelected.clear();
    renderShopifyShadow();

    try{
      const shop=mogaShopifyConnectedShop();
      const r=await fetch(`${SHOPIFY_API_BASE}/shopify/multi/inventory/snapshot?shop=${encodeURIComponent(shop)}`,{
        method:'GET',
        credentials:'include',
         headers:mogaShopifyAuthHeaders()
      });
      const data=await r.json().catch(()=>({}));
      if(!r.ok||!data?.ok||!Array.isArray(data.items)){
        throw new Error(data?.message||`HTTP ${r.status}`);
      }

      for(const x of candidates){
        const sfQty=Math.max(0,Math.trunc(number(inventoryQty(x.p))));
        let row=null;
        const directId=String(x.inventoryItemId||x.p?.shopifyInventoryItemId||'').trim();
        if(directId)row=data.items.find(i=>String(i.inventoryItemId||'')===directId)||null;
        if(!row)row=snapshotFindRow(data.items,x);

        if(!row){
          shopifyShadowResults.push({
            kind:'error',
            name:x.candidate||x.p?.name||'—',
            meta:`Handle: ${x.handle||'—'} · SKU: ${x.sku||x.p?.sku||'—'}`,
            state:'NERASTA / NEVIENAREIKŠMĖ'
          });
          continue;
        }

        const shopQty=number(row.onHand);
        const same=shopQty===sfQty;

        const key=String(row.inventoryItemId||'');
        shopifyShadowResults.push({
          key,
          inventoryItemId:row.inventoryItemId,
          shopQty,
          sfQty,
          kind:same?'ok':'diff',
          name:x.candidate||x.p?.name||'—',
          meta:`Handle: ${row.handle||x.handle||'—'} · SKU: ${row.sku||x.sku||x.p?.sku||'—'} · ${x.matchType||'susieta'}`,
          state:same?`OK ${sfQty}`:`Shopify ${shopQty} → SFAPP ${sfQty}`
        });
      }
    }catch(e){
      shopifyShadowResults=[{
        kind:'error',
        name:'API SHADOW',
        meta:'Shopify inventoriaus snapshot nepavyko gauti.',
        state:`KLAIDA: ${e?.message||'nežinoma'}`
      }];
    }

    shopifyShadowRunning=false;
    renderShopifyShadow();
  }


  function toggleMogaShopifyShadowDiffs(){
    shopifyShadowOnlyDiffs=!shopifyShadowOnlyDiffs;
    renderShopifyShadow();
  }
  window.toggleMogaShopifyShadowDiffs=toggleMogaShopifyShadowDiffs;

  function toggleMogaShopifyApiSync(key,checked){
    if(checked)shopifyApiSyncSelected.add(String(key));
    else shopifyApiSyncSelected.delete(String(key));
    renderShopifyShadow();
  }
  window.toggleMogaShopifyApiSync=toggleMogaShopifyApiSync;

  async function syncMogaShopifySelected(){
    const chosen=shopifyShadowResults.filter(x=>x.kind==='diff'&&shopifyApiSyncSelected.has(String(x.key)));
    if(!chosen.length)return;

    const doSync=async()=>{
      const btn=document.getElementById('shopifyApiSyncBtn');
      if(btn){btn.disabled=true;btn.textContent='SINCHRONIZUOJAMA...';}
      try{
        // Chunk 100: Worker intentionally refuses oversized blind writes.
        for(let i=0;i<chosen.length;i+=100){
          const batch=chosen.slice(i,i+100);
          const shop=mogaShopifyConnectedShop();
          const r=await fetch(`${SHOPIFY_API_BASE}/shopify/multi/inventory/sync-selected`,{
            method:'POST',
            credentials:'include',
            headers:mogaShopifyAuthHeaders({'Content-Type':'application/json'}),
            body:JSON.stringify({
              shop,
              changes:batch.map(x=>({
                inventoryItemId:x.inventoryItemId,
                quantity:x.sfQty,
                changeFromQuantity:x.shopQty
              }))
            })
          });
          const data=await r.json().catch(()=>({}));
          if(!r.ok||!data?.ok){
            const detail=(data?.errors||[]).map(e=>e.message).filter(Boolean).join(' | ');
            throw new Error(detail||data?.message||`HTTP ${r.status}`);
          }
        }
        shopifyApiSyncSelected.clear();
        await runMogaShopifyShadowCheck();
        window.MOGA_UI?.alert?.('Pažymėti Shopify likučiai sulyginti su SFAPP.',{title:'SHOPIFY API SYNC'});
      }catch(e){
        window.MOGA_UI?.alert?.(`Sinchronizacija sustabdyta. ${e?.message||'Nežinoma klaida'}\\n\\nJei Shopify likutis pasikeitė po patikros, sistema jo aklai neperrašė. Paleisk PATIKRINTI PER API dar kartą.`,{title:'SHOPIFY KONFLIKTAS'});
        await runMogaShopifyShadowCheck();
      }
    };

    const old=document.getElementById('mogaShopifySyncConfirm');
    if(old)old.remove();
    const overlay=document.createElement('div');
    overlay.id='mogaShopifySyncConfirm';
    overlay.className='moga-shopify-sync-confirm-overlay';

    const productRows=chosen.map(x=>`
      <div class="moga-shopify-sync-confirm-item">
        <span class="dot">•</span>
        <div><b>${esc(x.name||'—')}</b><small>Shopify ${esc(String(x.shopQty))} → SFAPP ${esc(String(x.sfQty))}</small></div>
      </div>`).join('');

    overlay.innerHTML=`
      <div class="moga-shopify-sync-confirm-modal" role="dialog" aria-modal="true">
        <div class="moga-shopify-sync-confirm-head">
          <div><div class="eyebrow">SHOPIFY API SYNC</div><h3>Sinchronizuoti pažymėtas prekes?</h3></div>
          <button type="button" class="close" aria-label="Uždaryti">×</button>
        </div>
        <div class="moga-shopify-sync-confirm-body">
          <div class="moga-shopify-sync-confirm-info">
            Bus pakeisti <b>${chosen.length}</b> Shopify ${chosen.length===1?'prekės likučiai':'prekių likučiai'} pagal SFAPP.
            <span>Jei Shopify likutis po patikros jau pasikeitė, sistema jo aklai neperrašys — sinchronizacija bus sustabdyta.</span>
          </div>
          <div class="moga-shopify-sync-confirm-label">KEIČIAMOS PREKĖS (${chosen.length})</div>
          <div class="moga-shopify-sync-confirm-list">${productRows}</div>
        </div>
        <div class="moga-shopify-sync-confirm-actions">
          <button type="button" class="cancel">ATŠAUKTI</button>
          <button type="button" class="confirm">SINCHRONIZUOTI (${chosen.length})</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    const close=()=>overlay.remove();
    overlay.querySelector('.close').onclick=close;
    overlay.querySelector('.cancel').onclick=close;
    overlay.addEventListener('pointerdown',e=>{if(e.target===overlay)close();});
    overlay.querySelector('.confirm').onclick=()=>{close();doSync();};
  }
  window.syncMogaShopifySelected=syncMogaShopifySelected;

  window.runMogaShopifyShadowCheck=runMogaShopifyShadowCheck;

  function renderShopifySync(){
    if(!document.getElementById('warehouseSheet'))return;
    applyShopifyConnectionUi();
    if(shopifyConnectionState.connected){
      renderMogaShopifyCatalog();
      renderShopifyShadow();
    }
    const inv=inventoryDirty();const tags=productTagDirty();
    const invTpl=inv.tpl,prodTpl=tags.tpl;
    const put=(id,v)=>{const el=document.getElementById(id);if(el)el.textContent=v};
    put('shopifyInvTemplateStatus',invTpl?`${invTpl.rows.length} eil.${invTpl.sourceName?' · '+invTpl.sourceName:''}`:'NEĮKELTAS');
    put('shopifyProductTemplateStatus',prodTpl?`${prodTpl.rows.length} eil.${prodTpl.sourceName?' · '+prodTpl.sourceName:''}`:'NEĮKELTAS');
    put('shopifyMappedStatus',invTpl?`${inv.mapped.length}/${inv.mapped.length+inv.unmatched.length}`:'—');
    put('shopifyInventoryDirty',inv.dirty.length);
    put('shopifyTagsDirty',tags.dirty.length);
    const apiDiffCount=shopifyShadowResults.filter(x=>x.kind==='diff').length;
    put('shopifySyncLaunchCount',inv.dirty.length+tags.dirty.length+shopifyCatalogNew.length+apiDiffCount);
    const select=document.getElementById('shopifySyncLocation');
    if(select){
      const cur=inv.location||getSettings().location||'';
      select.innerHTML=inv.locations.length?inv.locations.map(x=>`<option value="${esc(x)}">${esc(x)}</option>`).join(''):'<option value="">—</option>';
      select.value=cur;
    }
    const summary=document.getElementById('shopifyUnmatchedSummary');if(summary)summary.textContent=`Nevaldomos per SFAPP: ${inv.unmatched.length}`;
    const list=document.getElementById('shopifyUnmatchedList');if(list)list.innerHTML=inv.unmatched.length?inv.unmatched.slice(0,120).map(x=>`<div class="row"><span>${esc(x.candidate||'—')}<br><small>${esc(x.reason||'Nevaldoma')} · SKU: ${esc(x.sku||'—')} · Handle: ${esc(x.handle||'—')}</small></span><div class="row-actions"><button type="button" onclick="openShopifyManualMap(${Number(x.rowIndex)})">SUSIETI</button></div></div>`).join(''):'<div class="row"><span>Visos pasirinktos vietos eilutės susietos.</span></div>';
    const manualMaps=getManualMaps();const manualEntries=Object.entries(manualMaps);
    const manualSummary=document.getElementById('shopifyManualMapSummary');if(manualSummary)manualSummary.textContent=`Rankiniai susiejimai: ${manualEntries.length}`;
    const manualList=document.getElementById('shopifyManualMapList');if(manualList){
      const products=productList();
      manualList.innerHTML=manualEntries.length?manualEntries.map(([shopId,v])=>{const id=typeof v==='string'?v:String(v?.inventoryId||'');const p=products.find(z=>String(z.inventoryId||'')===id);const shName=typeof v==='object'?(v.shopifyName||v.handle||shopId):shopId;return `<div class="row"><span><b>${esc(shName||'—')}</b><br><small>→ SFAPP: ${esc(p?.name||'NERASTA PREKĖ')} · SKU: ${esc(p?.sku||'—')}</small></span><div class="row-actions"><button type="button" onclick="removeShopifyManualMap('${esc(encodeURIComponent(shopId))}')">ATSAIETI</button></div></div>`;}).join(''):'<div class="row"><span>Rankinių susiejimų dar nėra.</span></div>';
    }

    // Išvalome išimtis pakeitimams, kurių jau nebėra.
    const liveInvKeys=new Set(inv.dirty.map(x=>x.key));[...inventoryExcluded].forEach(k=>{if(!liveInvKeys.has(k))inventoryExcluded.delete(k)});
    const liveTagHandles=new Set(tags.dirty.map(x=>x.group.handle));[...tagExcluded].forEach(k=>{if(!liveTagHandles.has(k))tagExcluded.delete(k)});
    const invSelected=selectedInventoryDirty(inv),tagSelected=selectedTagDirty(tags);

    const invSummary=document.getElementById('shopifyInventoryChangeSummary');if(invSummary)invSummary.textContent=`${invSelected.length} / ${inv.dirty.length} pažymėta`;
    const invList=document.getElementById('shopifyInventoryChangeList');if(invList)invList.innerHTML=inv.dirty.length?inv.dirty.map(x=>{
      const oldQty=number(inv.baseline[x.key]),newQty=number(inventoryQty(x.p)),on=!inventoryExcluded.has(x.key);
      const sfSku=String(x.p?.sku||'').trim()||'—';const shSku=String(x.sku||'').trim()||'—';const shHandle=String(x.handle||x.row?.[inv.idx?.handle]||'').trim()||'—';
      return `<label class="moga-shopify-change-row ${on?'':'off'}"><input type="checkbox" ${on?'checked':''} onchange="toggleShopifyInventoryChange('${esc(x.key)}',this.checked)"><div><div class="name">${esc(x.candidate||x.p?.name||'—')}</div><div class="meta">Shopify: ${oldQty.toLocaleString('lt-LT')} · SFAPP: ${newQty.toLocaleString('lt-LT')}<br>SKU: SFAPP ${esc(sfSku)} · Shopify ${esc(shSku)}<br>Handle: ${esc(shHandle)}${x.matchType==='Rankinis'?' · RANKINIS SUSIEJIMAS':''}</div></div><div class="delta"><span class="from">${oldQty.toLocaleString('lt-LT')}</span><span class="arrow">→</span><span class="to">${newQty.toLocaleString('lt-LT')}</span></div></label>`;
    }).join(''):'<div class="moga-shopify-change-empty">Likučių pakeitimų nėra.</div>';
    const invAll=document.getElementById('shopifyInventoryAllCheck');if(invAll){invAll.checked=inv.dirty.length>0&&invSelected.length===inv.dirty.length;invAll.indeterminate=invSelected.length>0&&invSelected.length<inv.dirty.length;}
    const syncedBtn=document.getElementById('shopifyInventorySyncedBtn');if(syncedBtn){syncedBtn.disabled=!invSelected.length;syncedBtn.textContent=`JAU SINCHRONIZUOTA (${invSelected.length})`;}

    const tagSummary=document.getElementById('shopifyTagChangeSummary');if(tagSummary)tagSummary.textContent=`${tagSelected.length} / ${tags.dirty.length} pažymėta`;
    const tagList=document.getElementById('shopifyTagChangeList');if(tagList)tagList.innerHTML=tags.dirty.length?tags.dirty.map(x=>{
      const on=!tagExcluded.has(x.group.handle);
      const oldManaged=splitTags(x.oldTags).filter(t=>MANAGED_TAGS.has(t.toLowerCase())).join(', ')||'—';
      const nextManaged=splitTags(x.nextTags).filter(t=>MANAGED_TAGS.has(t.toLowerCase())).join(', ')||'—';
      return `<label class="moga-shopify-change-row moga-shopify-tag-row ${on?'':'off'}"><input type="checkbox" ${on?'checked':''} onchange="toggleShopifyTagChange('${esc(x.group.handle)}',this.checked)"><div><div class="name">${esc(x.group.title||x.group.handle||'—')}</div><div class="meta">Valdomi Shopify tagai</div></div><div class="delta"><span class="from">${esc(oldManaged)}</span><span class="arrow">→</span><span class="to">${esc(nextManaged)}</span></div></label>`;
    }).join(''):'<div class="moga-shopify-change-empty">Tagų pakeitimų nėra.</div>';
    const tagAll=document.getElementById('shopifyTagAllCheck');if(tagAll){tagAll.checked=tags.dirty.length>0&&tagSelected.length===tags.dirty.length;tagAll.indeterminate=tagSelected.length>0&&tagSelected.length<tags.dirty.length;}

    const bi=document.getElementById('shopifyExportInventoryBtn');if(bi){bi.disabled=!invTpl||!invSelected.length;bi.textContent=`EKSPORTUOTI INVENTORIAUS PAKEITIMUS (${invSelected.length})`;}
    const bt=document.getElementById('shopifyExportTagsBtn');if(bt){bt.disabled=!prodTpl||!invTpl||!tagSelected.length;bt.textContent=`EKSPORTUOTI TAGŲ PAKEITIMUS (${tagSelected.length})`;}
    const ba=document.getElementById('shopifyExportAllBtn');if(ba){ba.disabled=!invTpl||!prodTpl||(!invSelected.length&&!tagSelected.length);ba.textContent=`PARUOŠTI ABU SHOPIFY FAILUS (${invSelected.length+tagSelected.length})`;}
  }
  window.renderMogaShopifySync=renderShopifySync;

  function openShopifySync(){
    ensureShopifySyncUi();renderShopifySync();
    const m=document.getElementById('mogaShopifySyncModal');m?.classList.add('open');m?.setAttribute('aria-hidden','false');
    refreshMogaShopifyConnectionState({quiet:true}).then(async ok=>{
      renderShopifySync();
      // Atidarius SHOPIFY SYNC iš karto palyginame gyvą Shopify likutį su SFAPP.
      // Taip PO priėmimai / SF nurašymai matomi be papildomo CSV importo.
      if(ok||shopifyConnectionState.connected)await runMogaShopifyShadowCheck();
      renderShopifySync();
    });
  }
  function closeShopifySync(){const m=document.getElementById('mogaShopifySyncModal');m?.classList.remove('open');m?.setAttribute('aria-hidden','true')}
  window.openShopifySync=openShopifySync;window.closeShopifySync=closeShopifySync;

  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&document.getElementById('mogaShopifySyncModal')?.classList.contains('open'))closeShopifySync()});
  window.addEventListener('moga:data-ready',()=>setTimeout(()=>{ensureShopifySyncUi();renderShopifySync()},50));
  window.addEventListener('moga:supplier-links-change',()=>setTimeout(renderShopifySync,50));
  let shopifyInventoryChangeTimer=null;
  window.addEventListener('moga:inventory-changed',()=>{
    // LIVE UI: po SF/gamybos/pirkimų/inventorizacijos iškart perskaitome naują sandėlio būseną.
    try{ renderInventory(); }catch(_){ }
    try{ if(typeof renderInventoryHistory==='function') renderInventoryHistory(); }catch(_){ }
    // Ankstesnė SHADOW išvada po bet kokio sandėlio pokyčio tampa pasenusi.
    shopifyShadowResults=[];
    shopifyApiSyncSelected.clear();
    renderShopifySync();
    if(!document.getElementById('mogaShopifySyncModal')?.classList.contains('open')||!shopifyConnectionState.connected)return;
    clearTimeout(shopifyInventoryChangeTimer);
    shopifyInventoryChangeTimer=setTimeout(()=>runMogaShopifyShadowCheck(),250);
  });
  // Sandėlio kiekiai gali pasikeisti per SF registravimą / koregavimą — atnaujiname skaitiklius.
  document.addEventListener('click',()=>{if(document.getElementById('mogaShopifySyncModal')?.classList.contains('open'))setTimeout(renderShopifySync,80)},true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setTimeout(ensureShopifySyncUi,250),{once:true});
  else setTimeout(ensureShopifySyncUi,250);
  setTimeout(ensureShopifySyncUi,900);

  window.MOGA_SHOPIFY_SYNC={
    render:renderShopifySync,open:openShopifySync,
    inventoryDirty:()=>inventoryDirty().dirty.length,
    tagDirty:()=>productTagDirty().dirty.length
  };
})();


/* MOGA SF – compact grouped perfume inventory count */
(function(){
  if(document.getElementById('mogaPerfumeCountGroupedStyle'))return;
  const st=document.createElement('style');
  st.id='mogaPerfumeCountGroupedStyle';
  st.textContent=`
    #inventoryCountBody .inventory-count-group-row td{vertical-align:middle}
    #inventoryCountBody .inventory-count-group-row>td:first-child{min-width:230px}
    #inventoryCountBody .inventory-count-size{width:180px;min-width:150px;text-align:center;padding:8px 12px}
    #inventoryCountBody .inventory-count-size.missing{opacity:.35;font-weight:800}
    #inventoryCountBody .inventory-count-current{font-size:11px;color:#777;margin-bottom:5px;white-space:nowrap}
    #inventoryCountBody .inventory-count-current b{color:#111;font-size:12px}
    #inventoryCountBody .inventory-count-compact{width:92px!important;min-width:0!important;height:34px!important;padding:5px 8px!important;text-align:center;margin:0 auto;display:block}
    #inventoryCountBody .inventory-count-diff{min-height:14px;margin-top:3px;font-size:10px;font-weight:900;line-height:1}
    #inventoryCountBody .inventory-count-diff.plus{color:#079447}
    #inventoryCountBody .inventory-count-diff.minus{color:#d92d20}
    .inventory-count-grouped-head th:not(:first-child){text-align:center}
    @media(max-width:900px){
      #inventoryCountBody .inventory-count-size{min-width:125px;padding:7px 6px}
      #inventoryCountBody .inventory-count-group-row>td:first-child{min-width:180px}
    }
  `;
  document.head.appendChild(st);
})();


/* === MOGA Shopify product mini photos + zoom preview === */
(function(){
  if(window.MOGA_SHOPIFY_IMG)return;
  const h=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function thumb(url,alt='',size=42){
    url=String(url||'').trim();
    if(!url)return '';
    return `<button type="button" class="moga-shop-thumb-btn" data-moga-shop-img="${h(url)}" data-moga-shop-alt="${h(alt)}" title="Padidinti nuotrauką" style="width:${size}px;height:${size}px"><img src="${h(url)}" alt="${h(alt)}" loading="lazy"></button>`;
  }
  function open(url,alt=''){
    if(!url)return;
    let ov=document.getElementById('mogaShopImagePreview');
    if(!ov){
      ov=document.createElement('div');
      ov.id='mogaShopImagePreview';
      ov.className='moga-shop-image-preview';
      ov.innerHTML=`<div class="moga-shop-image-preview-card"><button type="button" class="moga-shop-image-preview-close" aria-label="Uždaryti">×</button><img class="moga-shop-image-preview-img" alt=""><div class="moga-shop-image-preview-caption"></div></div>`;
      document.body.appendChild(ov);
      const close=()=>ov.classList.remove('is-open');
      ov.addEventListener('click',e=>{if(e.target===ov||e.target.closest('.moga-shop-image-preview-close'))close()});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'&&ov.classList.contains('is-open'))close()});
    }
    const img=ov.querySelector('.moga-shop-image-preview-img');
    img.src=url; img.alt=alt||'Prekės nuotrauka';
    ov.querySelector('.moga-shop-image-preview-caption').textContent=alt||'';
    ov.classList.add('is-open');
  }
  window.MOGA_SHOPIFY_IMG={thumb,open};
  if(!window.__mogaShopImgClick){
    window.__mogaShopImgClick=true;
    document.addEventListener('click',e=>{
      const b=e.target.closest?.('[data-moga-shop-img]');
      if(!b)return;
      e.preventDefault(); e.stopPropagation();
      open(b.dataset.mogaShopImg||'',b.dataset.mogaShopAlt||'');
    },true);
  }
  const style=document.createElement('style');
  style.id='mogaShopImageStyles';
  style.textContent=`
    .moga-shop-thumb-btn{flex:0 0 auto;padding:0;border:1px solid rgba(255,255,255,.16);border-radius:9px;overflow:hidden;background:#111;display:inline-flex;align-items:center;justify-content:center;cursor:zoom-in;box-shadow:0 2px 10px rgba(0,0,0,.18);transition:.16s ease}
    .moga-shop-thumb-btn:hover{transform:scale(1.06);border-color:#ff7a18}
    .moga-shop-thumb-btn img{width:100%;height:100%;object-fit:cover;display:block}
    .moga-shop-catalog-product,.moga-shop-link-source,.moga-inv-product-with-img{display:flex;align-items:center;gap:10px;min-width:0}
    .moga-shop-catalog-product>div,.moga-shop-link-source>div,.moga-inv-product-with-img>div{min-width:0}
    .moga-shop-link-choice{width:100%;display:flex;align-items:center;gap:10px;text-align:left;padding:8px 10px;border:0;border-bottom:1px solid #292929;background:#121212;color:#fff;cursor:pointer}
    .moga-shop-link-choice:hover{background:#181818}
    .moga-shop-link-choice-text{display:block;min-width:0}
    .moga-shop-link-possible{display:flex;align-items:center;gap:7px;margin-top:6px;flex-wrap:wrap}
    .moga-shop-link-possible>small{font-size:8px;color:#ff9a22;font-weight:800;letter-spacing:.04em}
    .moga-shop-link-possible>span{display:flex;gap:5px;flex-wrap:wrap}
    .moga-shop-link-possible .moga-shop-thumb-btn{border-radius:7px}
    .moga-shop-image-preview{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.84);backdrop-filter:blur(5px);display:none;align-items:center;justify-content:center;padding:24px}
    .moga-shop-image-preview.is-open{display:flex}
    .moga-shop-image-preview-card{position:relative;max-width:min(920px,94vw);max-height:92vh;background:#111;border:1px solid #383838;border-radius:18px;padding:14px;box-shadow:0 28px 90px rgba(0,0,0,.7)}
    .moga-shop-image-preview-img{display:block;max-width:88vw;max-height:78vh;object-fit:contain;border-radius:12px;background:#090909}
    .moga-shop-image-preview-close{position:absolute;right:8px;top:8px;z-index:2;width:36px;height:36px;border-radius:50%;border:1px solid #555;background:rgba(12,12,12,.92);color:#fff;font-size:26px;line-height:30px;cursor:pointer}
    .moga-shop-image-preview-caption{color:#aaa;font-size:12px;margin:9px 4px 0;max-width:760px}
  `;
  document.head.appendChild(style);
})();


;(function(){const s=document.createElement('style');s.id='mogaShopImportRenameStyles';s.textContent='\n.moga-shopify-import-rename-modal{width:min(720px,94vw)!important}\n.moga-shop-import-note{font-size:11px;line-height:1.5;color:#aaa;margin:0 0 12px}\n.moga-shop-import-edit-list{max-height:54vh;overflow:auto;border:1px solid #292929;border-radius:12px}\n.moga-shop-import-edit-row{padding:12px;border-bottom:1px solid #292929;background:#111}\n.moga-shop-import-edit-row:last-child{border-bottom:0}\n.moga-shop-import-source{display:flex;align-items:center;gap:10px;margin-bottom:10px}\n.moga-shop-import-source>div{min-width:0}.moga-shop-import-source b{display:block;color:#fff;font-size:11px}\n.moga-shop-import-source small{display:block;color:#888;font-size:9px;margin-top:3px}\n.moga-shop-import-edit-row label{display:block;color:#888;font-size:8px;font-weight:800;margin-top:7px}\n.moga-shop-import-edit-row label em{font-style:normal;color:#ff8a19;margin-left:6px}\n.moga-shop-import-edit-row input{box-sizing:border-box;width:100%;margin-top:4px;padding:9px 10px;border:1px solid #444;border-radius:9px;background:#fff;color:#111;font-size:11px}\n.moga-shop-import-edit-row label:has(em) input{border-color:#ff8a19;box-shadow:0 0 0 1px rgba(255,138,25,.25)}\n.moga-shop-import-actions{display:flex;justify-content:flex-end;gap:8px;margin-top:12px}\n.moga-shop-import-actions button{border:1px solid #444;border-radius:10px;padding:10px 14px;font-size:9px;font-weight:900;cursor:pointer}\n.moga-shop-import-actions .cancel{background:#191919;color:#ddd}\n.moga-shop-import-actions .save{border:0;background:linear-gradient(90deg,#ff8a00,#ff3f8e);color:#fff}\n';document.head.appendChild(s)})();


;(function(){
  if(document.getElementById('mogaShopifyImportActionStyle'))return;
  const s=document.createElement('style');
  s.id='mogaShopifyImportActionStyle';
  s.textContent=`
    #shopifyCatalogImportBtn.moga-shopify-import-action{
      min-height:36px;padding:0 13px;border-radius:9px;
      display:inline-flex;align-items:center;justify-content:center;
      background:linear-gradient(135deg,#ff8a00,#ff4b93);color:#fff;
      font-size:9px;font-weight:1000;cursor:pointer;user-select:none;
      border:0;box-sizing:border-box
    }
    #shopifyCatalogImportBtn.moga-shopify-import-action:hover:not(.is-disabled){filter:brightness(1.06)}
    #shopifyCatalogImportBtn.moga-shopify-import-action.is-disabled{opacity:.4;cursor:pointer}
  `;
  document.head.appendChild(s);
})();


;(function(){
  if(document.getElementById('mogaShopifyRowImportStyle'))return;
  const s=document.createElement('style');
  s.id='mogaShopifyRowImportStyle';
  s.textContent=`
    .moga-shop-row-actions{display:flex;gap:6px;justify-content:flex-end;flex-wrap:wrap;margin-top:5px}
    .moga-shopify-catalog-row .state .import-new{border-color:#7a4d20!important;color:#ffc36d!important}
    .moga-shopify-catalog-row .state .import-new:hover{border-color:#ff8a00!important;background:#2b2117!important}
    #shopifyCatalogImportBtn.is-disabled{opacity:.4}
  `;
  document.head.appendChild(s);
})();

;(function(){
  if(document.getElementById('mogaShopImportVisibleFix'))return;
  const s=document.createElement('style');
  s.id='mogaShopImportVisibleFix';
  s.textContent=`
    .moga-shopify-import-rename-modal{width:min(720px,94vw)!important;max-height:90vh!important;overflow:hidden!important}
    .moga-shopify-import-rename-modal .moga-shopify-sync-confirm-body{max-height:calc(90vh - 78px);overflow:auto}
  `;
  document.head.appendChild(s);
})();


;(function(){
  if(document.getElementById('mogaShopifyImportTopPolish'))return;
  const s=document.createElement('style');
  s.id='mogaShopifyImportTopPolish';
  s.textContent=`
    #shopifyCatalogImportBtn{
      min-height:36px!important;
      padding:0 14px!important;
      display:inline-flex;
      align-items:center!important;
      justify-content:center!important;
      border:0!important;
      border-radius:9px!important;
      background:linear-gradient(90deg,#ff8a00,#ff3f8e)!important;
      color:#fff!important;
      font-size:9px!important;
      font-weight:900!important;
      line-height:1!important;
      cursor:pointer!important;
    }
    #shopifyCatalogImportBtn:disabled{opacity:.42!important;cursor:not-allowed!important}
  `;
  document.head.appendChild(s);
})();





/* =========================================================
   2026-09-13 UI FIX — PREKIŲ INFORMACIJA / KATEGORIJOS
   ========================================================= */
;(function(){
  const id='moga-inventory-category-ui-fix-20260913';
  if(document.getElementById(id))return;
  const st=document.createElement('style');
  st.id=id;
  st.textContent=`
    /* Kategorijų dropdown visada VIRŠ lentelės / sticky headerio */
    #warehouseSheet .product-info-toolbar,
    #warehouseSheet .product-info-category-action{
      position:relative!important;
      z-index:5000!important;
      overflow:visible!important;
    }
    #warehouseSheet .product-info-category-picker{
      position:relative!important;
      z-index:5001!important;
      overflow:visible!important;
    }
    #warehouseSheet #productInfoCategoryMenu.product-info-category-menu{
      z-index:2147480000!important;
      overflow-x:hidden!important;
      overflow-y:auto!important;
      isolation:isolate!important;
    }
    #warehouseSheet .product-info-table-wrap{
      position:relative!important;
      z-index:1!important;
    }
    #warehouseSheet .product-info-table thead{
      z-index:2!important;
    }

    /* Kategorijų valdymo modalas — aiškios spalvos DARK/LUXURY temose */
    body .moga-category-modal-window{
      background:#151515!important;
      color:#fff!important;
      border-color:#4a3526!important;
    }
    body .moga-category-add{
      background:#1d1915!important;
      border-bottom-color:#3a3129!important;
    }
    body .moga-category-list{
      background:linear-gradient(180deg,#171717 0%,#281715 100%)!important;
      color:#fff!important;
    }
    body .moga-category-row{
      border-bottom-color:rgba(255,255,255,.16)!important;
    }
    body .moga-category-main span{
      color:#bdbdbd!important;
    }
    body .moga-category-add input,
    body .moga-category-main input{
      background:#181818!important;
      color:#fff!important;
      -webkit-text-fill-color:#fff!important;
      caret-color:#fff!important;
      border-color:#4b4b4b!important;
      opacity:1!important;
    }
    body .moga-category-add input::placeholder,
    body .moga-category-main input::placeholder{
      color:#929292!important;
      -webkit-text-fill-color:#929292!important;
      opacity:1!important;
    }
    body .moga-category-add input:focus,
    body .moga-category-main input:focus{
      background:#fff!important;
      color:#111!important;
      -webkit-text-fill-color:#111!important;
      caret-color:#111!important;
      border-color:#ff8a00!important;
      box-shadow:0 0 0 2px rgba(255,138,0,.25)!important;
      outline:none!important;
    }
    body .moga-category-add input:focus::placeholder,
    body .moga-category-main input:focus::placeholder{
      color:#777!important;
      -webkit-text-fill-color:#777!important;
    }
  `;
  document.head.appendChild(st);
})();

/* =========================================================
   2026-09-13 UI FIX 2 — CATEGORY DROPDOWN PORTAL + FOCUS COLORS
   ========================================================= */
;(function(){
  const id='moga-inventory-category-ui-fix2-20260913';
  if(document.getElementById(id))return;
  const st=document.createElement('style');
  st.id=id;
  st.textContent=`
    /* Dropdown dabar yra BODY viduje, todėl jam reikia globalių stilių. */
    body > #productInfoCategoryMenu.product-info-category-menu{
      display:none!important;
      max-height:240px!important;
      overflow-x:hidden!important;
      overflow-y:auto!important;
      box-sizing:border-box!important;
      background:#1c1c22!important;
      color:#fff!important;
      border:1px solid #393943!important;
      border-radius:10px!important;
      box-shadow:0 18px 42px rgba(0,0,0,.42)!important;
      z-index:2147483646!important;
    }
    body > #productInfoCategoryMenu.product-info-category-menu.open{display:block!important}
    body > #productInfoCategoryMenu.product-info-category-menu button{
      display:block!important;
      width:100%!important;
      min-height:38px!important;
      height:auto!important;
      padding:9px 12px!important;
      margin:0!important;
      border:0!important;
      border-radius:0!important;
      background:#1c1c22!important;
      color:#fff!important;
      -webkit-text-fill-color:#fff!important;
      text-align:left!important;
      font-size:12px!important;
      font-weight:700!important;
      cursor:pointer!important;
    }
    body > #productInfoCategoryMenu.product-info-category-menu button:hover{background:#34343e!important}
    body > #productInfoCategoryMenu .product-info-category-empty{padding:11px 12px!important;color:#aaa!important}

    /* KATEGORIJOS modalas: aktyvus input visada baltas + juodas tekstas. */
    body #productCategoryModal.moga-category-modal.open .moga-category-add input:focus,
    body #productCategoryModal.moga-category-modal.open .moga-category-main input:focus,
    body.theme-dark #productCategoryModal.moga-category-modal.open .moga-category-add input:focus,
    body.theme-dark #productCategoryModal.moga-category-modal.open .moga-category-main input:focus,
    body.theme-luxury #productCategoryModal.moga-category-modal.open .moga-category-add input:focus,
    body.theme-luxury #productCategoryModal.moga-category-modal.open .moga-category-main input:focus{
      background:#fff!important;
      color:#111!important;
      -webkit-text-fill-color:#111!important;
      caret-color:#111!important;
      border-color:#ff8a00!important;
      box-shadow:0 0 0 2px rgba(255,138,0,.25)!important;
      outline:none!important;
    }
    body #productCategoryModal.moga-category-modal.open input:focus::selection{
      background:#2f74ff!important;
      color:#fff!important;
    }
  `;
  document.head.appendChild(st);
})();

